/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum AccessType {
  SealedSubmittedConventionally = "SealedSubmittedConventionally",
  Public = "Public",
  SealedElectronic = "SealedElectronic",
  InCameraElectronic = "InCameraElectronic",
  SubmittedConventionally = "SubmittedConventionally",
  SecurePublic = "SecurePublic",
  NotApplicable = "NotApplicable",
  Suppressed = "Suppressed",
  PrivateUpload = "PrivateUpload",
  Delete = "Delete",
  None = "None",
}

export enum CaseCategory {
  Civil = "Civil",
  Criminal = "Criminal",
  Appellate = "Appellate",
  CivilLimited = "CivilLimited",
  SmallClaims = "SmallClaims",
}

export enum RepresentationStatus {
  Active = "Active",
  Withdrawn = "Withdrawn",
  Dismissed = "Dismissed",
  Pending = "Pending",
}

export enum ConnexPersonType {
  Party = "Party",
  Attorney = "Attorney",
  Judge = "Judge",
  Form50 = "Form50",
}

export enum CaseSecurity {
  None = "None",
  Public = "Public",
  Suppressed = "Suppressed",
  Sealed = "Sealed",
  ClosedInactive = "ClosedInactive",
  Hidden = "Hidden",
}

export enum TrialBinderFolderType {
  Case = "Case",
  Folder = "Folder",
  Archive = "Archive",
}

export enum OSContactType {
  Other = "Other",
  LawFirm = "LawFirm",
  PublicAccess = "PublicAccess",
  SelfRepresentedOrganization = "SelfRepresentedOrganization",
  SelfRepresentedIndividual = "SelfRepresentedIndividual",
  Form50Agent = "Form50Agent",
}

export enum UserType {
  Attorney = "Attorney",
  Clerk = "Clerk",
  CourtManager = "CourtManager",
  CustomerService = "CustomerService",
  BasicUser = "BasicUser",
  FirmClerkStaffMember = "FirmClerkStaffMember",
  FirmManager = "FirmManager",
  IT = "IT",
  Judge = "Judge",
  Management = "Management",
  NonSubscribingUser = "NonSubscribingUser",
  PublicAccessUser = "PublicAccessUser",
  SystemAdmin = "SystemAdmin",
  ThirdPartyFiler = "ThirdPartyFiler",
  SelfRepresented = "SelfRepresented",
  NonSubscribingJudge = "NonSubscribingJudge",
  Form50Agent = "Form50Agent",
}

export enum OrganizationType {
  LawFirm = "LawFirm",
  PublicAccess = "PublicAccess",
  SelfRepresentedOrganization = "SelfRepresentedOrganization",
  SelfRepresentedIndividual = "SelfRepresentedIndividual",
  Form50Agent = "Form50Agent",
}

export enum ThreadUsersFilter {
  All = "All",
  HideTopicsParticipatedIn = "HideTopicsParticipatedIn",
  HideTopicsNotParticipatedIn = "HideTopicsNotParticipatedIn",
  HideTopicsByAnonymousUsers = "HideTopicsByAnonymousUsers",
  HideTopicsByNonAnonymousUsers = "HideTopicsByNonAnonymousUsers",
}

/**
 * The scope of the Sent Items list: the current user's own filings, or the
 * whole organization's filings. Mirrors the legacy Sent Items "My Filings /
 * Firm Filings" toggle (FilingOutboxUser* vs FilingOutboxOrg* procedures).
 */
export enum SentScope {
  Mine = "Mine",
  Firm = "Firm",
}

/** Which corner of the page the judge's banner overlay is anchored to. */
export enum OverlayAlignment {
  TopRight = "TopRight",
  TopLeft = "TopLeft",
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
}

/** Which side of a DocumentLinking row the reviewed document is on. */
export enum JudgeReviewLinkDirection {
  LinksTo = "LinksTo",
  LinkedFrom = "LinkedFrom",
}

/**
 * How a document in a submitted JudgeReviewAction was disposed of. Resolved by the
 * server at submit time; never chosen by the client.
 */
export enum JudgeReviewActionDocumentOutcome {
  InFiling = "InFiling",
  RecordOnly = "RecordOnly",
}

/** Controls how the judge review filing is distributed after submission. */
export enum JudgeReviewFilingMode {
  FileAndServe = "FileAndServe",
  FileOnly = "FileOnly",
  FileToCourt = "FileToCourt",
  CustomServiceList = "CustomServiceList",
}

/** Controls which page(s) the watermark overlay is applied to. */
export enum WatermarkPosition {
  FirstPageOnly = "FirstPageOnly",
  LastPageOnly = "LastPageOnly",
  AllPages = "AllPages",
  None = "None",
}

/** The type of judge signature to apply in the scribble stamp. */
export enum SignatureType {
  Slash = "Slash",
  Graphic = "Graphic",
}

/** The action the judge wishes to take on a document during judge review. */
export enum JudgeDocumentOption {
  KeepOriginal = "KeepOriginal",
  Replace = "Replace",
  Attach = "Attach",
}

/** Per-document review state of a reviewed filing's document, derived from the database on every read. */
export enum JudgeReviewDocumentStatus {
  Pending = "Pending",
  InCurrentAction = "InCurrentAction",
  Submitted = "Submitted",
}

/**
 * Judge-review-specific status for a filing in the judge's queue.
 * Surfaces the lock state so the UI can render status filter options (All / Pending / In Progress)
 * and a lock icon on in-progress rows.
 */
export enum JudgeReviewStatus {
  Pending = "Pending",
  InProgress = "InProgress",
}

/** The "Search By" filter applied to a Multi-Case search */
export enum MultiCaseSearchBy {
  None = "None",
  IndividualParty = "IndividualParty",
  BusinessParty = "BusinessParty",
  AttorneyName = "AttorneyName",
  FirmName = "FirmName",
  JudgeName = "JudgeName",
  CaseType = "CaseType",
}

export enum AllowCourtFeeWaiver {
  NotAllowed = "NotAllowed",
  WaiverCourtFeesOnly = "WaiverCourtFeesOnly",
  WaiveAllFees = "WaiveAllFees",
}

/**
 * Which field(s) the client searches for a court. Serialized as a string via the API's global
 * JsonStringEnumConverter. Values mirror the byte column exposed by
 * FileAndServe.Xpress.Jcms.Data.Enums.CaseSearchField.
 */
export enum CaseSearchFieldMode {
  CaseNumber = "CaseNumber",
  CaseDescription = "CaseDescription",
  Both = "Both",
}

/**
 * How the client drives case search for a court: Partial = type-ahead autocomplete,
 * Full = textbox + Search button (exact). Serialized as a string via the API's global
 * JsonStringEnumConverter (like FilingMode and the other contract enums), so the generated
 * client types get a real enum. Values mirror the byte column exposed by
 * FileAndServe.Xpress.Jcms.Data.Enums.CaseSearchMatch.
 */
export enum CaseSearchMatchMode {
  Partial = "Partial",
  Full = "Full",
}

/**
 * Outcomes of a fee-quote request as surfaced to the Angular client.
 * Mirrors ConnexV3.SharedObjects.FeeQuoteStatus and adds the two
 * failure states Modern detects itself (Error, Timeout).
 */
export enum FeeQuoteStatus {
  NotSupported = "NotSupported",
  Priced = "Priced",
  Invalid = "Invalid",
  Error = "Error",
  Timeout = "Timeout",
}

export enum PreAuthStatus {
  Authorized = "Authorized",
  Failed = "Failed",
}

export enum FilingMode {
  SubF = "SubF",
  Opf = "Opf",
  AddCase = "AddCase",
  PaperFiling = "PaperFiling",
}

/**
 * Describes how a filing will be submitted.
 *
 */
export enum FileToCourt {
  FileAndServe = "FileAndServe",
  FileOnly = "FileOnly",
  ServeOnlyPrivate = "ServeOnlyPrivate",
  ServeOnlyPublic = "ServeOnlyPublic",
  DocumentUpload = "DocumentUpload",
}

/**
 * The read-state filter for mailbox lists (Inbox / Sent Items).
 * Values mirror the legacy UserFiling.ViewStatusId values
 * (Unread = 0, Read = 1); Removed (2) is applied through the dedicated
 * remove endpoints rather than exposed as a query filter.
 */
export enum MailboxReadStatus {
  Unread = "Unread",
  Read = "Read",
  All = "All",
}

/**
 * The read-state filter for rejected filings.
 * (Values mirror the legacy FilingListReadState / UserDocRejectedViewStatus.ViewStatus values.)
 */
export enum RejectedFilingReadStatus {
  Unread = "Unread",
  Read = "Read",
  All = "All",
}

export enum ErrorCodeMetaDataType {
  FilingId = "FilingId",
  CaseId = "CaseId",
  CaseName = "CaseName",
  PartyId = "PartyId",
  DocumentId = "DocumentId",
  CourtId = "CourtId",
  DivisionId = "DivisionId",
  AddressTypeId = "AddressTypeId",
  FilingTypeId = "FilingTypeId",
  DocumentFormat = "DocumentFormat",
  DocumentTypeId = "DocumentTypeId",
  DocStoreErrorMessage = "DocStoreErrorMessage",
  FormBuilderErrorMessage = "FormBuilderErrorMessage",
  LinkedDocumentId = "LinkedDocumentId",
  ExistingPartyId = "ExistingPartyId",
  ExistingCaseId = "ExistingCaseId",
  AliasId = "AliasId",
  AdditionalRecipientId = "AdditionalRecipientId",
  AttorneyId = "AttorneyId",
  AttorneyTypeId = "AttorneyTypeId",
  PartyTypeId = "PartyTypeId",
  CounselTypeId = "CounselTypeId",
  PartySubTypeId = "PartySubTypeId",
  CourtesyCopyUserId = "CourtesyCopyUserId",
  FilingType = "FilingType",
  ConnexV3ErrorMessage = "ConnexV3ErrorMessage",
  JudgeId = "JudgeId",
  FeeTypeId = "FeeTypeId",
  GenericIntId = "GenericIntId",
  GenericGuidId = "GenericGuidId",
  GenericDomainString = "GenericDomainString",
}

export enum FilingOptionId {
  FileAndServe = "FileAndServe",
  File = "File",
  PrivateServe = "PrivateServe",
  PublicServe = "PublicServe",
  DocumentUpload = "DocumentUpload",
}

export enum FilingDraftAdditionalDataSelectionMode {
  Single = "Single",
  Multiple = "Multiple",
}

export enum FilingDraftAdditionalDataFieldType {
  String = "String",
  Decimal = "Decimal",
  Integer = "Integer",
  Date = "Date",
  Bool = "Bool",
  CodeRef = "CodeRef",
}

export enum FilingDraftAdditionalDataConditionOp {
  Equals = "Equals",
  NotEquals = "NotEquals",
  In = "In",
  NotEmpty = "NotEmpty",
  All = "All",
  Any = "Any",
  Not = "Not",
}

export enum FilingDraftAdditionalDataFormScope {
  Case = "Case",
  Document = "Document",
}

/** Which side of a filing a participant collection draws from. */
export enum FilingDraftAdditionalDataPartyScope {
  Sending = "Sending",
  Other = "Other",
}

export enum FilingDraftAdditionalDataOptionSourceKind {
  CollectionRef = "CollectionRef",
  Inline = "Inline",
}

export enum FilingDraftAdditionalDataNodeKind {
  FormRegistry = "FormRegistry",
  Form = "Form",
  Field = "Field",
}

export enum FilingTypeFilingOption {
  MainAttachForSubF = "Main_Attach_for_SubF",
  MainAttachForOPF = "Main_Attach_for_OPF",
  MainAttachForBoth = "Main_Attach_for_Both",
  MainForSubF = "Main_for_SubF",
  MainForOPF = "Main_for_OPF",
  MainForBoth = "Main_for_Both",
  AttachForSubF = "Attach_for_SubF",
  AttachForOPF = "Attach_for_OPF",
  AttachForBoth = "Attach_for_Both",
}

export enum DocumentOriginatingEvent {
  None = "None",
  OPF = "OPF",
  Both = "Both",
}

export enum RedactSealedDocumentsConfiguration {
  No = "No",
  Upload = "Upload",
  EditWithAcrobat = "EditWithAcrobat",
}

export enum StatutoryFeeEditConfiguration {
  ViewOnly = "ViewOnly",
  EditAsSingleFee = "EditAsSingleFee",
  Hide = "Hide",
  EditAsLineItems = "EditAsLineItems",
}

export enum DeliveryStatusSummary {
  Unknown = "Unknown",
  NewTransactionPendingTransmission = "NewTransactionPendingTransmission",
  TransmittedToPartner = "TransmittedToPartner",
  Processing = "Processing",
  DispatchedForDelivery = "DispatchedForDelivery",
  Delivered = "Delivered",
  Completed = "Completed",
  SubsequentRejectedFiling = "SubsequentRejectedFiling",
}

export enum OperationType {
  Add = "Add",
  Remove = "Remove",
  Replace = "Replace",
  Move = "Move",
  Copy = "Copy",
  Test = "Test",
  Invalid = "Invalid",
}

export enum ErrorDomain {
  None = "None",
  FilingFiling = "FilingFiling",
  FilingCase = "FilingCase",
  FilingDocument = "FilingDocument",
  FilingParty = "FilingParty",
  FilingAttorney = "FilingAttorney",
  ClerkReviewFiling = "ClerkReviewFiling",
  ClerkReviewCase = "ClerkReviewCase",
  ClerkReviewDocument = "ClerkReviewDocument",
  ClerkReviewParty = "ClerkReviewParty",
  ClerkReviewAttorney = "ClerkReviewAttorney",
  JudgeReviewFiling = "JudgeReviewFiling",
  JudgeReviewCase = "JudgeReviewCase",
  JudgeReviewDocument = "JudgeReviewDocument",
  ResourceLock = "ResourceLock",
  FilingAdditionalRecipient = "FilingAdditionalRecipient",
  FilingCourtesyCopy = "FilingCourtesyCopy",
  FilingCaseSearch = "FilingCaseSearch",
  OnlineSubscriber = "OnlineSubscriber",
  JudgeChamber = "JudgeChamber",
  JudgeReviewSavedFilter = "JudgeReviewSavedFilter",
}

export enum ClerkReviewRole {
  FILER_AND_AUTHORIZER = "FILER_AND_AUTHORIZER",
  FILER_ONLY = "FILER_ONLY",
  AUTHORIZER_ONLY = "AUTHORIZER_ONLY",
  MODIFIER_ONLY = "MODIFIER_ONLY",
  FILER_AUTHORIZER_AND_MODIFIER = "FILER_AUTHORIZER_AND_MODIFIER",
  FILER_AND_MODIFIER = "FILER_AND_MODIFIER",
  AUTHORIZER_AND_MODIFIER = "AUTHORIZER_AND_MODIFIER",
  SERVICE = "SERVICE",
  COURT_NOTIFICATION = "COURT_NOTIFICATION",
  ADDITIONAL_RECIPIENT = "ADDITIONAL_RECIPIENT",
  ADDITIONAL_RECIPIENT_NEW_ADDRESS = "ADDITIONAL_RECIPIENT_NEW_ADDRESS",
  FORWARD = "FORWARD",
  NOTICE = "NOTICE",
  COURTESY_COPIES_RECIPIENT = "COURTESY_COPIES_RECIPIENT",
}

/**
 * The filing option filter for the case history report
 * (legacy SearchFilingOption).
 */
export enum CaseHistoryFilingOption {
  All = "All",
  Court = "Court",
  DocumentUpload = "DocumentUpload",
}

/**
 * The search role scope for the case history report.
 * (Values mirror the legacy SearchRoleType / billing Role enums.)
 */
export enum CaseHistorySearchRole {
  MyTransactions = "MyTransactions",
  MyFirmsTransactions = "MyFirmsTransactions",
  AllTransactions = "AllTransactions",
  PublicTransactions = "PublicTransactions",
}

export enum SortOrder {
  Ascending = "Ascending",
  Descending = "Descending",
}

export enum QueryOperation {
  StartsWith = "StartsWith",
  EndsWith = "EndsWith",
  Contains = "Contains",
  Equal = "Equal",
  NotEqual = "NotEqual",
}

export interface AccountDetailsRequest {
  username?: string | null;
  password?: string | null;
  authenticationSource?: string | null;
  email?: string | null;
  /** @format guid */
  objectId?: string | null;
}

export interface KeyValuePairOfStringAndJsonNode {
  key?: string;
  value?: JsonNode | null;
}

export interface JsonNode {
  underlyingElement?: any | null;
  options?: JsonNodeOptions | null;
  parent?: JsonNode | null;
  root?: JsonNode;
}

export interface JsonNodeOptions {
  propertyNameCaseInsensitive?: boolean;
}

export interface ValidateLoginPageRequest {
  recaptchaToken?: string;
  userName?: string;
  email?: string;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

/**
 * Callback payload posted by the AI clerk review service when a document has been processed.
 * Property names bind from the camelCase JSON via the API's System.Text.Json configuration.
 * Reference-type properties are nullable because the service legitimately sends null for many
 * fields; without the ?, ASP.NET Core (with <Nullable>enable</Nullable>) would
 * treat each non-nullable reference type as implicitly [Required] and reject the payload.
 */
export interface AIClerkReviewCallbackRequest {
  /** AI engine document identifier. Matches DocumentAIReview.AIDocumentID. */
  documentId?: string | null;
  /** External identifier supplied at submission (the JCMS DocumentId). */
  externalId?: string | null;
  document?: AIClerkReviewCallbackDocument | null;
  summary?: AIClerkReviewCallbackSummary | null;
  testResults?: AIClerkReviewCallbackTestResult[] | null;
  processing?: AIClerkReviewCallbackProcessing | null;
}

export interface AIClerkReviewCallbackDocument {
  id?: string | null;
  externalId?: string | null;
  fileName?: string | null;
  status?: string | null;
  /** @format date-time */
  uploadedAt?: string | null;
  /** @format date-time */
  processedAt?: string | null;
  caseMetadata?: string | null;
  caseName?: string | null;
  caseNumber?: string | null;
  courtName?: string | null;
  userId?: string | null;
}

export interface AIClerkReviewCallbackSummary {
  pass?: boolean;
  summary?: string | null;
  /** @format int32 */
  pageCount?: number;
  /** @format int32 */
  wordCount?: number;
  documentDescription?: string | null;
  documentType?: string | null;
  /** @format int32 */
  totalRulesTested?: number;
  /** @format int32 */
  rulesPassed?: number;
  /** @format int32 */
  rulesFailed?: number;
  /** @format int32 */
  rulesInconclusive?: number;
  /** @format int64 */
  processingTimeMs?: number;
  /** @format date-time */
  createdAt?: string | null;
}

export interface AIClerkReviewCallbackTestResult {
  ruleId?: string | null;
  status?: string | null;
  reason?: string | null;
  /** @format double */
  confidence?: number;
  /** @format date-time */
  testedAt?: string | null;
  /** @format int64 */
  processingTimeMs?: number;
  highlights?: AIClerkReviewCallbackHighlight[] | null;
  rule?: AIClerkReviewCallbackRule | null;
}

export interface AIClerkReviewCallbackHighlight {
  chunkId?: string | null;
  /** @format int32 */
  pageNumber?: number;
  boundingBox?: number[] | null;
  content?: string | null;
}

export interface AIClerkReviewCallbackRule {
  id?: string | null;
  description?: string | null;
  ruleLevel?: string | null;
  jurisdiction?: string | null;
  court?: string | null;
  division?: string | null;
  caseClass?: string | null;
  caseType?: string | null;
  documentType?: string | null;
  isQualitative?: boolean;
  isActive?: boolean;
  quantitativeMetric?: string | null;
  comparisonOperator?: string | null;
  /** @format double */
  comparisonValue?: number | null;
  unit?: string | null;
}

export interface AIClerkReviewCallbackProcessing {
  /** @format int32 */
  totalRules?: number;
  /** @format int32 */
  completedRuleTests?: number;
  allRuleTestsCompleted?: boolean;
  resultsSummaryGenerated?: boolean;
  /** @format date-time */
  completedAt?: string | null;
}

export interface CaseParticipantBatchSubstituteAttorney {
  keys?: CaseParticipantKey[];
  oldAttorney?: RepresentationAttorney | null;
  newAttorney?: RepresentationAttorney | null;
  /** @format int32 */
  filingId?: number | null;
  documentTitle?: string | null;
  documentRef?: TempDocumentRef | null;
}

export interface CaseParticipantKey {
  /** @format int32 */
  caseId?: number;
  /** @format int32 */
  partyId?: number;
  /** @format int32 */
  partyTypeId?: number;
}

export type RepresentationAttorney = ParticipantRepresentation & {
  /** @format guid */
  representationId?: string | null;
  barNumber?: string | null;
};

export interface ParticipantRepresentation {
  /** @format int32 */
  id?: number;
  name?: string;
  /** @format int32 */
  typeId?: number;
  type?: string;
  /** @format guid */
  organizationId?: string;
  organizationName?: string;
  /** @format int32 */
  statusId?: number | null;
}

export interface TempDocumentRef {
  /** @format uri */
  uri?: string | null;
  fileName?: string;
}

export interface QueuedAttorney {
  queue?: QueueInfo | null;
  petition?: QueuePetition | null;
  queueAttorneyInfoList?: QueueAttorneyInfo[] | null;
}

export interface QueueInfo {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  requestorId?: number | null;
  requestorName?: string | null;
  /** @format guid */
  requestorOrgId?: string;
  requestorOrg?: string | null;
  /** @format date-time */
  dateEntered?: string;
  /** @format int32 */
  status?: number;
  /** @format int32 */
  typeId?: number | null;
  relatedIds?: number[];
}

export interface QueuePetition {
  /** @format int32 */
  filingId?: number | null;
  documentTitle?: string | null;
  documentPath?: string | null;
  transactionDocuments?: DocumentBasicInfo[];
}

export interface DocumentBasicInfo {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  filingId?: number;
  title?: string | null;
  type?: string | null;
  status?: string | null;
  /** @format date-time */
  statusDate?: string | null;
  access?: string | null;
  originalDocumentUri?: string | null;
  pdfDocumentUri?: string | null;
  /** @format int32 */
  pages?: number;
}

export interface QueueAttorneyInfo {
  /** @format int32 */
  entryId?: number;
  /** @format int32 */
  requestUserId?: number;
  requestUser?: string;
  requestOrganization?: string;
  /** @format date-time */
  dateEntered?: string;
  /** @format int32 */
  status?: number;
  /** @format int32 */
  filingId?: number | null;
  docTitle?: string;
  docFileName?: string;
  /** @format int32 */
  caseId?: number | null;
  caseName?: string | null;
  caseNumber?: string | null;
  caseClass?: string | null;
  /** @format guid */
  orgId?: string;
  courtName?: string;
  /** @format int32 */
  partyId?: number;
  partyName?: string;
  /** @format int32 */
  originalPartyTypeId?: number;
  originalPartyType?: string;
  /** @format int32 */
  newPartyTypeId?: number | null;
  /** @format int32 */
  userId?: number;
  userName?: string;
  userOrganization?: string | null;
  /** @format int32 */
  originalParticipantTypeId?: number | null;
  originalParticipantType?: string | null;
  /** @format int32 */
  replaceUserId?: number;
  replaceUserName?: string;
  replaceOrganization?: string;
  /** @format int32 */
  newParticipantTypeId?: number | null;
  /** @format int32 */
  newParticipantStatusId?: number | null;
  groupedEntries?: number[] | null;
  /** @format int32 */
  groupedStatus?: number | null;
}

export interface QueueAttorneyReplacement {
  /** @format int32 */
  newAttorneyTypeId?: number;
  noSubstitution?: boolean;
}

export interface QueueRejection {
  reason?: string | null;
  sendNotification?: boolean;
}

/** The "Batches for Clerk Review" list payload. */
export type BatchListResponse = QueryResponseOfBatchSummary & {
  /**
   * The court list backing the court filter, returned only when the request asks for it so
   * the client can fetch it once and page without re-sending it.
   */
  settings?: BatchReviewFilterSettings | null;
};

/**
 * Filter options for the batch list. Batches have no queue or judge scope of their own — the
 * court is the only axis Classic offers — so this is deliberately narrower than
 * ClerkReviewFilterSettings.
 */
export interface BatchReviewFilterSettings {
  /**
   * The courts the caller may clerk-review for. Reuses the clerk review court shape so the
   * client can share a court-picker control between the two lists.
   */
  courts?: ClerkReviewCourt[];
}

export interface ClerkReviewCourt {
  /** @format int32 */
  courtId?: number;
  courtName?: string;
  /**
   * The court enables judge chambers (Court.EnableJudgeChambers): the clerk can see and write chamber notes
   * in clerk review, and be mentioned in them.
   */
  isJudgeChambersEnabled?: boolean;
}

export interface QueryResponseOfBatchSummary {
  data?: BatchSummary[];
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  skip?: number;
  /** @format int32 */
  take?: number;
  sortBy?: string;
  sortOrder?: string;
}

/**
 * One row of the "Batches for Clerk Review" list.
 * Mirrors Classic's BulkFilingClerkReviewList projection (FilingBulkList.aspx in clerk
 * review mode): batch id, authorized date, authorizer name over authorizer org, court name and
 * the three batch descriptors. LockedByUserId comes from the same
 * Filing.Reviewer_ID lookup Classic uses to grey a batch out for everyone but its holder.
 */
export interface BatchSummary {
  /**
   * The batch identifier (BulkFiling.BulkFilingID). This is the friendly id the clerk
   * sees and the key the detail route takes.
   * @format int32
   */
  bulkFilingId?: number;
  /**
   * The court the batch was filed into.
   * @format int32
   */
  courtId?: number;
  /** The court's organization name. */
  courtName?: string;
  /**
   * The court's time zone, so the client can render AuthorizedDate in court
   * time the way Classic's GetCourtDateTime does.
   */
  courtTimeZone?: string;
  /**
   * When the batch was authorized for filing. Classic shows this (not the submission date)
   * in clerk review mode.
   * @format date-time
   */
  authorizedDate?: string | null;
  /**
   * Name of the attorney who authorized the batch, taken from the first filing in the batch
   * that carries one.
   */
  authorizerName?: string;
  /**
   * The authorizing attorney's firm. Classic renders this on a second line under
   * AuthorizerName.
   */
  authorizerOrgName?: string;
  /** Filer-supplied batch descriptor 1. */
  descriptor1?: string;
  /** Filer-supplied batch descriptor 2. */
  descriptor2?: string;
  /** Filer-supplied batch descriptor 3. */
  descriptor3?: string;
  /**
   * How many live (non-deleted) filings the batch holds.
   * @format int32
   */
  filingCount?: number;
  /**
   * True when another clerk currently holds the batch. Classic blocks the detail page
   * outright in that case; the list surfaces it so the clerk knows before clicking.
   */
  isLocked?: boolean;
  /**
   * The clerk holding the batch, when IsLocked is true.
   * @format int32
   */
  lockedByUserId?: number | null;
  /** Display name of the clerk holding the batch, when IsLocked is true. */
  lockedByName?: string;
}

/**
 * Sort/filter request for the "Batches for Clerk Review" list.
 * Classic sorts this grid on BulkFilingID, AuthorizedDate, CourtName, AuthorizerName and the
 * three descriptors, so those are the columns exposed here. Filtering is an addition over
 * Classic (which offered none) and is kept to the same column set.
 */
export type BatchQueryRequest = QueryRequestOfBulkFiling & {
  /**
   * Whether to return the court filter options alongside the page of rows.
   * @default false
   */
  includeSettings?: boolean;
  /** Filter by court. */
  courtId?: QueryColumnOfInteger | null;
  /** Sort by court name. */
  courtName?: QueryColumnOfString | null;
  /** Filter by batch id. */
  bulkFilingId?: QueryColumnOfInteger | null;
  /** Range of authorized dates. */
  dateRange?: QueryColumnOfDateRange | null;
  /** Sort by the authorizing attorney's name. */
  authorizerName?: QueryColumnOfString | null;
  /** Filter by batch descriptor 1. */
  descriptor1?: QueryColumnOfString | null;
  /** Filter by batch descriptor 2. */
  descriptor2?: QueryColumnOfString | null;
  /** Filter by batch descriptor 3. */
  descriptor3?: QueryColumnOfString | null;
};

export interface QueryColumnOfInteger {
  /** @format int32 */
  value: number;
  operation: QueryOperation;
}

export interface QueryColumnOfString {
  /** @minLength 1 */
  value: string;
  operation: QueryOperation;
}

export interface QueryColumnOfDateRange {
  value: DateRange;
  operation: QueryOperation;
}

export interface DateRange {
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
}

export interface QueryRequestOfBulkFiling {
  /**
   * Items to skip
   * @format int32
   * @min 0
   * @max 2147483647
   */
  skip?: number;
  /**
   * Items to take
   * @format int32
   * @min 1
   * @max 250
   */
  take?: number;
  /** Whether to include total count in response */
  includeTotal?: boolean;
  /** @minLength 1 */
  sortBy: string;
  /** @default "Ascending" */
  sortOrder?: SortOrder;
}

/**
 * Everything the batch review screen needs to render one batch.
 * This is the Modern equivalent of what Classic's FilingBulkDetails.aspx assembles from
 * BulkFilingDetailsGetByBulkID plus a handful of per-filing lookups: the batch header,
 * the flattened filing/document grid, and the flags that decide which header controls appear.
 */
export interface BatchDetail {
  /**
   * The batch identifier.
   * @format int32
   */
  bulkFilingId?: number;
  /**
   * The court the batch was filed into.
   * @format int32
   */
  courtId?: number;
  /** The court's organization name. */
  courtName?: string;
  /** The court's time zone, for rendering AuthorizedDate in court time. */
  courtTimeZone?: string;
  /**
   * The batch's current BulkFilingStatus. A reviewable batch is Submitted (2);
   * once every filing has been reviewed it becomes ClerkReviewed (11).
   * @format int32
   */
  bulkFilingStatusId?: number | null;
  /**
   * When the batch was authorized.
   * @format date-time
   */
  authorizedDate?: string | null;
  /**
   * The authorizing attorney's user id.
   * @format int32
   */
  authorizerUserId?: number | null;
  /** The authorizing attorney's display name. */
  authorizerName?: string;
  /** The authorizing attorney's firm. */
  authorizerOrgName?: string;
  /** Filer-supplied batch descriptor 1. */
  descriptor1?: string;
  /** Filer-supplied batch descriptor 2. */
  descriptor2?: string;
  /** Filer-supplied batch descriptor 3. */
  descriptor3?: string;
  /**
   * True when the batch's filings are originating (new-case) filings. Classic reads this off
   * the first grid row's OPF flag and uses it to decide whether the judge and division
   * pickers appear at all.
   */
  isOpf?: boolean;
  /**
   * The case class shared by the batch's filings. Drives which court case-class clerk review
   * options apply.
   * @format int32
   */
  caseClassId?: number | null;
  /**
   * The clerk currently holding the batch, if any. Classic refuses the whole page when this
   * is set to somebody else.
   * @format int32
   */
  lockedByUserId?: number | null;
  /** Display name of the clerk holding the batch. */
  lockedByName?: string;
  /** The filings in the batch, each carrying its own documents. */
  filings?: BatchFilingSummary[];
}

/**
 * One filing row in the batch grid. Classic renders a filing as a run of document rows with
 * the filing-level cells row-spanned across them; keeping documents nested lets the Angular
 * grid do the same without re-deriving the grouping.
 */
export interface BatchFilingSummary {
  /**
   * The filing's friendly submission id.
   * @format int32
   */
  filingId?: number;
  /**
   * The filing's GUID, for linking out to the single-transaction clerk review screen.
   * @format guid
   */
  filingUniqueId?: string;
  /**
   * The case the filing belongs to.
   * @format int32
   */
  caseId?: number | null;
  /**
   * The case's GUID.
   * @format guid
   */
  caseUniqueId?: string | null;
  /** The case number, empty for an originating filing whose number the clerk still has to set. */
  caseNumber?: string;
  /** The case style / name. */
  caseStyle?: string;
  /**
   * Regex the court requires a manually entered case number to match. Classic wires this
   * into an onBlur validator on each case-number input.
   */
  caseNumberValidationExpression?: string;
  /** Human-readable hint shown when CaseNumberValidationExpression fails. */
  caseNumberFormatTip?: string;
  /** The filer's note on the filing. Only surfaced when the court allows filer notes. */
  filerNote?: string;
  /** The filing description / bill reference. */
  filingDescription?: string;
  /**
   * How many active parties the filing's case has.
   * @format int32
   */
  numberOfParties?: number;
  /**
   * Classic's OPF flag: 0 subsequent, 1 originating, 2 subsequent with case creation,
   * 3 paper.
   * @format byte
   */
  opf?: number;
  /** The documents in this filing. */
  documents?: BatchDocumentSummary[];
}

/** One document row inside a batch filing. */
export interface BatchDocumentSummary {
  /**
   * The document identifier. This is the value the submit request checks off.
   * @format int32
   */
  documentId?: number;
  /** The document title. */
  documentTitle?: string;
  /**
   * The filing type's GUID, needed when building the review message.
   * @format guid
   */
  filingTypeUniqueId?: string | null;
  /** The filing type's display text. */
  filingType?: string;
  /**
   * The document's current review status id (1 pending, 2 accepted, 3 rejected,
   * 6 accepted without docketing).
   * @format int32
   */
  reviewStatusId?: number | null;
  /** The document's current review status text. */
  reviewStatus?: string;
  /**
   * The document's statutory fee as currently recorded.
   * @format decimal
   */
  fee?: number;
  /**
   * The fee type carrying Fee, echoed back on submit so the review message
   * updates the right line.
   * @format guid
   */
  feeTypeUniqueId?: string | null;
  /**
   * How many fee lines the document carries. Classic uses more than one, together with the
   * court's statutory-fee mode, to decide the fee is not editable inline.
   * @format int32
   */
  feeTypeCount?: number;
  /**
   * True when this document is the filing's originating-event document. Rejecting it rejects
   * the whole filing.
   */
  isOriginatingEvent?: boolean;
  /** Sealed documents are never stamped. */
  isSealed?: boolean;
  /** Conventionally filed documents are never stamped. */
  isConventionallyFiled?: boolean;
  /**
   * The parent document for a supporting document, null for a main document.
   * @format int32
   */
  relatedDocumentId?: number | null;
  /**
   * False when the clerk may not select this document — Classic hides the checkbox on an
   * originating filing whose originating document has already been rejected, because the
   * rest of the filing follows that rejection regardless.
   */
  isSelectable?: boolean;
}

/**
 * The court-driven options that decide which controls the batch review header shows and which
 * of them are required.
 * Classic derives all of this at page load from CourtProfile, CourtCaseClass (the CR* columns)
 * and CourtCaseCalendarEvent. Returning it as one document lets the Angular screen build its
 * form once instead of inferring rules from scattered flags.
 */
export interface BatchReviewConfiguration {
  /**
   * Judges assignable on an originating batch — the court's judges, matching Classic's
   * AvailableCourtJudgesAsEntities(). Empty for a subsequent-filing batch, which has
   * no judge picker.
   */
  judges?: CaseJudge[];
  /**
   * The court's divisions. Classic deliberately ignores the court's AllowSelectedDivision
   * setting here and offers every division whenever the division control is shown at all.
   */
  divisions?: BatchDivision[];
  /** The court's clerk stamps. */
  clerkStamps?: CourtClerkStamp[];
  /**
   * The stored path of the court's default stamp, preselected when the clerk has not chosen
   * one yet.
   */
  defaultClerkStampPath?: string;
  /**
   * Whether the division control appears. Mirrors CourtCaseClass.CropfDivision:
   * 0 means do not display.
   */
  showDivision?: boolean;
  /** Whether a division must be picked before an accepted batch can be submitted. */
  divisionRequired?: boolean;
  /**
   * Whether the stamp control appears. Classic shows it only when the court actually has
   * stamps configured, and then makes it required.
   */
  showClerkStamp?: boolean;
  /**
   * The court's statutory fee mode (CourtCaseClass.CrstatFee). When it is
   * "edit as line item", Classic makes the batch grid's fee read-only and sends the clerk to
   * the single-transaction review screen to change it.
   * @format int32
   */
  statutoryFeeMode?: number;
  /** True when the fee cell is editable directly in the batch grid. */
  allowInlineFeeEdit?: boolean;
  /**
   * Whether the court runs auto case numbering, which is what enables the
   * "Auto Case Number" action. When false, the clerk types case numbers per filing instead.
   */
  allowAutoCaseNumber?: boolean;
  /**
   * True once every filing in the batch has a case number, which is when Classic hides the
   * auto-case-number button.
   */
  allCaseNumbersSet?: boolean;
  /** Whether the court shows filer notes; when false Classic drops the notes column entirely. */
  allowFilerNote?: boolean;
  /**
   * Whether a calendar event may be entered with this batch review. True when the court has
   * clerk review calendar events on for the batch's kind of filing — CourtOpf for an
   * originating batch, CourtSubF for a subsequent one.
   */
  showCalendarEvent?: boolean;
  /**
   * Whether that calendar event is mandatory. Always true for an originating batch; for a
   * subsequent batch it follows CourtCaseClass.CrsubfbulkFilingEventRequired.
   */
  calendarEventRequired?: boolean;
  /** Whether the event's location is picked from the court's divisions rather than typed. */
  calendarEventLocationIsDivision?: boolean;
  /**
   * Whether the event's Location field appears at all.
   * Classic always offers a free-text Location, except when the court sources locations from
   * its divisions and has none configured — then the field is hidden rather than shown as an
   * empty dropdown (TFS 37075).
   */
  showEventLocation?: boolean;
  /**
   * Whether the clerk may set the event's status (Tentative / Confirmed / Cancelled).
   * Classic shows its status row only when the court lets somebody edit the event at all —
   * any of the admin-creator, creator-org, clerk-reviewer, court-user or anyone flags on
   * CourtCaseCalendarEvent. When it is hidden the event keeps the Confirmed default.
   */
  showEventStatus?: boolean;
  /** The calendar event types available for the batch's court and case class. */
  calendarEventTypes?: BatchEventType[];
  /**
   * Whether a clerk may reject a document that was already accepted
   * (CourtCaseClass.CrinactivateDocs). Together with
   * AllowAcceptRejected this decides which already-reviewed documents stay in
   * the batch grid.
   */
  allowRejectAccepted?: boolean;
  /**
   * Whether a clerk may accept a document that was already rejected
   * (CourtCaseClass.CracceptRejected).
   */
  allowAcceptRejected?: boolean;
}

export interface CaseJudge {
  /** @format int32 */
  userId?: number;
  /** @format guid */
  uniqueId?: string | null;
  name?: PersonName;
}

export interface PersonName {
  lastName?: string;
  firstName?: string | null;
  middleName?: string | null;
  prefix?: string | null;
  suffix?: string | null;
  /** @example "string --[patch-disabled]" */
  readonly fullName?: string | null;
  /** @example "boolean --[patch-disabled]" */
  readonly suppressed?: boolean;
  /** @example "boolean --[patch-disabled]" */
  readonly display?: boolean;
}

/** A selectable court division. */
export interface BatchDivision {
  /** @format int32 */
  divisionId?: number;
  divisionDescription?: string;
}

export interface CourtClerkStamp {
  /** @format int32 */
  courtId?: number;
  clerkStampPath?: string;
  clerkStampDescription?: string;
  isDefault?: boolean;
  /** @format guid */
  uniqueId?: string;
}

/** A selectable calendar event type. */
export interface BatchEventType {
  /** @format int32 */
  eventTypeId?: number;
  eventType?: string;
}

/** The outcome of a batch submit. */
export interface SubmitBatchReviewResult {
  /** The filings whose review was published to the filing state machine. */
  submittedFilingIds?: number[];
  /**
   * The batch's status after the submit. It reaches ClerkReviewed (11) once no filing in the
   * batch still has a pending document.
   * @format int32
   */
  bulkFilingStatusId?: number | null;
  /** True when the batch is fully reviewed and the screen should stop offering submit. */
  isBatchComplete?: boolean;
}

/**
 * One batch review decision, applied across every document the clerk checked.
 * Batch review is deliberately coarse: unlike single-transaction clerk review, the clerk picks
 * one status, one stamp, one judge, one division and one calendar event, and those apply to
 * the whole selection. That is exactly what Classic's FilingBulkDetails form posts, and the
 * shape is kept here so the two paths stay comparable.
 */
export interface SubmitBatchReviewRequest {
  /**
   * The review status to apply: 2 accepted or 3 rejected. Classic offers no other choice on
   * a batch.
   * @format int32
   * @min 2
   * @max 3
   */
  reviewStatusId: number;
  /**
   * The documents the clerk checked. At least one is required — Classic blocks submit with
   * "select a document" otherwise.
   * @minItems 1
   */
  documentIds: number[];
  /**
   * The primary judge to assign. Required on an accepted originating batch; ignored on a
   * rejection, which Classic does not make the clerk fill the header out for.
   * @format int32
   */
  judgeUserId?: number | null;
  /**
   * The division to set on each filing's case. Required when the court's clerk review
   * options mark division required and the batch is being accepted.
   * @format int32
   */
  divisionId?: number | null;
  /** Stored path of the clerk stamp to apply. Required when the court has stamps configured. */
  clerkStampPath?: string;
  /**
   * Per-filing case numbers typed by the clerk, for courts without auto case numbering.
   * Duplicates across the batch are rejected, matching Classic's duplicate check.
   */
  caseNumbers?: BatchCaseNumberEntry[];
  /** Per-document fee overrides, sent only when the court allows editing the fee inline. */
  fees?: BatchDocumentFeeEntry[];
  /**
   * The calendar event to create or update on every filing in the selection. Sent only when
   * the court has clerk review calendar events on, and never on a rejection.
   */
  calendarEvent?: BatchCalendarEvent;
}

/** A clerk-entered case number for one filing. */
export interface BatchCaseNumberEntry {
  /** @format int32 */
  filingId: number;
  /** @minLength 1 */
  caseNumber: string;
}

/** A clerk-entered statutory fee for one document. */
export interface BatchDocumentFeeEntry {
  /** @format int32 */
  documentId: number;
  /**
   * The new fee. Negative values are rejected, as in Classic.
   * @format decimal
   * @min 0
   */
  fee?: number;
}

/** The calendar event applied to each filing in the batch. */
export interface BatchCalendarEvent {
  /** @format int32 */
  eventTypeId?: number;
  eventName?: string;
  /**
   * Event status: 1 tentative, 2 confirmed, 3 cancelled. Classic defaults to confirmed.
   * @format byte
   */
  eventStatusId?: number;
  /** @format date-time */
  beginDateTime?: string | null;
  /** @format date-time */
  endDateTime?: string | null;
  /** Free-text location, used when the court does not source locations from divisions. */
  locationDescription?: string;
  /**
   * Division-backed location, used when the court does.
   * @format int32
   */
  locationDivisionId?: number | null;
  comment?: string;
}

export interface CaseSearchResult {
  /** @format int32 */
  caseId?: number;
  caseNumber?: string | null;
  caseName?: string | null;
  /** @format guid */
  orgId?: string;
  courtName?: string | null;
  /** @format int32 */
  caseClassId?: number;
  caseClassName?: string | null;
  /** @format int32 */
  caseTypeId?: number;
  caseTypeName?: string | null;
}

export interface AppealableCase {
  /** @format int32 */
  caseId?: number;
  caseNumber?: string | null;
  caseName?: string | null;
  /** @format guid */
  orgId?: string;
  courtName?: string | null;
}

export interface CaseInfo {
  /** @format int32 */
  caseId?: number;
  caseName?: string | null;
  caseNumber?: string | null;
  /** @format guid */
  orgId?: string;
  courtName?: string;
  /** @format int32 */
  caseClassId?: number | null;
  caseClassName?: string | null;
  /** @format int32 */
  caseTypeId?: number | null;
  caseTypeName?: string | null;
  /** @format int32 */
  divisionId?: number | null;
  divisionName?: string | null;
  /** @format int32 */
  caseStatusId?: number | null;
  caseStatusDescription?: string | null;
  /** @format int32 */
  status?: number | null;
  /** @format date-time */
  beginDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  judgeId?: number[] | null;
  judgeName?: string[] | null;
  /** @format int32 */
  alternateJudgeId?: number | null;
  alternateJudgeName?: string | null;
  /** @format int32 */
  clerkId?: number | null;
  clerkName?: string | null;
  state?: string | null;
  isMasterCase?: boolean;
  publicAccess?: boolean;
  semiPrivate?: boolean | null;
  lowerCase?: LowerCase | null;
  elevateDocumentSecurity?: boolean;
}

export interface LowerCase {
  /** @format int32 */
  caseId?: number;
  caseNumber?: string | null;
  caseName?: string | null;
  /** @format int32 */
  courtId?: number;
  courtName?: string;
}

export interface Case {
  /** @minLength 1 */
  caseName: string;
  /** @minLength 1 */
  caseNumber: string;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  caseStatusId?: number;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  caseClassId?: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  caseTypeId?: number;
  /**
   * @format int32
   * @min -1
   * @max 2147483647
   */
  divisionId?: number;
  judgeId?: number[] | null;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  alternateJudgeId?: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  clerkId?: number;
  /** @format date-time */
  beginDate?: string;
  /** @format date-time */
  endDate?: string | null;
  /** @format int32 */
  lowerCaseId?: number | null;
}

export interface QueueCaseInfo {
  /** @format int32 */
  entryId?: number;
  /** @format int32 */
  requestUserId?: number;
  requestUser?: string;
  requestOrganization?: string;
  /** @format date-time */
  dateEntered?: string;
  /** @format int32 */
  status?: number;
  /** @format int32 */
  caseId?: number;
  caseName?: string | null;
  caseNumber?: string | null;
  /** @format guid */
  orgId?: string;
  courtName?: string;
  /** @format int32 */
  caseClassId?: number | null;
  /** @format int32 */
  caseTypeId?: number | null;
  /** @format int32 */
  divisionId?: number | null;
  /** @format int32 */
  caseStatusId?: number | null;
  /** @format date-time */
  beginDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  judgeId?: number[] | null;
  /** @format int32 */
  alternateJudgeId?: number | null;
  /** @format int32 */
  clerkId?: number | null;
  lowerCase?: LowerCase | null;
  originalCaseInfo?: CaseInfo | null;
}

export interface CaseGroupInfo {
  /** @minLength 1 */
  groupName: string;
  isPublic?: boolean;
  caseIds?: number[];
}

export interface CaseGroup {
  /** @format int32 */
  groupId?: number;
  groupName?: string;
  /** @format guid */
  orgId?: string;
  court?: string;
  creator?: string;
  creatorOrg?: string;
  /** @format guid */
  creatorOrgId?: string;
  /** @format date-time */
  dateCreated?: string;
  isPublic?: boolean;
  cases?: CaseGroupMember[] | null;
}

export interface CaseGroupMember {
  /** @format int32 */
  caseId?: number;
  caseName?: string;
  caseNumber?: string;
  /** @format int32 */
  caseClassId?: number;
  caseClass?: string;
  caseType?: string;
}

/** The billing (fee gate) information for a case history report. */
export interface SearchReportBillingInfo {
  /**
   * The search role the fee was priced for — the requested role, or the legacy
   * default when none was requested. Send it back on the report query so the
   * report is produced and billed under the role whose fee was acknowledged.
   */
  searchRole?: CaseHistorySearchRole;
  /** Whether a fee must be acknowledged before the report is produced. */
  feeRequired?: boolean;
  /**
   * The fee amount for the requested search role.
   * @format decimal
   */
  fee?: number;
  /**
   * The covering subscription id, when the organization has one (0 otherwise).
   * @format int64
   */
  subscriptionId?: number;
  /** True when the organization is delinquent and the report is blocked. */
  locked?: boolean;
  /**
   * True when the organization requires a billing reference (legacy client
   * matter) on search reports — the legacy MandatoryBillingReference
   * SearchDocumentOrTransaction flag. Only set when a fee applies, matching
   * the legacy report, which asks for the reference on the fee panel only.
   */
  billingReferenceRequired?: boolean;
}

/**
 * The case-information panel served from a filing (a modern refactor of the
 * legacy Case/CaseInfoFromFiling.aspx single-case view). Keyed by the case's
 * unique (GUID) id. Covers the Case Details header, Court Officials, and Case
 * Parties (with representation). Case Group Affiliations and Linked Cases from
 * the legacy page are not included in this version.
 */
export interface CaseInfoFromFilingResult {
  /** @format guid */
  caseUniqueId?: string;
  /** @format int32 */
  caseId?: number;
  caseNumber?: string | null;
  caseName?: string | null;
  courtName?: string | null;
  division?: string | null;
  caseClass?: string | null;
  caseType?: string | null;
  caseStatus?: string | null;
  /**
   * The File & ServeXpress live date (CourtCase.BeginDate).
   * @format date-time
   */
  liveDate?: string | null;
  /** Court officials (judges, alternate judge, clerk). */
  courtOfficials?: CaseOfficialInfo[];
  /** Case parties with their representation. */
  parties?: CasePartyInfo[];
}

/** A court official row (Court Officials section). */
export interface CaseOfficialInfo {
  name?: string | null;
  participantType?: string | null;
  organization?: string | null;
}

/** A case party with its attorneys (Case Parties section). */
export interface CasePartyInfo {
  partyName?: string | null;
  partyType?: string | null;
  attorneys?: CasePartyAttorneyInfo[];
}

/** An attorney representing a party. */
export interface CasePartyAttorneyInfo {
  name?: string | null;
  attorneyType?: string | null;
  firm?: string | null;
}

/** Response wrapper for the case history query, with the case header block. */
export type CaseHistoryQueryResponse = QueryResponseOfCaseHistoryTransaction & {
  /** The case the history belongs to (for the page header). */
  case?: CaseHistoryCaseInfo | null;
};

/** The case header block for the case history page. */
export interface CaseHistoryCaseInfo {
  /** @format guid */
  caseUniqueId?: string;
  caseNumber?: string | null;
  caseName?: string | null;
  /** @format guid */
  courtOrgId?: string;
  courtName?: string | null;
  /** The case's division description, when assigned. */
  division?: string | null;
  /** The case type description. */
  caseType?: string | null;
  /** The assigned judges, each as "Last, First Middle". Empty when there is none to show. */
  primaryJudges?: string[];
  /**
   * The court's File & ServeXpress live date for the case (CourtCase.BeginDate).
   * @format date-time
   */
  liveDate?: string | null;
  /**
   * The number of documents in the report (legacy DocsByCase "Document(s) Filed:",
   * which counts the rows of the report data set, not every document ever linked to
   * the case). It therefore matches the documents the caller can actually see: the
   * procedure matrix's rows after the review-status visibility, pending/rejected and
   * date-range filters, across every page.
   * @format int32
   */
  documentsFiled?: number;
  /**
   * Whether the case's court assigns docket sequence numbers
   * (Court.AllowDocketNumbering). When false no document carries a
   * DocketId and the legacy report hides the
   * docket ("#") column outright.
   */
  allowDocketNumbering?: boolean;
}

export interface QueryResponseOfCaseHistoryTransaction {
  data?: CaseHistoryTransaction[];
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  skip?: number;
  /** @format int32 */
  take?: number;
  sortBy?: string;
  sortOrder?: string;
}

/**
 * A filing (transaction) in the case history, with its documents.
 * Refactored from the legacy FindDocsByLawFirm* stored procedure results.
 */
export interface CaseHistoryTransaction {
  /**
   * The filing id (displayed as the Transaction ID / TID).
   * @format int32
   */
  transactionId?: number;
  /**
   * The filing's unique (GUID) id, used for navigation (e.g. the
   * transaction view sidecar). Display still uses TransactionId.
   * @format guid
   */
  filingUniqueId?: string;
  /**
   * When the filing was authorized, as an absolute instant (UTC offset).
   * Persisted as Eastern wall-clock; converted on the way out so the UI can
   * render it in the signed-in user's own time zone.
   * @format date-time
   */
  authorizedDate?: string | null;
  /** The filer's name. */
  filer?: string | null;
  /** The authorizer's name. */
  authorizer?: string | null;
  /** The authorizer's organization name. */
  authorizerOrganization?: string | null;
  /** The filing option display text (Court / Firm / Upload). */
  filingOption?: string | null;
  /**
   * The raw FileToCourt indicator (4 = Document Upload).
   * @format int32
   */
  fileToCourt?: number;
  /**
   * Whether the filing spans multiple cases. When true the UI shows
   * "Multi-Case" instead of a case number/name.
   */
  multiCase?: boolean;
  /**
   * The party color code id for the filing (legacy PartyColorCode.Id:
   * 0 = Court, 1 = Plaintiff, 2 = Defendant, …), or null when no party
   * on the filing matched a configured color. Drives row color coding
   * by party (filer) type.
   * @format int32
   */
  partyColorCodeId?: number | null;
  /**
   * The party color for the filing (hex, e.g. "#FF0000") from the matched
   * PartyColorCode, or null when none applies.
   */
  partyColor?: string | null;
  /**
   * The matched party color code's group type (e.g. "Plaintiff"), for a
   * legend/tooltip, or null when none applies.
   */
  partyGroupType?: string | null;
  /** The documents on this filing. */
  documents?: CaseHistoryDocument[];
}

/** A document within a case history transaction. */
export interface CaseHistoryDocument {
  /** @format int32 */
  documentId?: number;
  /** The document title. */
  title?: string | null;
  /** The filing type of the document. */
  filingType?: string | null;
  /** The review status display text. */
  reviewStatus?: string | null;
  /**
   * The review status id (1 pending, 2 accepted, 3 rejected, ...).
   * @format int32
   */
  reviewStatusId?: number;
  /**
   * The document size in bytes.
   * @format int64
   */
  fileSizeBytes?: number;
  /**
   * The docket sequence number, when the court enables docket numbering.
   * @format int32
   */
  docketId?: number | null;
  /**
   * The related (parent) document id; 0 when this is a main document.
   * @format int32
   */
  relatedDocumentId?: number;
  /**
   * The document access type id.
   * @format int32
   */
  accessTypeId?: number;
  /** The next calendar event type / date on the filing, when present. */
  eventType?: string | null;
  /**
   * The next calendar event date. Deliberately NOT converted to an absolute
   * instant like AuthorizedDate: this is
   * a calendar date, and shifting it into the viewer's zone would move a
   * midnight value to the previous day west of Eastern.
   * @format date-time
   */
  eventDate?: string | null;
}

/** Query request for the case history documents report. */
export interface CaseHistoryQueryRequest {
  /**
   * The search role scope. Omit it for the legacy default: My Firm's Cases when the
   * caller's organization is an active participant in the case, otherwise All
   * Transactions (legacy DocsByCase direct-case link).
   */
  searchRole?: CaseHistorySearchRole | null;
  /**
   * The filing option filter. Defaults to all documents.
   * @default "All"
   */
  filingOption?: CaseHistoryFilingOption;
  /**
   * Optional lower bound (inclusive) on the authorized date.
   * @format date-time
   */
  fromDate?: string | null;
  /**
   * Optional upper bound (inclusive) on the authorized date.
   * @format date-time
   */
  toDate?: string | null;
  /**
   * Whether pending documents are included (legacy pending checkbox).
   * @default true
   */
  includePending?: boolean;
  /**
   * Whether rejected documents are included (legacy rejected checkbox).
   * @default true
   */
  includeRejected?: boolean;
  /**
   * Must be true when the billing endpoint reports a fee for this
   * search role; the fee is billed when the report is produced.
   */
  acknowledgeFee?: boolean;
  /**
   * The billing reference (legacy client matter) recorded against the search
   * fee. Required when the billing endpoint reports
   * BillingReferenceRequired.
   * @maxLength 255
   */
  billingReference?: string | null;
  /**
   * Items (transactions) to skip.
   * @format int32
   * @min 0
   * @max 2147483647
   */
  skip?: number;
  /**
   * Items (transactions) to take.
   * @format int32
   * @min 1
   * @max 250
   */
  take?: number;
  /** Whether to include the total (post-filter) transaction count. */
  includeTotal?: boolean;
  /**
   * When true, all matching transactions are returned in a single response
   * (Skip/Take are ignored) and the report is not re-billed. Used by the
   * printable report view, which shows every item without pagination.
   */
  includeAll?: boolean;
}

export interface ListResponseOfDashboardJudge {
  data?: DashboardJudge[];
}

/**
 * A judge in the clerk's court(s), with their active case count and the
 * current user's favorite (tracked) flag. The clerk-side counterpart of
 * DashboardAttorney; both are refactored from the
 * legacy GetCourtPersonnel / GetCourtPersonnelAssigned stored procedures, which
 * return judges for a court (clerk) user and attorneys for a firm user.
 */
export interface DashboardJudge {
  /**
   * The judge's user id.
   * @format int32
   */
  userId?: number;
  /** The judge's first name. */
  firstName?: string | null;
  /** The judge's last name. */
  lastName?: string | null;
  /**
   * The number of active cases the judge is assigned to.
   * @format int32
   */
  activeCaseCount?: number;
  /** Whether the current user has favorited (tracks) this judge. */
  isFavorite?: boolean;
}

/** Payload for setting an attorney favorite (tracked personnel) flag. */
export interface SetFavoriteRequest {
  /** True to favorite the attorney; false to remove the favorite. */
  isFavorite?: boolean;
}

/** Response wrapper for the active cases query. */
export type ActiveCasesQueryResponse = QueryResponseOfActiveCaseItem & object;

export interface QueryResponseOfActiveCaseItem {
  data?: ActiveCaseItem[];
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  skip?: number;
  /** @format int32 */
  take?: number;
  sortBy?: string;
  sortOrder?: string;
}

/**
 * An active case row for the dashboard case list.
 * Refactored from the legacy GetCourtPersonnelCaseList stored procedure.
 */
export interface ActiveCaseItem {
  /**
   * The case id.
   * @format int32
   */
  caseId?: number;
  /**
   * The case's unique (guid) id, used by the filing flows.
   * @format guid
   */
  caseUniqueId?: string;
  /** The case number. */
  caseNumber?: string | null;
  /** The case caption / style. */
  caseName?: string | null;
  /**
   * The court's organization unique id (used by court-scoped endpoints).
   * @format guid
   */
  courtOrgId?: string;
  /**
   * The id of the case's Trial Binder (eBinder), when one exists; otherwise null.
   * @format guid
   */
  trialBinderId?: string | null;
  /**
   * The forum id of the case's message board, when one exists; otherwise null.
   * @format int32
   */
  messageBoardForumId?: number | null;
  /** The court's display name. */
  courtName?: string | null;
  /** Whether the current user has bookmarked this case. */
  bookmarked?: boolean;
  /** The firm's attorneys participating in this case. */
  attorneys?: ActiveCaseAttorney[];
  /** The parties on this case. */
  parties?: ActiveCaseParty[];
}

/** An attorney participating in an active case. */
export interface ActiveCaseAttorney {
  /**
   * The attorney's user id.
   * @format int32
   */
  userId?: number;
  /** The attorney's display name. */
  name?: PersonName | null;
}

/** A party on an active case. */
export interface ActiveCaseParty {
  /** The party's role (party type), e.g. Plaintiff / Defendant. */
  role?: string | null;
  /** The party's display name. */
  name?: PersonName | null;
}

/**
 * Query request for the clerk dashboard active case list (server-paged).
 * Mirrors ActiveCasesQueryRequest but filters by
 * judge rather than attorney.
 */
export interface ClerkActiveCasesQueryRequest {
  /**
   * Optional filter to a single judge's cases.
   * When null, cases for all of the court's judges are returned.
   * @format int32
   */
  judgeUserId?: number | null;
  /** Optional text filter applied to case number, caption, and court name. */
  search?: string | null;
  /**
   * Items to skip.
   * @format int32
   * @min 0
   * @max 2147483647
   */
  skip?: number;
  /**
   * Items to take.
   * @format int32
   * @min 1
   * @max 250
   */
  take?: number;
  /** Whether to include the total (post-filter) case count in the response. */
  includeTotal?: boolean;
}

/** Payload for setting a case bookmark flag. */
export interface SetBookmarkRequest {
  /** True to bookmark the case; false to remove the bookmark. */
  bookmarked?: boolean;
}

/**
 * The "Clerk Review — My Pending Work" dashboard summary: the clerk's review
 * queues (with pending counts) and a per-status breakdown of their pending work.
 */
export interface ClerkReviewDashboardSummary {
  /**
   * The clerk's review queues with their pending filing counts
   * (reused from the clerk review filter settings).
   */
  queues?: ClerkReviewQueueAndCount[];
  /**
   * A per-status breakdown of the clerk's pending review work
   * (e.g. awaiting review, in review, late).
   */
  statuses?: ReviewStatusCount[];
}

export interface ClerkReviewQueueAndCount {
  /** @format guid */
  clerkReviewQueueId?: string;
  /** @format int32 */
  courtId?: number;
  clerkReviewQueueName?: string;
  /** @format int32 */
  clerkReviewQueueCount?: number;
}

export interface ListResponseOfRecentlyFiledCase {
  data?: RecentlyFiledCase[];
}

/** A case the clerk recently filed into, for the dashboard's "Recently Filed Into" list. */
export interface RecentlyFiledCase {
  /**
   * The case's unique (guid) id; opens Case History and preselects the case when filing into it.
   * @format guid
   */
  caseUniqueId?: string;
  /** The case number. */
  caseNumber?: string | null;
  /** The case name (caption). */
  caseName?: string | null;
  /**
   * The court organization's unique (guid) id.
   * @format guid
   */
  courtOrgId?: string;
  /** The court name. */
  courtName?: string | null;
  /**
   * When the clerk last filed into the case.
   * @format date-time
   */
  lastFiledDate?: string | null;
}

/** A single status bucket in the clerk review dashboard summary. */
export interface ReviewStatusCount {
  /** A stable key identifying the bucket (e.g. "awaitingReview", "inReview", "late"). */
  key?: string;
  /** The display label for the bucket. */
  label?: string;
  /**
   * The number of filings in the bucket.
   * @format int32
   */
  count?: number;
}

export type ClerkReviewListResponse = QueryResponseOfReviewFilingSummary & {
  settings?: ClerkReviewFilterSettings | null;
};

export interface ClerkReviewFilterSettings {
  courts?: ClerkReviewCourt[];
  queues?: ClerkReviewQueueAndCount[];
  judges?: ClerkReviewJudge[];
}

export interface ClerkReviewJudge {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  judgeId?: number;
  judgeName?: PersonName;
}

export interface QueryResponseOfReviewFilingSummary {
  data?: ReviewFilingSummary[];
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  skip?: number;
  /** @format int32 */
  take?: number;
  sortBy?: string;
  sortOrder?: string;
}

export interface ReviewFilingSummary {
  /** @format int32 */
  filingId?: number;
  /** @format guid */
  filingUniqueId?: string;
  /** @format date-time */
  filingDate?: string | null;
  /** @format date-time */
  authorizedDate?: string | null;
  /** @format int32 */
  courtId?: number;
  courtName?: string;
  courtTimeZone?: string;
  /** @format int32 */
  authorizerId?: number | null;
  /** @format int32 */
  authorizerOrganizationId?: number | null;
  authorizerName?: PersonName;
  authorizerOrganizationName?: string;
  status?: string;
  isBusy?: boolean;
  isLate?: boolean;
  isLocked?: boolean;
  /**
   * The filing's court enables judge chambers (Court.EnableJudgeChambers), so its documents can show
   * chamber notes in clerk review.
   */
  isJudgeChambersEnabled?: boolean;
  hasFilerNote?: boolean;
  reviewerName?: PersonName | null;
  filerNote?: string | null;
  cases?: ReviewFilingCaseSummary[];
  documents?: ReviewFilingDocumentSummary[];
}

export interface ReviewFilingCaseSummary {
  /** @format int32 */
  caseId?: number;
  /**
   * The case's CourtCase.UniqueId. The Case History sidecar is keyed by this GUID,
   * not the integer CaseId.
   * @format guid
   */
  caseUniqueId?: string | null;
  name?: string;
  number?: string | null;
  caseClass?: string;
  judge?: CaseJudge | null;
  /**
   * The TrialBinder (eBinder) ID for this case, if one exists.
   * Use this to link to the case's eBinder. Null when no binder has been created for the case.
   * @format guid
   */
  trialBinderId?: string | null;
}

export interface ReviewFilingDocumentSummary {
  /** @format int32 */
  documentId?: number;
  documentTitle?: string;
  /** @format int32 */
  filingTypeId?: number | null;
  filingType?: string;
  /** @format int32 */
  reviewStatusId?: number | null;
  reviewStatus?: string;
  /** @format int32 */
  numberOfBytes?: number | null;
  /** @format int32 */
  relatedDocumentId?: number | null;
  /** @format int32 */
  linkTo?: number | null;
  /** @format int32 */
  linkFrom?: number | null;
}

export type ClerkReviewQueryRequest = QueryRequestOfFiling & {
  /**
   * Indicates whether to include the user settings in the response.
   * @default false
   */
  includeSettings?: boolean;
  /** Filter by court id */
  courtId?: QueryColumnOfInteger | null;
  /** Filter by court id */
  courtName?: QueryColumnOfString | null;
  /** Filter by supporting documents */
  searchSupportingDocuments?: QueryColumnOfBoolean;
  /** Filter by queue. */
  queueIds?: QueryColumnOfIListOfGuid | null;
  /** Range of filing dates */
  dateRange?: QueryColumnOfDateRange | null;
  /** Filter by judge id */
  judgeId?: QueryColumnOfInteger | null;
  /** Filter by judge name */
  judgeName?: QueryColumnOfString | null;
  /** Filter by authorizer name */
  authorizerName?: QueryColumnOfString | null;
  /** Filter by authorizer's firm */
  authorizerFirm?: QueryColumnOfString | null;
  /** Filter by case name */
  caseName?: QueryColumnOfString | null;
  /** Filter by case number */
  caseNumber?: QueryColumnOfString | null;
  /** Filter by case type */
  caseType?: QueryColumnOfString | null;
  /** Filter by division */
  division?: QueryColumnOfString | null;
  /** Filter by document title */
  documentTitle?: QueryColumnOfString | null;
  /** Filter by filing type */
  filingType?: QueryColumnOfString | null;
  /** Filter by sender name */
  sender?: QueryColumnOfString | null;
  /** Filter by sender's firm */
  senderFirm?: QueryColumnOfString | null;
  /** Filter by document's status */
  status?: QueryColumnOfString | null;
  /** Filter by transaction */
  filingId?: QueryColumnOfInteger | null;
};

export interface QueryColumnOfBoolean {
  value: boolean;
  operation: QueryOperation;
}

export interface QueryColumnOfIListOfGuid {
  value: string[];
  operation: QueryOperation;
}

export interface QueryRequestOfFiling {
  /**
   * Items to skip
   * @format int32
   * @min 0
   * @max 2147483647
   */
  skip?: number;
  /**
   * Items to take
   * @format int32
   * @min 1
   * @max 250
   */
  take?: number;
  /** Whether to include total count in response */
  includeTotal?: boolean;
  /** @minLength 1 */
  sortBy: string;
  /** @default "Ascending" */
  sortOrder?: SortOrder;
}

export interface ClerkReviewFiling {
  /**
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly filingUniqueId?: string;
  /**
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly filingId?: number;
  /**
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly courtId?: string;
  /** @example "string --[patch-disabled]" */
  readonly courtName?: string;
  /** @example "boolean --[patch-disabled]" */
  readonly isOpf?: boolean;
  /** @format date-time */
  authorizedDate?: string | null;
  /** @format date-time */
  scheduledDate?: string | null;
  /** @example "string --[patch-disabled]" */
  readonly filingComment?: string | null;
  financialComment?: string | null;
  isLate?: boolean;
  /** @format guid */
  reviewerId?: string | null;
  /** @example "object --[patch-disabled]" */
  readonly reviewerName?: PersonName | null;
  /** @example "string --[patch-disabled]" */
  readonly filerNote?: string | null;
  /** @example "object --[patch-disabled]" */
  readonly filerName?: PersonName | null;
  /** @example "string --[patch-disabled]" */
  readonly filerOrganizationName?: string | null;
  /** @example "object --[patch-disabled]" */
  readonly authorizerName?: PersonName | null;
  /** @example "string --[patch-disabled]" */
  readonly authorizerOrganizationName?: string | null;
  /** @example "boolean --[patch-disabled]" */
  readonly isJudgeReviewFilingInProcess?: boolean;
  /** @example "string --[patch-disabled]" */
  readonly feeWaiverReason?: string | null;
  /**
   * Whether the filer has a deferred payment arrangement with the court for this filing
   * (Filing.PaymentDeferred). Clerk-editable when the court allows deferred payment;
   * the reviewed value is written back to the Filing row on clerk-review submission.
   */
  paymentDeferred?: boolean;
  /**
   * The filing's current payment status, provider-agnostic — same display shape as the
   * Transaction Details screen (GetLatestPaymentDisplayAsync).
   * Null when the filing never had a payment attempt (e.g. fee-waived, $0, or not yet
   * captured). Read-only: shown to the clerk before they edit fees, not editable here.
   * @example "object --[patch-disabled]"
   */
  readonly payment?: TransactionPayment | null;
  readonly clerkReviewCases?: ClerkReviewCase[];
  readonly clerkReviewDocuments?: ClerkReviewDocument[];
  readonly additionalDataCaseValues?: ClerkReviewAdditionalDataValue[];
  readonly validationErrors?: Error[];
}

/**
 * The filing's most recent payment result, provider-agnostic. Null on the parent
 * TransactionDetails when the filing never had a payment attempt (e.g. fee-waived
 * or $0 filings), or when the requesting user is not allowed to see payment details
 * (CanViewTransactionPayment).
 * Deliberately does not name the payment provider — display-only, not an audit
 * trail; Last4/CardBrand are null when not resolvable.
 */
export interface TransactionPayment {
  /** @format decimal */
  amount?: number;
  last4?: string | null;
  cardBrand?: string | null;
  status?: string | null;
  externalAuthCode?: string | null;
  gatewayCode?: string | null;
  /** @format date-time */
  occurredAt?: string;
}

export interface ClerkReviewCase {
  /**
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly caseId?: string;
  caseNumber?: string;
  caseName?: string;
  /**
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly caseClassId?: string;
  /** @example "string --[patch-disabled]" */
  readonly caseClass?: string | null;
  /** @format guid */
  caseTypeId?: string;
  /** @example "string --[patch-disabled]" */
  readonly caseType?: string | null;
  /** @format guid */
  divisionId?: string | null;
  /** @example "string --[patch-disabled]" */
  readonly division?: string | null;
  primaryJudge?: ClerkReviewCaseJudge | null;
  alternateJudge?: ClerkReviewCaseJudge | null;
  multipleJudges?: ClerkReviewCaseJudge[];
  readonly sendingParties?: ClerkReviewCaseParticipant[];
  readonly queueCaseParticipants?: ClerkReviewCaseParticipant[];
  readonly caseParticipants?: ClerkReviewCaseParticipant[];
  /**
   * Total number of DISTINCT SERVICE-role recipients (party + party-type) on
   * this case, counted BEFORE the response cap is applied. When a filing has
   * more service recipients than ServiceRecipientCap,
   * CaseParticipants is trimmed to the first N distinct parties
   * (all attorney rows for those parties are kept) and the full list is served
   * by GET clerk-review/filing/{id}/recipients. The UI sums this across cases
   * to decide whether to show the "View All Recipients" affordance. A recipient
   * is a distinct PARTY, not a participant row: a party with several attorneys
   * is many rows but counts once here.
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly totalServiceRecipients?: number;
}

export interface ClerkReviewCaseJudge {
  /** @format guid */
  userId?: string;
  /** @example "object --[patch-disabled]" */
  readonly judgeName?: PersonName;
}

export interface ClerkReviewCaseParticipant {
  /**
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly entryId?: number | null;
  /**
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly caseParticipantId?: string | null;
  party?: ClerkReviewParty;
  attorney?: ClerkReviewAttorney;
  /** @example "boolean --[patch-disabled]" */
  readonly isConfidential?: boolean;
  /** @format int32 */
  clerkReviewStatusId?: number | null;
  clerkReviewRole?: ClerkReviewRole | null;
}

export interface ClerkReviewParty {
  /**
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly partyId?: string;
  /**
   * The JCMS integer Party.PartyId, not the guid PartyId above. Additional-data
   * case.participants fields store their selection as this id, so the pickers must match on it.
   * Hydrated on read (not authoritative in the blob) by RefreshPartyIdentifiersAsync.
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly jcmsPartyId?: number;
  partyName?: PersonName;
  /** @format guid */
  partyTypeId?: string | null;
  /** @example "string --[patch-disabled]" */
  readonly partyType?: string | null;
  /** @format guid */
  partySubTypeId?: string | null;
  /** @example "string --[patch-disabled]" */
  readonly partySubType?: string | null;
  /** @format int32 */
  partyStatusId?: number | null;
  /** @example "string --[patch-disabled]" */
  readonly partyStatus?: string | null;
  /** @format int32 */
  entityTypeId?: number;
  entityType?: string;
  ssn?: string | null;
  /** @format date-time */
  dateOfBirth?: string | null;
  clerkReviewPartyAliases?: ClerkReviewPartyAlias[];
  addresses?: Address[];
  email?: string | null;
  phoneNumber?: string | null;
  extension?: string | null;
}

export interface ClerkReviewPartyAlias {
  /**
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly partyId?: string;
  partyName?: PersonName;
  /** @format guid */
  aliasTypeId?: string | null;
  /** @example "string --[patch-disabled]" */
  readonly aliasType?: string | null;
  /** @example "string --[patch-disabled]" */
  readonly partyStatus?: string | null;
  /** @format int32 */
  entityTypeId?: number;
  addresses?: Address[];
  email?: string | null;
  phoneNumber?: string | null;
  extension?: string | null;
}

export interface Address {
  /** @format int64 */
  id?: number | null;
  /** @format int32 */
  typeId?: number | null;
  type?: string | null;
  streetLine1?: string | null;
  streetLine2?: string | null;
  city?: string | null;
  stateCode?: string | null;
  state?: string | null;
  isPrimary?: boolean;
  /**
   * @minLength 5
   * @maxLength 5
   */
  zipCode?: string | null;
  /**
   * @minLength 4
   * @maxLength 4
   */
  zipCodeExtension?: string | null;
}

export interface ClerkReviewAttorney {
  /**
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly userId?: string;
  /** @example "object --[patch-disabled]" */
  readonly attorneyName?: PersonName;
  /** @format guid */
  attorneyTypeId?: string | null;
  /** @example "string --[patch-disabled]" */
  readonly attorneyType?: string | null;
  /** @format guid */
  counselTypeId?: string | null;
  /** @example "string --[patch-disabled]" */
  readonly counselType?: string | null;
  /** @format int32 */
  attorneyStatusId?: number | null;
  /** @example "string --[patch-disabled]" */
  readonly attorneyStatus?: string | null;
  /** @example "string --[patch-disabled]" */
  readonly attorneyBarNumber?: string | null;
  /** @example "string --[patch-disabled]" */
  readonly firm?: string | null;
}

export interface ClerkReviewDocument {
  /**
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly documentId?: number;
  title?: string;
  /** @format int32 */
  relatedDocumentId?: number | null;
  /** @format byte */
  originatingEvent?: number;
  /**
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly pages?: number | null;
  /** @format guid */
  filingTypeId?: string | null;
  /** @example "string --[patch-disabled]" */
  readonly filingType?: string;
  /** @format guid */
  reviewStatusId?: string | null;
  /** @example "string --[patch-disabled]" */
  readonly reviewStatus?: string;
  /** @format int32 */
  accessTypeId?: number | null;
  /** @example "string --[patch-disabled]" */
  readonly accessType?: string;
  /** @format int32 */
  judicialActionId?: number;
  /** @example "string --[patch-disabled]" */
  readonly judicialAction?: string;
  /**
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly redactedDocumentId?: number;
  /** @format decimal */
  statutoryFee?: number;
  readonly clerkReviewDocumentFees?: ClerkReviewDocumentFee[];
  /** @format guid */
  clerkStamp?: string | null;
  applyStampToAllPages?: boolean | null;
  /** @format date-time */
  reviewDate?: string;
  /** @format guid */
  sendToJudgeId?: string | null;
  /** @example "object --[patch-disabled]" */
  readonly sendToJudge?: CaseJudge | null;
  /** @format date-time */
  sendToJudgeDate?: string | null;
  /** @format date-time */
  judgeReviewedDate?: string | null;
  /** @format int32 */
  changeReason?: number | null;
  comments?: string | null;
  /** @format guid */
  subStatusId?: string | null;
  certificateSubmissionRejectionReason?: string | null;
  certificateSubmissionComments?: string | null;
  readonly customFields?: ClerkReviewCustomField[];
  /** @example "boolean --[patch-disabled]" */
  readonly showRedactDocumentLink?: boolean;
  readonly availableReviewStatuses?: ClerkReviewDocumentReviewStatus[];
  /** @example "boolean --[patch-disabled]" */
  readonly allowClerkToAssignJudge?: boolean;
  readonly availableDocumentJudgeReviewers?: CaseJudge[] | null;
  /** @example "object --[patch-disabled]" */
  readonly aiReview?: AIClerkReviewSummary | null;
  readonly additionalDataValues?: ClerkReviewAdditionalDataValue[];
}

export interface ClerkReviewDocumentFee {
  /**
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly feeTypeId?: string;
  /** @example "string --[patch-disabled]" */
  readonly feeType?: string;
  /** @format decimal */
  fee?: number | null;
  /** @example "boolean --[patch-disabled]" */
  readonly adjustable?: boolean;
}

export interface ClerkReviewCustomField {
  /** @example "string --[patch-disabled]" */
  readonly label?: string;
  /** @example "string --[patch-disabled]" */
  readonly caption?: string;
  /** @example "string --[patch-disabled]" */
  readonly type?: string;
  /**
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly length?: number;
  value?: string;
}

export interface ClerkReviewDocumentReviewStatus {
  /**
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly reviewStatusId?: string;
  /** @example "string --[patch-disabled]" */
  readonly reviewStatus?: string;
}

export interface AIClerkReviewSummary {
  passed?: boolean | null;
  results?: AIClerkReviewTestResult[];
}

export interface AIClerkReviewTestResult {
  ruleId?: string | null;
  description?: string | null;
  status?: string | null;
  reason?: string | null;
  /** @format double */
  confidence?: number | null;
  highlights?: AIClerkReviewHighlight[];
}

export interface AIClerkReviewHighlight {
  chunkId?: string | null;
  /** @format int32 */
  pageNumber?: number;
  boundingBox?: number[];
  content?: string | null;
}

export interface ClerkReviewAdditionalDataValue {
  key?: string | null;
  label?: string | null;
  value?: string | null;
  displayValue?: string | null;
}

export interface Error {
  /**
   * @deprecated
   * @format int64
   */
  id?: number | null;
  /**
   * @deprecated
   * @format guid
   */
  uniqueId?: string | null;
  domain?: ErrorDomain;
  code?: string;
  description?: string;
  data?: Record<string, any>;
}

/**
 * Full, uncapped SERVICE-role recipient list for a filing, returned by
 * GET clerk-review/filing/{id}/recipients and rendered by the read-only
 * "Transaction Recipients" sidecar. Deliberately slim (no SSN / DoB /
 * addresses / aliases) — the sidecar only needs display strings — so a large
 * service list is cheap to serialize and never materialized as reactive forms
 * on the client.
 */
export interface ClerkReviewRecipientsResponse {
  /** @format guid */
  filingUniqueId?: string;
  cases?: ClerkReviewRecipientsCase[];
}

export interface ClerkReviewRecipientsCase {
  /** @format guid */
  caseId?: string;
  /**
   * Distinct SERVICE party count for this case (matches the capped response).
   * @format int32
   */
  totalServiceRecipients?: number;
  /**
   * One row per attorney representation. Rows sharing PartyId + PartyTypeId are
   * the same recipient with multiple attorneys; the client groups them to show
   * the primary attorney with "(+N)" collapsed and every attorney expanded.
   */
  recipients?: ClerkReviewRecipient[];
}

export interface ClerkReviewRecipient {
  /** @format guid */
  partyId?: string;
  /** @format guid */
  partyTypeId?: string | null;
  partyName?: string | null;
  partyType?: string | null;
  attorneyName?: string | null;
  counselType?: string | null;
  /** Representation type — the attorney-type label (e.g. "Attorney in Charge"). */
  representationType?: string | null;
  firm?: string | null;
  attorneyBarNumber?: string | null;
}

/** @example [{"op":"replace","path":"/root/property","value":"new value"}] */
export type JsonPatchDocumentOfClerkReviewFiling = {
  /** The operation to be performed */
  op: "add" | "remove" | "replace" | "move" | "copy" | "test";
  /** JSON pointer to the property to modify */
  path: string;
  /** The value to set (for add, replace operations) */
  value?: any | null;
  /** JSON pointer to copy/move from (for copy, move operations) */
  from?: string | null;
}[];

export type OperationOfClerkReviewFiling = Operation & object;

export type Operation = OperationBase & {
  value?: any | null;
};

export interface OperationBase {
  operationType?: OperationType;
  path?: string | null;
  op?: string | null;
  from?: string | null;
}

export type IContractResolver = object;

/**
 * Response for clerk-review submission. Capture (if the court/case class requires it) runs
 * synchronously as part of submission, so by the time this responds, the filing's payment
 * status already reflects whatever happened — letting the client update its view without a
 * follow-up GET, which would otherwise fail once the filing is no longer reachable for review.
 */
export interface SubmitClerkReviewResult {
  /**
   * The filing's payment status right after submission, same shape as
   * Payment. Null when the filing never had (or needed) a
   * payment capture — not every filing does.
   */
  payment?: TransactionPayment | null;
}

export interface ClerkReviewFilingConfiguration {
  courtName?: string;
  /** @format int32 */
  courtId?: number;
  /** @format guid */
  courtUniqueId?: string;
  courtTimeZone?: string;
  showFilingComment?: boolean;
  canEditFilingComment?: boolean;
  showFinancialComment?: boolean;
  canEditFinancialComment?: boolean;
  showCalendarEvent?: boolean;
  canAddCalendarEvent?: boolean;
  isEServePossible?: boolean;
  showOtherTransactionData?: boolean;
  showRejectAllButton?: boolean;
  showAddCaseParticipant?: boolean;
  filedToCourt?: string;
  isMultiCase?: boolean | null;
  /** True when the filing's court case class is integrated */
  isIntegratedCaseClass?: boolean;
  deliveryStatus?: DeliveryStatusSummary | null;
  canEditFiling?: boolean;
  /**
   * True when another clerk currently holds the review lock on this filing. The filing is then
   * opened read-only: CanEditFiling and every CanEdit* flag are false, and writes
   * (patch, reset, submit) are still rejected with 423 by the API.
   */
  isLockedByOtherUser?: boolean;
  /** The clerk holding the review lock when IsLockedByOtherUser is true; otherwise null. */
  lockedByName?: PersonName | null;
  showSetCaseNumberButton?: boolean;
  showMultiplePrimaryJudges?: boolean;
  allowAcceptWithoutDocketing?: boolean;
  allowAcceptOfPreviouslyRejectedDocuments?: boolean;
  allowRejectOfPreviouslyAcceptedDocuments?: boolean;
  allowDelayingJudgeReview?: boolean;
  isDivisionRequired?: boolean;
  allowTombstoneOfDocuments?: boolean;
  allowChangingAccessTypeAfterReview?: boolean;
  /**
   * When true, the filing may contain more than one main (lead) document. Maps to
   * Court.MultiLeadDoc. When false the clerk may not leave the filing with more than one
   * main document, so the "Main Document" option is withheld from supporting documents.
   */
  allowMultipleLeadDocuments?: boolean;
  /**
   * The filing's court enables judge chambers (Court.EnableJudgeChambers), so its documents can show
   * chamber notes in clerk review.
   */
  isJudgeChambersEnabled?: boolean;
  /**
   * When true, the court permits deferred payment arrangements (Court.AllowPaymentDeferred),
   * so clerk review shows the "Filer has a deferred payment arrangement with the Court" checkbox.
   */
  allowPaymentDeferred?: boolean;
  opfPartyExtraFields?: boolean;
  showReviewedDate?: boolean;
  canEditReviewedDate?: boolean;
  showAccessType?: boolean;
  canEditAccessType?: boolean;
  showDocumentTitle?: boolean;
  canEditDocumentTitle?: boolean;
  showFilingType?: boolean;
  canEditFilingType?: boolean;
  showAlternateJudge?: boolean;
  canEditAlternateJudge?: boolean;
  showCaseName?: boolean;
  canEditCaseName?: boolean;
  showCaseNumber?: boolean;
  canEditCaseNumber?: boolean;
  showCaseType?: boolean;
  canEditCaseType?: boolean;
  showDivision?: boolean;
  canEditDivision?: boolean;
  showPrimaryJudge?: boolean;
  canEditPrimaryJudge?: boolean;
  showPartyAddress?: boolean;
  partyAddressRequired?: boolean;
  showPartyPhone?: boolean;
  partyPhoneRequired?: boolean;
  showPartyEmail?: boolean;
  partyEmailRequired?: boolean;
  showPartySocialSecurityNumber?: boolean;
  partySocialSecurityNumberRequired?: boolean;
  showPartyDateOfBirth?: boolean;
  partyDateOfBirthRequired?: boolean;
  enableAiClerkReview?: boolean;
  statutoryFee?: StatutoryFeeEditConfiguration;
  redactSealedDocuments?: RedactSealedDocumentsConfiguration;
  addressTypes?: DisplayFieldOfInteger[];
  partyEntities?: DisplayFieldOfInteger[];
  reasonsForChange?: DisplayFieldOfInteger[];
  divisionTypes?: DisplayFieldOfGuid[];
  courtJudges?: CaseJudge[];
  eventTypes?: DisplayFieldOfInteger[];
  courtClerkStamps?: CourtClerkStamp[];
  filingCourtCaseTypeConfigurations?: FilingCourtCaseTypeConfiguration[];
  filingCourtPartyTypeConfigurations?: FilingCourtPartyTypeConfiguration[];
  filingCourtCounselTypeConfigurations?: FilingCourtCounselTypeConfiguration[];
  filingCourtAliasTypeConfigurations?: FilingCourtAliasTypeConfiguration[];
  filingCourtAttorneyTypeConfigurations?: FilingCourtAttorneyTypeConfiguration[];
  filingAccessTypeConfigurations?: FilingAccessTypeConfiguration[];
  filingCourtFilingTypeConfigurations?: FilingCourtFilingTypeConfiguration[];
  /**
   * Escalation queues for this filing's current queue, highest priority first.
   * Empty when the filing cannot be escalated. The Escalate button is shown
   * only while this list has at least one entry.
   */
  escalationQueues?: ClerkReviewEscalationQueue[];
  /**
   * The filing's most recent escalation (reason, who, when); null when the filing
   * has never been escalated. Drives the ESCALATED banner in Clerk Review.
   */
  escalation?: ClerkReviewFilingEscalation | null;
}

export interface DisplayFieldOfInteger {
  name?: string;
  /** @format int32 */
  value?: number;
}

export interface DisplayFieldOfGuid {
  name?: string;
  /** @format guid */
  value?: string;
}

export interface FilingCourtCaseTypeConfiguration {
  caseType?: string;
  /** @format int32 */
  caseTypeId?: number;
  /** @format guid */
  caseTypeUniqueId?: string;
  ruleCheck?: string;
  additionalInfo?: string;
  isOpfInitiatingPartyOnly?: boolean;
  isAttestationFlow?: boolean;
  allowConfidentialParties?: boolean;
}

export interface FilingCourtPartyTypeConfiguration {
  partyType?: string;
  /** @format int32 */
  partyTypeId?: number;
  /** @format guid */
  partyTypeUniqueId?: string;
  filingCourtPartySubTypeConfigurations?: FilingCourtPartySubTypeConfiguration[];
}

export interface FilingCourtPartySubTypeConfiguration {
  partySubType?: string;
  /** @format int32 */
  partySubTypeId?: number;
  /** @format guid */
  partySubTypeUniqueId?: string;
}

export interface FilingCourtCounselTypeConfiguration {
  counselType?: string;
  /** @format int32 */
  counselTypeId?: number;
  /** @format guid */
  counselTypeUniqueId?: string;
  /** @format int32 */
  perPartyLimit?: number;
}

export interface FilingCourtAliasTypeConfiguration {
  aliasType?: string;
  /** @format int32 */
  aliasTypeId?: number;
  /** @format guid */
  aliasTypeUniqueId?: string;
}

export interface FilingCourtAttorneyTypeConfiguration {
  attorneyType?: string;
  /** @format int32 */
  attorneyTypeId?: number;
  attorneyTypeName?: string;
  /** @format guid */
  attorneyTypeUniqueId?: string;
  /** @format int32 */
  perPartyLimit?: number;
}

export interface FilingAccessTypeConfiguration {
  accessType?: string;
  /** @format int32 */
  accessTypeId?: number;
}

export interface FilingCourtFilingTypeConfiguration {
  filingType?: string;
  /** @format int32 */
  filingTypeId?: number;
  /** @format guid */
  filingTypeUniqueId?: string;
  /** @format decimal */
  totalFee?: number;
  eventType?: DocumentOriginatingEvent;
  alwaysBill?: boolean;
  useTemplateForm?: boolean;
  /** @format guid */
  templatedFormId?: string | null;
  isOpfRequired?: boolean;
  /** @format int32 */
  filingCategoryId?: number;
  filingTypeFilingOption?: FilingTypeFilingOption;
  documentFormatConfigurations?: DocumentFormatConfiguration[];
}

export interface DocumentFormatConfiguration {
  /** @format int32 */
  documentFormatId?: number;
  documentExtension?: string;
  isAccepted?: boolean;
  isDenied?: boolean;
}

/** An escalation queue the filing's current clerk-review queue can send a transaction to. */
export interface ClerkReviewEscalationQueue {
  /** @format guid */
  queueId?: string;
  description?: string;
  /** True when this queue's configuration requires an escalation reason. */
  requiresReason?: boolean;
}

/** The filing's most recent escalation, shown on the Clerk Review ESCALATED banner. */
export interface ClerkReviewFilingEscalation {
  /**
   * The reason entered when escalating. Empty when the escalation queue did not
   * require one and none was given.
   */
  reason?: string;
  /** The clerk who escalated the filing; null when that user no longer exists. */
  escalatedBy?: PersonName | null;
  /**
   * When the filing was escalated, as server (Eastern) wall-clock time with no offset,
   * the way FilingEscalations.EscalationDate stores it. Null when the row has no date.
   * @format date-time
   */
  escalationDate?: string | null;
}

/** Sends the filing under review to one of its current queue's escalation queues. */
export interface EscalateClerkReviewFilingRequest {
  /**
   * @format guid
   * @minLength 1
   */
  escalationQueueId: string;
  /**
   * Required when the selected queue's configuration requires a reason.
   * At most ReasonMaxLength characters.
   * @maxLength 500
   */
  escalationReason?: string | null;
}

export interface ErrorResponse {
  errors?: Error[];
}

export interface StampDocumentPreviewRequest {
  /** @format int32 */
  documentId?: number;
  /** @format guid */
  stampId?: string;
  applyToAll?: boolean;
}

export interface CaseClassList {
  /** @format int32 */
  caseClassId?: number;
  caseClassDesc?: string;
  /** @format guid */
  uniqueId?: string;
  isSelected?: boolean;
}

export interface CourtCaseClassSelected {
  /** @format int32 */
  caseClassId?: number;
  caseClassDesc?: string;
  /** @format guid */
  uniqueId?: string;
  isSelected?: boolean;
}

export interface NewCaseClassRequest {
  caseClassDesc?: string;
}

export interface AliasTypeList {
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  aliasTypeId?: number;
  aliasTypeDesc?: string;
  /** @format guid */
  uniqueId?: string;
  isSelected?: boolean;
}

export interface NewAliasTypeRequest {
  aliasTypeDesc?: string;
}

export interface CaseTypeList {
  /** @format int32 */
  caseClassId?: number | null;
  /** @format int32 */
  caseTypeId?: number;
  caseType?: string;
  /** @format guid */
  uniqueId?: string;
  isSelected?: boolean;
}

export interface CourtCaseTypeItem {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  caseTypeId?: number;
  ruleCheckSp?: string;
  additionalInfo?: string;
  allowSubscriberOnlineServiceOptOut?: boolean;
  allowNAUserOnlineServiceOptOut?: boolean;
  treatContingentUsersAsSubscribers?: boolean;
  masterCase?: boolean;
  opfInitiatingPartyOnly?: boolean;
  allowConfidentialParties?: boolean;
  caseNumberValidationExpression?: string;
  caseNumberFormatTip?: string;
  /** @format byte */
  allowSubFCaseEntry?: number;
  caseTypeDescription?: string;
  /** @format int32 */
  status?: number | null;
  /** @format int32 */
  masterCaseId?: number;
  masterCaseStyle?: string;
  caseClassAllowsAttestationFlow?: boolean;
  caseClassAllowsConfidentialParties?: boolean;
}

export interface CourtCaseTypeSelected {
  /** @format int32 */
  caseTypeId?: number;
  isSelected?: boolean;
}

export interface NewCaseTypeRequest {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  caseTypeId?: number;
  caseType?: string | null;
  caseTypeDescription?: string | null;
  /** @format date-time */
  beginDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** @format int32 */
  status?: number;
  additionalInfo?: string | null;
  masterCase?: boolean;
  /** @format byte */
  allowSubfCaseEntry?: number;
  treatContingentUsersAsSubscribers?: boolean;
  allowSubscriberOnlineServiceOptOut?: boolean;
  allowNAUserOnlineServiceOptOut?: boolean;
  caseOnlyBilling?: boolean;
  allowProposedCalendarEvent?: boolean;
  caseNumberValidationExpression?: string | null;
  caseNumberFormatTip?: string | null;
  supportsNumberOfCausesOfAction?: boolean;
  opfAllowed?: boolean;
  opfInitiatingPartyOnly?: boolean;
  isEfmEnabled?: boolean;
  allowConfidentialParties?: boolean;
}

export interface CaseFilingTypeList {
  /** @format int32 */
  filingTypeId?: number;
  filingTypeName?: string;
  filingTypeDesc?: string;
  /** @format guid */
  uniqueId?: string;
  isSelected?: boolean;
}

export interface CourtCaseFilingTypeList {
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  filingTypeId?: number;
  filingTypeName?: string;
  filingTypeDesc?: string;
  /** @format int32 */
  isOriginationEvent?: number;
  /** @format int32 */
  groupTransactionAccess?: number;
  /** @format int32 */
  judgeReview?: number;
  /** @format int32 */
  courtReviewStatus?: number;
  /** @format int32 */
  firmReviewStatus?: number;
  /** @format int32 */
  alwaysBill?: number;
  /** @format int32 */
  filingCategoryId?: number;
  /** @format int32 */
  filingCategoryName?: number;
  opfRequired?: boolean;
  useTemplatedForm?: boolean;
  /** @format guid */
  uniqueId?: string;
  isSelected?: boolean;
}

export interface NewCaseFilingTypeRequest {
  filingType?: string;
  filingTypeDescription?: string;
  /** @format date-time */
  beginDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  /** @format int32 */
  status?: number | null;
}

export interface PartyPartySubTypes {
  /** @format int32 */
  partyId?: number;
  partyDesc?: string;
  /** @format int32 */
  partySubTypeId?: number;
  partySubTypeDesc?: string;
}

export interface CaseClassCounselTypes {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  counselTypeId?: number;
  counselTypeDesc?: string;
}

export interface QueryResponseOfPartyTypeList {
  data?: PartyTypeList[];
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  skip?: number;
  /** @format int32 */
  take?: number;
  sortBy?: string;
  sortOrder?: string;
}

export interface PartyTypeList {
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  partyTypeId?: number;
  partyTypeDesc?: string;
  /** @format guid */
  uniqueId?: string;
  isSelected?: boolean;
}

export interface NewPartyTypeRequest {
  partyTypeDesc?: string;
}

export interface CourtDivisionList {
  /** @format int32 */
  divisionId?: number;
  divisionDesc?: string;
  /** @format guid */
  uniqueId?: string;
  isSelected?: boolean;
}

export interface NewDivisionRequest {
  divisionDesc?: string;
}

export interface QueryResponseOfAttorneyTypeList {
  data?: AttorneyTypeList[];
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  skip?: number;
  /** @format int32 */
  take?: number;
  sortBy?: string;
  sortOrder?: string;
}

export interface AttorneyTypeList {
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  attorneyTypeId?: number;
  attorneyTypeDesc?: string;
  /** @format guid */
  uniqueId?: string;
  isSelected?: boolean;
  isSelfRep?: boolean;
  isForm50?: boolean;
}

export interface NewAttorneyTypeRequest {
  attorneyTypeDesc?: string;
}

export interface JudicialActionList {
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  judicialActionId?: number;
  judicialActionDesc?: string;
  /** @format guid */
  uniqueId?: string;
  isSelected?: boolean;
}

export interface NewJudicialActionRequest {
  judicialActionDesc?: string;
}

export interface PartyEntityList {
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  partyEntityId?: number;
  partyEntityDesc?: string;
  isSelected?: boolean;
}

export interface NewPartyEntityRequest {
  partyEntityDesc?: string;
}

export interface ReasonCodeList {
  /** @format int32 */
  reasonCodeId?: number;
  reasonCodeIdDesc?: string;
  isSelected?: boolean;
}

export interface NewReasonRequest {
  reasonCodeDesc?: string;
}

export interface QueryResponseOfCaseClassFilingCategoryList {
  data?: CaseClassFilingCategoryList[];
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  skip?: number;
  /** @format int32 */
  take?: number;
  sortBy?: string;
  sortOrder?: string;
}

export interface CaseClassFilingCategoryList {
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  filingCategoryId?: number;
  filingCategoryDesc?: string;
  /** @format guid */
  uniqueId?: string;
  isSelected?: boolean;
}

export interface NewCaseClassFilingCategoryRequest {
  filingCategoryDesc?: string;
}

export interface CourtScheduleConfigDto {
  openingTime?: string;
  closingTime?: string;
  monday?: boolean;
  tuesday?: boolean;
  wednesday?: boolean;
  thursday?: boolean;
  friday?: boolean;
  saturday?: boolean;
  sunday?: boolean;
}

export type UpdateCourtScheduleConfigRequest = CourtScheduleConfigDto & object;

export interface CourtScheduleHolidayUpdateRequest {
  dates?: string[];
}

export interface CalendarEventTypesList {
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  calendarEventTypeId?: number;
  calendarEventTypeDesc?: string;
  isSelected?: boolean;
}

export interface NewCalendarEventTypeRequest {
  calendarEventTypeDesc?: string;
}

export interface CourtCaseAutoNumberDto {
  caseNumberPrefix?: string;
  /** @format int32 */
  nextCaseNumber?: number;
  caseNumberPostfix?: string;
}

export interface CourtFeeWaiverReasonDto {
  /** @format guid */
  orgId?: string;
  reason?: string;
}

export interface CourtCaseDocketEntryDto {
  /** @format guid */
  orgId?: string;
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  filingTypeId?: number | null;
  entryTitle?: string;
  canEnter?: boolean;
}

export interface CourtCRStampDto {
  storedPath?: string;
  stampDesc?: string;
  /** @format byte */
  isDefault?: number;
  /** @format int32 */
  overlayAlignment?: number | null;
  /** @format guid */
  uniqueId?: string;
}

export interface CourtPartyExtraFieldsConfigDto {
  /** @format int32 */
  caseTypeId?: number;
  caseType?: string;
  /** @format int32 */
  partyTypeId?: number;
  partyType?: string;
  /** @format byte */
  barNumber?: number;
}

export interface CCFilingTypeFeeItem {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  filingTypeId?: number;
  /** @format int32 */
  feeTypeId?: number;
  /** @format decimal */
  fee?: number | null;
  adjustable?: boolean;
}

export interface CCFilingTypeFeeSelected {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  filingTypeId?: number;
  /** @format int32 */
  feeTypeId?: number;
  /** @format decimal */
  fee?: number | null;
  adjustable?: boolean;
  isSelected?: boolean;
}

export interface NewFilingTypeFeeRequest {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  filingTypeId?: number;
  feeTypeId?: number;
  feeDescription?: string;
  /** @format decimal */
  feeAmount?: number;
  /** @format byte */
  status?: number;
  adjustable?: boolean;
}

export interface PartyCustomFieldDto {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  caseTypeId?: number;
  caseTypeDesc?: string;
  /** @format int32 */
  partyTypeId?: number;
  partyTypeDesc?: string;
  /** @format byte */
  barNumber?: number;
}

export interface CalendarEventSettingsDto {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  caseClassId?: number;
  /** @format int32 */
  adminId?: number;
  adminsIsUser?: boolean;
  adminIsOrg?: boolean;
  noneIsAdmin?: boolean;
  courtToolBoxCr?: boolean;
  courtToolboxNonCr?: boolean;
  courtOPF?: boolean;
  courtSubF?: boolean;
  firmCanCreate?: boolean;
  adminCreatorCanEdit?: boolean;
  orgCanEdit?: boolean;
  crCanEdit?: boolean;
  courtUserCanEdit?: boolean;
  anyoneCanEdit?: boolean;
  locationIsDivision?: boolean;
}

export interface CourtEditDto {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  courtLevelId?: number | null;
  /** @format int32 */
  courtDistrict?: number | null;
  /** @format int32 */
  crdaysInPending?: number | null;
  /** @format byte */
  abid?: number;
  /** @format int32 */
  crlockoutTime?: number | null;
  /** @format int32 */
  status?: number | null;
  /** @format byte */
  allowMaintenance?: number | null;
  caseValidationSp?: string;
  /** @format byte */
  uploadReplace?: number | null;
  /** @format int32 */
  serviceLevelId?: number;
  /** @format int32 */
  nsserviceMethodId?: number;
  /** @format byte */
  allowAddParty?: number;
  /** @format byte */
  clerkAddParty?: number;
  attFromFirmRepresented?: boolean;
  attFromFirmNewParty?: boolean;
  attOtherFirmUnrepresented?: boolean;
  attOtherFirmRepresented?: boolean;
  attOtherFirmNewParty?: boolean;
  attUnknownNewParty?: boolean;
  usmailServiceToProSe?: boolean;
  /** @format byte */
  allowDocPreview?: number;
  timeZone?: string;
  /** @format byte */
  usesDlstime?: number;
  addPartyMustCreateNew?: boolean;
  multiLeadDoc?: boolean;
  allowEserve?: boolean;
  /** @format byte */
  externalCr?: number;
  /** @format int32 */
  allowSelectMos?: number;
  forceEmailService?: boolean;
  forceDocsAttached?: boolean;
  /** @format byte */
  digSignDocuments?: number;
  allowFilerNote?: boolean;
  /** @format byte */
  efmservice?: number;
  /** @format int32 */
  maxDocFileByteCount?: number;
  /** @format int32 */
  maxTotalDocFileByteCount?: number;
  /** @format byte */
  docSuppressRule?: number;
  externalCrcredentials?: boolean;
  allowCourtesyCopies?: boolean;
  allowSelectDivision?: boolean;
  /** @format int32 */
  colorCode?: number;
  allowDocketNumbering?: boolean;
  allowLnfilingOverride?: boolean;
  /** @format int32 */
  pdfpageSizeId?: number;
  courtRulingFee?: boolean;
  allowFilerCourtesyCopies?: boolean;
  uploadReplaceAllowEditDt?: boolean;
  uploadReplaceAllowEditDocType?: boolean;
  uploadReplaceAllowEditDocTitle?: boolean;
  uploadReplaceAllowEditDocSec?: boolean;
  /** @format int32 */
  maxProposedJudgments?: number;
  docsMustBeCrstamped?: boolean;
  filePileId?: string;
  allowFilePile?: boolean;
  locked?: boolean;
  /** @format date-time */
  modifiedDate?: string;
  allowDefaultJudgeReview?: boolean;
  allowLinkToLowerCourt?: boolean;
  appendCaseListForMultiCaseFilings?: boolean;
  allowCourtUserToFastFile?: boolean;
  enableCourtScheduleFilingAdherence?: boolean;
  allowToDeleteFilingsPiorReview?: boolean;
  filingCompleteMessage?: string;
  courtOffline?: boolean;
  efmCode?: string;
  allowConfidentialFiling?: boolean;
  enableServiceOfProcess?: boolean;
  /** @format byte */
  filingCompleteMessageFlag?: number;
  trialBinderEnabled?: boolean;
  suppressPartyDetails?: boolean;
  rejectAsFiled?: boolean;
  doNotStampDocumentsInClerkReview?: boolean;
  removeRejectOptionCrstatus?: boolean;
  attorneyTypeLimitEnabled?: boolean;
  allowMultipleAddressTypesPerParty?: boolean;
  allowMultiAttorneyOpf?: boolean;
}

/** Court level settings a system admin edits from the court profile (dbo.Court). */
export interface CourtSettingsDto {
  /**
   * Judge Review opens the Judge Chambers page, and non-judges need active chamber membership for judge review
   * (Court.EnableJudgeChambers).
   */
  enableJudgeChambers?: boolean;
}

export interface DocumentAccessTypeDto {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  caseClassId?: number;
  /** @format byte */
  fileSealedDocument?: number;
  /** @format byte */
  inCameraFilings?: number;
  /** @format byte */
  allowConventionalDoc?: number;
  /** @format byte */
  allowSuppressedDoc?: number;
  /**
   * Who may assign In Chambers, electronic (0 = No One, 1 = Court Only, 2 = Anyone).
   * Nullable so a client that does not send it leaves the stored value unchanged.
   * @format byte
   */
  inChambersFilings?: number | null;
}

/**
 * One additional-data schema row configured for a court/case-class, as shown in the
 * court-profile admin surface. Each row corresponds to a CaseClassAdditionalDataConfig
 * record; the (CaseTypeId, Opf) pair is the row's specificity key — null values are the
 * broader fallback rows the filing read path resolves against.
 */
export interface CourtAdditionalDataSchemaItem {
  /** @format guid */
  id?: string;
  /**
   * External unique id of the case type this schema targets, or null when the row
   * applies to every case type in the case class.
   * @format guid
   */
  caseTypeId?: string | null;
  /**
   * Internal case type id — the identifier the court-config admin endpoints (and the
   * save request) key on. Null when the row applies to every case type.
   * @format int32
   */
  internalCaseTypeId?: number | null;
  caseTypeDescription?: string | null;
  /**
   * Filing-mode discriminator (SubF=0, OPF=1, AddCase=2, PaperFiling=3), or null when
   * the schema is shared across filing modes.
   * @format byte
   */
  opf?: number | null;
  /**
   * The connector that generated this schema (e.g. "JournalTechnologiesInc"), from the
   * schema payload itself. Connector-generated schemas are regenerated on every court
   * code-sync and must not be hand-edited.
   */
  connector?: string | null;
  /**
   * True when the schema's provenance is an integration connector (i.e. Connector is
   * set and not "Manual"). Provenance only — whether the admin editor may edit the row
   * is IsEditable, which is stored explicitly rather than inferred here.
   */
  isConnectorOwned?: boolean;
  /**
   * Whether the court-admin editor may edit this row. Stored on the row and set by the
   * writer (connector code-sync = false, schema editor = true); the editor gates on
   * this rather than on IsConnectorOwned.
   */
  isEditable?: boolean;
  /** @format int32 */
  version?: number | null;
  status?: string | null;
  /** @format date-time */
  createTimeUtc?: string | null;
  /**
   * UTC timestamp of the most recent write (connector regeneration or manual edit).
   * Null for rows never updated since creation.
   * @format date-time
   */
  updateTimeUtc?: string | null;
  /**
   * True when the stored SchemaJson could not be deserialized; Schema is
   * null in that case and the row needs investigation rather than display.
   */
  hasParseError?: boolean;
  schema?: FilingDraftAdditionalDataDefinition | null;
}

export interface FilingDraftAdditionalDataDefinition {
  kind?: FilingDraftAdditionalDataNodeKind;
  /** @format int32 */
  courtId?: number;
  connector: string;
  /** @format int32 */
  version: number;
  status: string;
  /**
   * Per filing/document type rules describing which document roles the connector allows for
   * this case class/type (FSX FilingTypeIds). Null or empty means "do not filter/validate";
   * when present, the client narrows each picker to the matching role and rejects a selection
   * used in a role it isn't allowed for.
   */
  documentTypeRules?: FilingDraftDocumentTypeRule[] | null;
  /**
   * Party types the connector recognizes for this court (FSX PartyTypeIds). Null or empty
   * means "do not filter".
   */
  allowedPartyTypeIds?: number[] | null;
  optionSources?: Record<string, FilingDraftAdditionalDataOptionSource>;
  forms?: FilingDraftAdditionalDataForm[];
}

/**
 * A single filing type's document-role eligibility. Lead = valid as the
 * initiating/lead document; Supporting = valid as a connected/supporting
 * document. A type may qualify for one, both, or (if listed) neither.
 */
export interface FilingDraftDocumentTypeRule {
  /** @format int32 */
  filingTypeId?: number;
  lead?: boolean;
  supporting?: boolean;
  /**
   * Display-ready role suffix for the document type label (e.g. " (Lead Only)"); null when the
   * type serves both roles. The client shows this verbatim.
   */
  suffix?: string | null;
}

export interface FilingDraftAdditionalDataOptionSource {
  kind: FilingDraftAdditionalDataOptionSourceKind;
  codeRef?: string | null;
  collectionRef?: string | null;
  required?: boolean;
  filter?: FilingDraftAdditionalDataOptionFilter | null;
  options?: FilingDraftAdditionalDataOption[] | null;
}

export interface FilingDraftAdditionalDataOptionFilter {
  excludeRoles?: string[] | null;
  partyTypeAllowListField?: string | null;
  partyTypeAllowLists?: Record<string, string[]> | null;
  /**
   * Restricts the collection to one side of the filing; null offers the whole case roster.
   * Sending is a membership test - a party the filing does not carry is not sent to the court.
   * Other is the inverse, for a role that points across the case.
   */
  partyScope?: FilingDraftAdditionalDataPartyScope | null;
  /**
   * Context field holding the group the filer chose. With GroupListRef, hides an
   * option the list assigns to a different group; an option the list does not mention belongs to
   * no group and stays offered.
   */
  groupField?: string | null;
  /**
   * A captured case list (case.lists.<name>) whose items map an option's key - for the
   * participant collection, the party's EfmId - to the group it belongs to.
   */
  groupListRef?: string | null;
}

export interface FilingDraftAdditionalDataOption {
  value: any;
  label: string;
  match?: Record<string, any[]> | null;
}

export interface FilingDraftAdditionalDataForm {
  kind?: FilingDraftAdditionalDataNodeKind;
  key: string;
  appliesTo: FilingDraftAdditionalDataFormScope;
  label: string;
  showWhen?: FilingDraftAdditionalDataCondition | null;
  fields?: FilingDraftAdditionalDataField[];
}

export interface FilingDraftAdditionalDataCondition {
  op: FilingDraftAdditionalDataConditionOp;
  field?: string | null;
  value?: any | null;
  values?: any[] | null;
  conditions?: FilingDraftAdditionalDataCondition[] | null;
  condition?: FilingDraftAdditionalDataCondition | null;
}

export interface FilingDraftAdditionalDataField {
  kind?: FilingDraftAdditionalDataNodeKind;
  key: string;
  type: FilingDraftAdditionalDataFieldType;
  label: string;
  codeRef?: string | null;
  format?: string | null;
  validation?: FilingDraftAdditionalDataValidation | null;
  showWhen?: FilingDraftAdditionalDataCondition | null;
  required?: boolean;
  requireWhen?: FilingDraftAdditionalDataCondition | null;
  selection?: FilingDraftAdditionalDataSelection | null;
  dependsOn?: string[] | null;
}

export interface FilingDraftAdditionalDataValidation {
  /** @format int32 */
  minLength?: number | null;
  /** @format int32 */
  maxLength?: number | null;
  /** @format double */
  min?: number | null;
  /** @format double */
  max?: number | null;
  /** @format double */
  multipleOf?: number | null;
  pattern?: string | null;
  enum?: string[] | null;
  message?: string | null;
}

export interface FilingDraftAdditionalDataSelection {
  mode: FilingDraftAdditionalDataSelectionMode;
  /** @format int32 */
  min?: number | null;
  /** @format int32 */
  max?: number | null;
  /** True = New-participant picker. False = existing participant picker. Null means unrestricted. */
  allowNew?: boolean | null;
  newItem?: FilingDraftAdditionalDataNewSelectionItem | null;
  itemFields?: FilingDraftAdditionalDataField[];
}

export interface FilingDraftAdditionalDataNewSelectionItem {
  codeRef?: string | null;
  allowedValues?: any[] | null;
  requiredFields?: FilingDraftAdditionalDataField[];
}

/**
 * Upsert request for one additional-data schema row. The (CaseTypeId, Opf) pair selects
 * the row's specificity: null CaseTypeId targets the whole case class, null Opf shares the
 * schema across filing modes. The court/case-class come from the route.
 */
export interface CourtAdditionalDataSchemaSaveRequest {
  /**
   * Internal case type id the schema targets, or null for a case-class-wide schema.
   * @format int32
   */
  caseTypeId?: number | null;
  /**
   * Filing-mode discriminator (SubF=0, OPF=1, AddCase=2, PaperFiling=3), or null to
   * share the schema across filing modes.
   * @format byte
   */
  opf?: number | null;
  schema: FilingDraftAdditionalDataDefinition;
}

export interface LockTimeoutCRFilingDto {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  caseClassId?: number;
  /** @format byte */
  allowAddParty?: number;
  /** @format int32 */
  crLockoutTime?: number;
  /** @format int32 */
  crDaysInPending?: number;
  /** @format byte */
  opfCaseName?: number;
  /** @format byte */
  opfCaseNumber?: number;
  /** @format byte */
  opfCaseType?: number;
  /** @format byte */
  opfDivision?: number;
  divisionRequired?: boolean;
}

export interface ListResponseOfState {
  data?: State[];
}

export interface State {
  /** The Code ID of the State */
  code?: string;
  /** The name of the Stae */
  name?: string | null;
}

export interface CourtItem {
  /** @format int32 */
  id?: number;
  /** @format guid */
  uniqueId?: string;
  name?: string;
  state?: string;
}

export interface ListResponseOfUserItem {
  data?: UserItem[];
}

export interface UserItem {
  /** @format int32 */
  id?: number;
  /** @format guid */
  uniqueId?: string;
  name?: string;
}

export interface CaseLoadItem {
  /** @format int32 */
  uploadId?: number;
  fileName?: string;
  uploadType?: string;
}

export interface CaseLoadRequest {
  fileName?: string;
  uploadType?: string;
}

export interface CourtInfo {
  /** @format guid */
  orgId?: string;
  name?: string;
  /** @format int32 */
  courtLevelId?: number;
  isAppellateCourt?: boolean;
}

/**
 * Live e-filing availability for a court. Deliberately served on its own endpoint rather than
 * inside the (server-cached) filing configuration payload: a court can be taken offline or
 * brought back online at any moment, so callers re-read this each time they need it.
 */
export interface CourtOnlineStatus {
  /**
   * False when the court is offline (Court.CourtOffline) and cannot accept e-filings
   * or process judge reviews.
   */
  isOnline?: boolean;
}

export interface CaseClassInfo {
  /** @format int32 */
  id?: number;
  allowMultiplePrimaryJudges?: boolean;
}

export interface CaseStatus {
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface CaseClass {
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface ListResponseOfDocumentType {
  data?: DocumentType[];
}

export interface DocumentType {
  /** @format int32 */
  id?: number;
  name?: string;
  /** @format decimal */
  totalFee?: number;
  /** @format int32 */
  isOriginatingEvent?: number;
  isOriginatingEventDesc?: string;
  /** @format int32 */
  groupFilingAccess?: number | null;
  groupFilingAccessDesc?: string;
  /** @format int32 */
  judgeReview?: number;
  judgeReviewDesc?: string;
}

export interface CaseType {
  /** @format int32 */
  id?: number;
  name?: string;
  additionalInfo?: string | null;
  caseNumberValidationExpression?: string | null;
  caseNumberFormatTip?: string | null;
}

export interface Division {
  /** @format guid */
  orgId?: string;
  /** @format int32 */
  divisionId?: number;
  divisionDesc?: string;
  division1?: string;
}

export interface Judge {
  /** @format int32 */
  id?: number;
  name?: string;
  /** @format guid */
  orgId?: string;
  organizationName?: string;
  isAJudgeOfTheCourt?: boolean;
  /** @format guid */
  uniqueId?: string;
}

export interface Clerk {
  /** @format int32 */
  id?: number;
  name?: string;
  /** @format guid */
  orgId?: string;
  organizationName?: string;
  isAClerkOfTheCourt?: boolean;
}

export interface PartyType {
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface PartyStatus {
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface AttorneyType {
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface CaseManagementCourtCatalogs {
  courts?: CourtItem[];
  caseStatuses?: CaseStatus[];
  caseClasses?: CaseClass[];
  divisions?: Division[];
  judges?: Judge[];
  clerks?: Clerk[];
  partyTypes?: PartyType[];
  partyStatuses?: PartyStatus[];
  attorneyTypes?: AttorneyType[];
  addressTypes?: AddressType[];
  phoneTypes?: PhoneType[];
  states?: State[];
}

export interface AddressType {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export interface PhoneType {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

/**
 * An attorney from the Case & Party Management attorney search (courts/{orgId}/attorneys).
 * Id is the attorney's user ID, which the participants-by-attorney route and
 * Id expect back.
 */
export interface CourtAttorney {
  /** @format int32 */
  id?: number;
  name?: string | null;
  /** @format guid */
  orgId?: string;
  organizationName?: string | null;
  barNumber?: string | null;
}

export interface ListResponseOfCourtItem {
  data?: CourtItem[];
}

export interface ListResponseOfCourtHouseItem {
  data?: CourtHouseItem[];
}

export interface CourtHouseItem {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export interface CourtHouseRequest {
  name?: string | null;
  stateCode?: string | null;
}

export interface CourtHouseResult {
  /** @format int32 */
  id?: number;
  name?: string | null;
  stateCode?: string | null;
  courtAssociates?: CourtAssociate[] | null;
}

export interface CourtAssociate {
  /** @format int32 */
  courtId?: number;
  courtName?: string;
}

export interface CourtPersonnel {
  /** @format int32 */
  userId?: number;
  /** @format guid */
  orgId?: string;
  name?: string | null;
  typeId?: string | null;
  type?: string | null;
}

export interface CourtPersonnelCase {
  /** @format int32 */
  caseId?: number;
  caseNumber?: string | null;
  caseName?: string | null;
  /** @format guid */
  orgId?: string;
  courtName?: string | null;
  /** @format int32 */
  caseClassId?: number;
  caseClassName?: string | null;
  /** @format int32 */
  caseTypeId?: number;
  isMasterCase?: boolean;
  caseTypeName?: string | null;
  userStatus?: string | null;
  /** @format int32 */
  userStatusId?: number | null;
  userTypeId?: string | null;
}

export interface CaseCourtPersonnel {
  /** @format int32 */
  userId?: number;
  /** @format int32 */
  caseId?: number;
  /** @format guid */
  orgId?: string;
  name?: string | null;
  type?: string | null;
}

export interface AddCourtPersonalToCaseBatch {
  caseIds?: number[];
  personal?: CourtPersonnel | null;
}

export interface QueuePersonnelInfo {
  /** @format int32 */
  entryId?: number;
  /** @format int32 */
  requestUserId?: number;
  requestUser?: string;
  requestOrganization?: string;
  /** @format date-time */
  dateEntered?: string;
  /** @format int32 */
  status?: number;
  caseName?: string | null;
  caseNumber?: string | null;
  /** @format guid */
  orgId?: string;
  courtName?: string;
  /** @format int32 */
  userId?: number;
  userName?: string;
  /** @format int32 */
  newParticipantStatusId?: number;
  newParticipantStatus?: string;
  /** @format int32 */
  newParticipantTypeId?: number | null;
}

export interface DocumentHistoryResponse {
  filingInfo?: DocumentHistoryFilingInfo;
  historyItems?: ListRequestOfDocumentHistoryItem;
}

export interface DocumentHistoryFilingInfo {
  /** @format int32 */
  filingId?: number;
  filerName?: string;
  filerOrganization?: string;
  authorizerName?: string;
  authorizerOrganization?: string;
  filingOption?: FilingOptionId;
  courtName?: string;
  divisionName?: string;
  caseClass?: string;
  caseType?: string;
  caseNumber?: string;
  caseName?: string;
  /** @format date-time */
  authorizedDate?: string;
  primaryJudgeName?: string | null;
  alternateJudgeName?: string | null;
}

export interface ListRequestOfDocumentHistoryItem {
  data?: DocumentHistoryItem[];
}

export interface DocumentHistoryItem {
  /** @format date-time */
  submitDate?: string | null;
  reviewStatus?: string;
  /** The judicial action recorded on this history row (e.g. "Granted"), or empty when none. */
  judicialAction?: string;
  reviewer?: string;
  reason?: string;
  comment?: string;
  documentType?: string;
  documentTitle?: string;
  accessType?: string;
  statutoryFee?: string;
}

/** A user an admin is permitted to emulate — shown in the emulation target picker. */
export interface EmulatableUser {
  /** @format guid */
  userUniqueId?: string;
  fullName?: string;
  email?: string | null;
  loginName?: string | null;
  organizationName?: string;
  userType?: string;
}

/**
 * The effective identity of an emulated user, returned so the client can overlay the target's
 * context (id, org, type) into its identity state while emulation is active.
 */
export interface EmulatedProfile {
  /** @format guid */
  userUniqueId?: string;
  /** @format guid */
  organizationUniqueId?: string;
  organizationName?: string;
  userType?: string;
  /** @format int32 */
  groupId?: number;
  fullName?: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

export interface ErrorCodeDefinition {
  code?: string;
  description?: string;
  metaDataTypes?: ErrorCodeMetaDataType[];
}

export interface FilingDashboardStateCourts {
  /** State details */
  state?: State;
  /** List of Courts in the State */
  courts?: FilingDashboardCourt[];
}

export interface FilingDashboardCourt {
  /**
   * Court's Organization GUID ID
   * @format guid
   */
  organizationId?: string;
  /** Court's Organization Name */
  organizationName?: string;
  /** The user has access to see filings and the related cases in the given court */
  accessFilings?: boolean;
  /** The user has access to file and serve in the given court */
  accessFileAndServe?: boolean;
}

/** Response wrapper for the rejected filings query. */
export type RejectedFilingsQueryResponse = QueryResponseOfRejectedFilingItem &
  object;

export interface QueryResponseOfRejectedFilingItem {
  data?: RejectedFilingItem[];
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  skip?: number;
  /** @format int32 */
  take?: number;
  sortBy?: string;
  sortOrder?: string;
}

/**
 * A rejected filing (transaction) with its rejected documents.
 * Refactored from the legacy FilingRejected* stored procedure results.
 */
export interface RejectedFilingItem {
  /**
   * The filing id (displayed as the Transaction ID / TID).
   * @format int32
   */
  transactionId?: number;
  /**
   * The filing's unique (GUID) id, used for navigation (e.g. the
   * transaction view sidecar). Display still uses TransactionId.
   * @format guid
   */
  filingUniqueId?: string;
  /**
   * The case id (0 for multi-case filings).
   * @format int32
   */
  caseId?: number;
  /**
   * The case's unique (GUID) id, used to open the case-information sidecar.
   * Null for multi-case filings.
   * @format guid
   */
  caseUniqueId?: string | null;
  /** The case number ("Multi-Case" for multi-case filings). */
  caseNumber?: string | null;
  /** The case caption / style. */
  caseName?: string | null;
  /** The court's display name. */
  courtName?: string | null;
  /**
   * The court's organization id.
   * @format int32
   */
  courtId?: number;
  /**
   * The court's organization unique (GUID) id, used by the front end to start a
   *             filing on the case.
   * @format guid
   */
  courtOrgId?: string | null;
  /** The court's time zone; these values are read from the custom timezone abbreviations in the Court table */
  courtTimeZone?: string | null;
  /**
   * When the filing was authorized / submitted (the date shown as "Submitted").
   * This is also the date the DaysBack filter applies to.
   * @format date-time
   */
  submittedDate?: string | null;
  /**
   * When the filing was reviewed and rejected (the date shown as "Rejected").
   * @format date-time
   */
  rejectedDate?: string | null;
  /** The name of the user that submitted the filing. */
  submittedBy?: string | null;
  /** The organization of the submitter. */
  submittedByOrganization?: string | null;
  /** The authorizing attorney's name. */
  authorizer?: string | null;
  /** Whether the current user has read this rejected item. */
  read?: boolean;
  /** The rejected documents on this filing. */
  documents?: RejectedFilingDocument[];
}

/** A rejected document within a rejected filing. */
export interface RejectedFilingDocument {
  /**
   * The document id.
   * @format int32
   */
  documentId?: number;
  /** The document title. */
  title?: string | null;
  /** The filing type of the document. */
  filingType?: string | null;
  /** The review status text for the document (displayed as the rejection reason). */
  reviewStatus?: string | null;
  /**
   * The clerk's comment entered when rejecting this document (plain text; may contain line breaks).
   * Null when the clerk left no comment.
   */
  clerkNote?: string | null;
  /**
   * The rejection reason the clerk picked from the court's reason list, if any.
   * Legacy shows it ahead of the comment ("Rejection Reason(s): {reason}. {comment}").
   */
  clerkReason?: string | null;
}

/**
 * Query request for the rejected filings list.
 * Defaults match the attorney dashboard section (unread, last 7 days);
 * the full-page Rejected Items list widens these to the legacy filter ranges.
 */
export interface RejectedFilingsQueryRequest {
  /**
   * How many days back (from now) to include, based on the filing's authorized date.
   * Legacy allowed 7-120 days.
   * @format int32
   * @min 1
   * @max 36500
   * @default 7
   */
  daysBack?: number;
  /**
   * Read-state filter. Defaults to unread (dashboard semantics).
   * @default "Unread"
   */
  readStatus?: RejectedFilingReadStatus;
  /**
   * Whether to include supporting documents (attachments) alongside the main
   * documents of each rejected filing.
   * Legacy: WithDocs (true) vs WithMainDocs (false) stored procedures.
   */
  withAttachments?: boolean;
  /**
   * Optional filter to a single case.
   * @format int32
   */
  caseId?: number | null;
  /**
   * Items to skip.
   * @format int32
   * @min 0
   * @max 2147483647
   */
  skip?: number;
  /**
   * Items to take.
   * @format int32
   * @min 1
   * @max 250
   */
  take?: number;
  /** Whether to include the total (post-filter) transaction count in the response. */
  includeTotal?: boolean;
}

/** Payload for setting the read state of a rejected filing. */
export interface SetReadStateRequest {
  /** True to mark read; false to mark unread. */
  read?: boolean;
}

/**
 * The result of resolving a transaction id (numeric TID) to the filing's
 * unique (guid) id used for navigation.
 */
export interface TransactionLookupResult {
  /**
   * The transaction id (legacy numeric FilingID) that was looked up.
   * @format int32
   */
  transactionId?: number;
  /**
   * The filing's unique (guid) id.
   * @format guid
   */
  filingUniqueId?: string;
}

/** Response to the Attorneys query, includes the list of attorneys and the count of total distinct cases */
export interface DashboardAttorneyResponse {
  data?: DashboardAttorney[];
  /** @format int32 */
  distinctCaseCount?: number;
}

/**
 * An attorney (or other tracked personnel) in the current user's firm,
 * with their active case count and favorite (tracked) flag.
 * Refactored from the legacy GetCourtPersonnel / GetCourtPersonnelAssigned stored procedures.
 */
export interface DashboardAttorney {
  /**
   * The attorney's user id.
   * @format int32
   */
  userId?: number;
  /** The attorney's name. */
  name?: PersonName | null;
  /**
   * The number of active cases the attorney participates in.
   * @format int32
   */
  activeCaseCount?: number;
  /** Whether the current user has favorited (tracks) this attorney. */
  isFavorite?: boolean;
}

/** Query request for the active case list (server-paged). */
export interface ActiveCasesQueryRequest {
  /**
   * Optional filter to a single attorney's cases.
   * When null, cases for all of the firm's attorneys are returned.
   * @format int32
   */
  attorneyUserId?: number | null;
  /** Optional text filter applied to case number, caption, and court name. */
  search?: string | null;
  /**
   * Items to skip.
   * @format int32
   * @min 0
   * @max 2147483647
   */
  skip?: number;
  /**
   * Items to take.
   * @format int32
   * @min 1
   * @max 250
   */
  take?: number;
  /** Whether to include the total (post-filter) case count in the response. */
  includeTotal?: boolean;
}

/** Response wrapper for the Inbox query. */
export type InboxQueryResponse = QueryResponseOfInboxItem & object;

export interface QueryResponseOfInboxItem {
  data?: InboxItem[];
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  skip?: number;
  /** @format int32 */
  take?: number;
  sortBy?: string;
  sortOrder?: string;
}

/** An Inbox filing (served on / forwarded to the current user). */
export type InboxItem = MailboxItem & {
  userRole?: string | null;
};

/**
 * A mailbox filing (transaction) with its documents.
 * Base type shared by InboxItem and SentItem.
 */
export interface MailboxItem {
  /**
   * The filing id (displayed as the Transaction ID / TID).
   * @format int32
   */
  transactionId?: number;
  /**
   * The filing's unique (GUID) id, used for navigation (e.g. the
   * transaction view sidecar). Display still uses TransactionId.
   * @format guid
   */
  filingUniqueId?: string;
  /**
   * The case id (0 for multi-case filings).
   * @format int32
   */
  caseId?: number;
  /**
   * The case's unique (GUID) id, used to open the case-information sidecar.
   * Null for multi-case filings.
   * @format guid
   */
  caseUniqueId?: string | null;
  /** The case number ("Multi-Case" for multi-case filings). */
  caseNumber?: string | null;
  /** The case caption / style. */
  caseName?: string | null;
  /** The court's display name. */
  courtName?: string | null;
  /**
   * The court's organization id.
   * @format int32
   */
  courtId?: number;
  /** The court's time zone; these values are read from the custom timezone abbreviations in the Court table */
  courtTimeZone?: string | null;
  /**
   * When the filing was sent (the date shown in the list).
   * @format date-time
   */
  sentDate?: string | null;
  /** The name of the user that submitted the filing. */
  submittedBy?: string | null;
  /** The organization of the submitter. */
  submittedByOrganization?: string | null;
  /** The authorizing attorney's name. */
  authorizer?: string | null;
  /** The authorizing attorney's organization (shown as "Authorizer / Organization"). */
  authorizerOrganization?: string | null;
  /** The clerk review status text for the filing (shown in the Clerk Review Status column). */
  clerkReviewStatus?: string | null;
  /** Whether the current user has read this item. */
  read?: boolean;
  /** The documents on this filing. */
  documents?: MailboxDocument[];
}

/** A document within a mailbox filing. */
export interface MailboxDocument {
  /**
   * The document id.
   * @format int32
   */
  documentId?: number;
  /** The document title. */
  title?: string | null;
  /** The filing type of the document (shown in the Document Type column). */
  filingType?: string | null;
  /** The clerk review status text for the document. */
  reviewStatus?: string | null;
  /**
   * The document size in bytes (shown in the Size column).
   * @format int64
   */
  sizeBytes?: number;
}

/**
 * Query request for the Inbox list (filings served on / forwarded to the user).
 * Ported from the legacy DisplayFilingList.aspx (go=inbox) filters.
 */
export interface InboxQueryRequest {
  /**
   * How many days back (from now) to include, based on the filing's sent date.
   * Legacy allowed 7-120 days.
   * @format int32
   * @min 1
   * @max 36500
   * @default 7
   */
  daysBack?: number;
  /**
   * Read-state filter. Defaults to unread (legacy Inbox default).
   * @default "Unread"
   */
  readStatus?: MailboxReadStatus;
  /**
   * Whether to include filings whose only documents are attachments.
   * Legacy: WithDocs (true) vs WithMainDocs (false) stored procedures.
   */
  withAttachments?: boolean;
  /**
   * Optional filter to a single case (legacy ByCase procedures).
   * @format int32
   */
  caseId?: number | null;
  /**
   * Optional filter to a case group (legacy ByCaseGroup procedures).
   * @format int32
   */
  caseGroupId?: number | null;
  /**
   * Items to skip.
   * @format int32
   * @min 0
   * @max 2147483647
   */
  skip?: number;
  /**
   * Items to take.
   * @format int32
   * @min 1
   * @max 250
   */
  take?: number;
  /** Whether to include the total (post-filter) transaction count in the response. */
  includeTotal?: boolean;
}

export interface FilingFeeSummary {
  lineItems?: FeeLineItem[];
  /** @format decimal */
  subtotal?: number;
  /** @format decimal */
  tax?: number;
  /** @format decimal */
  total?: number;
}

export interface FeeLineItem {
  description?: string;
  /** @format decimal */
  amount?: number;
  isStatutoryFee?: boolean;
  isCourtFee?: boolean;
  /** @format decimal */
  tax?: number;
}

export interface FilingDraft {
  /**
   * The GUID used to refer to this draft filing (read only)
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly filingId?: string;
  /** How a filing will be submitted-- File, Serve, FileAndServe */
  fileToCourt?: FileToCourt;
  /**
   * The mode of the filing-- OPF, SubF (read only)
   * @example "string --[patch-disabled]"
   */
  readonly filingModeId?: FilingMode;
  /**
   * The GUID identifying the court (the court's organization GUID) being filed into (read only)
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly courtId?: string;
  /**
   * The State Code that the court is in (read only)
   * @example "string --[patch-disabled]"
   */
  readonly courtStateCode?: string;
  /**
   * The name of the court being filed into (read only)
   * @example "string --[patch-disabled]"
   */
  readonly courtName?: string;
  /**
   * The Case Class of the filing (read only)
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly caseClassId?: string;
  /**
   * Whether this FilingDraft has been submitted (read only)
   * @example "boolean --[patch-disabled]"
   */
  readonly hasBeenSubmitted?: boolean;
  /**
   * The name of the Case Class being filed into (read only)
   * @example "string --[patch-disabled]"
   */
  readonly caseClassName?: string;
  /**
   * The Case Type of the filing (read only); note that for multiCase filings, cases may have different FilingTypes - this field is set to the first case's
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly caseTypeId?: string;
  /**
   * The name of the Case Type being filed into (read only)
   * @example "string --[patch-disabled]"
   */
  readonly caseTypeName?: string;
  /**
   * The date/time the draft was created (read only)
   * @format date-time
   * @example "date-time --[patch-disabled]"
   */
  readonly dateCreated?: string;
  /**
   * For courts with division, the division being filed into
   * @format guid
   */
  divisionId?: string | null;
  /**
   * For courts with division, the name of the division being filed into (read only)
   * @example "string --[patch-disabled]"
   */
  readonly divisionName?: string | null;
  /**
   * User GUID identifying the Filer
   * @format guid
   */
  filerId?: string | null;
  /**
   * User details for the Filer (read only; will be populated based on FilerId)
   * @example "object --[patch-disabled]"
   */
  readonly filerUserDetails?: FilingDraftUserDetails | null;
  /**
   * User GUID identifying the Authorizer
   * @format guid
   */
  authorizerId?: string | null;
  /**
   * User details for the Authorizer (read only; will be populated based on AuthorizerId)
   * @example "object --[patch-disabled]"
   */
  readonly authorizerUserDetails?: FilingDraftUserDetails | null;
  /** The list of cases associated with this filing */
  cases?: FilingDraftCase[];
  /** The list of documents associated with this filing */
  documents?: FilingDraftDocument[];
  /** The list of sending parties associated with this filing */
  sendingParties?: FilingDraftParty[];
  /** The list of service parties associated with this filing */
  serviceParties?: FilingDraftParty[];
  /** The list of additional recipient parties associated with this filing */
  additionalRecipients?: FilingDraftAdditionalRecipient[];
  /** Additional data values collected from filing-specific schema fields */
  additionalData?: FilingDraftAdditionalData;
  /** The list of attorneys associated with this filing */
  attorneys?: FilingDraftAttorney[];
  /** A mapping from attorneys to the parties they represent */
  attorneyToPartyMappings?: FilingDraftAttorneyToPartyMapping[];
  /**
   * If filer is requesting a fee waiver, the ID of the fee waiver reason
   * @format int32
   */
  feeWaiverReasonId?: number | null;
  /**
   * If filer is requesting a fee waiver, the description of the fee waiver (read only)
   * @example "string --[patch-disabled]"
   */
  readonly feeWaiverReasonComment?: string | null;
  /**
   * Billing Reference string for the filing
   *
   */
  billingReference?: string | null;
  /**
   * Note To Clerk string for the filing
   *
   */
  noteToClerk?: string | null;
  /**
   * True when the filer has declared a deferred payment arrangement with the court for this
   * filing. Only offered when the court sets Court.AllowPaymentDeferred; defaults from
   * the filer organization's OrganizationDeferred row but remains filer-editable.
   * Flows to the FilingXML PaymentDeferred attribute and Filing.PaymentDeferred.
   * Null means the filer has not answered yet, so the client applies the organization default;
   * an explicit false must survive a revisit, which is why this is nullable rather than bool.
   */
  paymentDeferred?: boolean | null;
  /**
   * If filing is scheduled to be submitted, the date of the submission
   * @format date-time
   */
  scheduledDate?: string | null;
  /** If the filer wants to send a Courtesy Copy of the filing to a Court User (typically a judge) */
  courtesyCopy?: FilingDraftCourtesyCopy | null;
  /** Validation errors associated with this filing. The draft can not be submitted until all errors are resolved (read only) */
  readonly validationErrors?: Error[];
  /**
   * Payment information for this filing. SelectedPaymentMethodId is patchable (user selects their card);
   * Methods and their Attempts are managed exclusively by the backend and must not be patched directly.
   */
  payment?: FilingDraftPayment | null;
}

/** User Details to include in a filing draft; this class is intended to be read-only, populated from the User database record */
export interface FilingDraftUserDetails {
  /**
   * User's GUID
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly userId?: string;
  /**
   * User's Organization's GUID
   *
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly organizationId?: string;
  /**
   * Name of the user
   * @example "object --[patch-disabled]"
   */
  readonly name?: PersonName;
  /**
   * Name of the user's organization
   * @example "string --[patch-disabled]"
   */
  readonly organizationName?: string;
  /**
   * User's default phone number
   * @example "string --[patch-disabled]"
   */
  readonly phone?: string | null;
  /**
   * User's default email address
   * @example "string --[patch-disabled]"
   */
  readonly email?: string | null;
}

export interface FilingDraftCase {
  /**
   * The GUID of an existing case, if this is a SubF filing. Null, for OPF filings
   * @format guid
   */
  caseId?: string | null;
  /** The Case Name or proposed Case Name; for existing cases (CaseId != null), this value will be overwritten by the CaseName stored in the DB */
  caseName?: string | null;
  /**
   * The Case Number, if filing is to an existing case (read only)
   * @example "string --[patch-disabled]"
   */
  readonly caseNumber?: string | null;
  /**
   * The Unique ID of this case's CaseType
   *
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly caseTypeId?: string | null;
  /**
   * The Name of this case's CaseType
   * @example "string --[patch-disabled]"
   */
  readonly caseTypeName?: string;
}

export interface FilingDraftDocument {
  /**
   * ID to be used to refer to this document within the filing, set by client. Number is per-filing. Must be unique within the filing
   * @format int32
   */
  documentId?: number;
  /**
   * Stable per-document identifier minted by the client at row creation and echoed back unchanged.
   * Unique within the filing; used only to keep the UI and API in sync (correlation + dedupe) while
   * the draft is edited. Draft-lifetime only — not persisted to FilingXml/JCMS at submit.
   * @format guid
   */
  clientUniqueId?: string | null;
  /**
   * The FilingType of the document
   * @format guid
   */
  filingTypeId?: string | null;
  /**
   * The name of the document's FilingType (read only)
   * @example "string --[patch-disabled]"
   */
  readonly filingTypeName?: string | null;
  /**
   * The AccessType of the document
   * @format int32
   */
  accessTypeId?: number | null;
  /**
   * The name of the document's AccessType (read only)
   * @example "string --[patch-disabled]"
   */
  readonly accessTypeName?: string | null;
  /** Whether this document is the originating event */
  originatingEvent?: boolean | null;
  /**
   * Filing category GUID, if applicable
   * @format guid
   */
  filingCategoryId?: string | null;
  /**
   * Filing category name, if applicable (read only)
   * @example "string --[patch-disabled]"
   */
  readonly filingCategoryName?: string | null;
  /** The document's title */
  documentTitle?: string | null;
  /** The original document name on the uploader's computer */
  originalFileName?: string | null;
  /**
   * Document Upload URI.
   * @format uri
   */
  documentUploadUri?: string | null;
  /**
   * DocumentStore document ID GUID TODO: do we need this?
   * @format guid
   */
  documentStoreDocumentId?: string | null;
  /**
   * The format of the document (docx, pdf, etc)
   * @format int32
   */
  documentFormatId?: number | null;
  /**
   * Whether the document is ready for submission, as reported by DocStore (read only)
   * @example "boolean --[patch-disabled]"
   */
  readonly isReady?: boolean | null;
  /**
   * Document byte size, as reported by DocStore (read only)
   * @format int64
   * @example "int64 --[patch-disabled]"
   */
  readonly documentByteCount?: number | null;
  /**
   * Document page count, as reported by DocStore (read only)
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly documentPageCount?: number | null;
  /** Visible error message from DocStore. Read-only. */
  docStoreError?: string | null;
  /**
   * Statutory fee for this document (read only)
   * @format decimal
   * @example "decimal --[patch-disabled]"
   */
  readonly documentStatutoryFee?: number | null;
  /**
   * If document is a templated form, GUID for the form
   * @format guid
   */
  templatedFormId?: string | null;
  /**
   * If document is a templated form, GUID for the form data
   * @format guid
   */
  templateDataId?: string | null;
  /**
   * Sort Order, for use by the UI to maintain consistent sorting
   * @format int32
   */
  sortOrder?: number | null;
  /**
   * If document is a supporting document, this is the ID of the document it supports
   * @format int32
   */
  mainDocumentId?: number | null;
  /** A list of linked documents */
  linkedDocumentIds?: number[];
}

export interface FilingDraftParty {
  /**
   * Party ID to refer to this party within the filing, set by client. Both new parties and existing parties should have a unique ID
   * @format int32
   */
  partyId?: number;
  /** EfmId is the ID of the party in C-Track. This is only used when a Form50Agent does a filing on behalf of a party that is already in C-Track. */
  efmId?: string | null;
  /**
   * If party is an existing party on the case, their GUID ID
   * @format guid
   */
  existingPartyId?: string | null;
  /** Whether this is a confidential party */
  confidential?: boolean | null;
  /**
   * Party Entity Type (individual, organization)
   * @format int32
   */
  entityTypeId?: number | null;
  /** The PersonName for the party. Organizations use the LastName field only */
  partyName?: PersonName | null;
  /**
   * The party's date of birth
   * @format date-time
   */
  dateOfBirth?: string | null;
  /** The party's social security number */
  ssn?: string | null;
  /** A list of addresses belonging to the party. Each address must have a unique address type */
  addresses?: Address[];
  /** Address property used when a party does not have representation and is being served. */
  serviceAddress?: Address | null;
  /**
   * A party's phone number.
   * 10 digits = Area Code + Phone Number
   * During validations and storing to db needs to be split in AreaCode and PhoneNumber.
   * CountryCode is 1 by default when saving to db, but is not consider when we build the phone number from db or when user enters it
   */
  phoneNumber?: string | null;
  /** The party's phone extension */
  phoneExtension?: string | null;
  /** The party's email */
  email?: string | null;
  /** A list of aliases belonging to the party */
  partyAliases?: FilingDraftPartyAlias[];
}

export interface FilingDraftPartyAlias {
  /**
   * An ID for this alias, set by the client. It can be used to address a specific alias if there are multiple with the same alias type. Must be unique per-party
   * @format int32
   */
  aliasId?: number;
  /**
   * The alias type for this alias
   * @format guid
   */
  aliasTypeId?: string | null;
  /**
   * The name of the alias type (read only)
   * @example "string --[patch-disabled]"
   */
  readonly aliasTypeName?: string | null;
  /**
   * The entity type for this alias (Individual, Organization)
   * @format int32
   */
  entityTypeId?: number | null;
  /** The PersonName for this alias. If alias is an organization, LastName field is used */
  name?: PersonName | null;
  /** A list of addresses belonging to this alias */
  addresses?: Address[];
  /**
   * A phone number belonging to this alias.
   * 10 digits = Area Code + Phone Number
   * During validations and storing to db needs to be splitted in AreaCode and PhoneNumber.
   * CountryCode is 1 by default when saving to db, but is not consider when we build the phone nunmber from db or when user enters it
   */
  phoneNumber?: string | null;
  /** The phone extension belonging to this alias. */
  phoneExtension?: string | null;
  /** An email address belonging to this alias */
  email?: string | null;
}

export interface FilingDraftAdditionalRecipient {
  /**
   * An ID for this additional recipient, set by the client
   * @format int32
   */
  additionalRecipientId?: number;
  /**
   * If this additional recipient was retrieved from a user search, the User GUID. If null, it may be a new user
   * @format guid
   */
  userUniqueId?: string | null;
  /** The additional recipient's name */
  name?: PersonName | null;
  /** The additional recipient's email address */
  email?: string | null;
}

export interface FilingDraftAdditionalData {
  /** Additional data values that apply to the filing case. */
  caseValues?: FilingDraftAdditionalDataValue[];
  /** Additional data values that apply to individual draft documents. */
  documentValues?: FilingDraftDocumentAdditionalDataValues[];
}

export interface FilingDraftAdditionalDataValue {
  /** Exact schema field key. */
  key: string;
  /** Raw schema field value. */
  value?: any | null;
  /** Schema field label at the time the value was collected. */
  label?: string | null;
  /** Human-readable value at the time the value was collected. */
  displayValue?: string | null;
}

export interface FilingDraftDocumentAdditionalDataValues {
  /**
   * ID of the document in the FilingDraft.
   * @format int32
   */
  documentId?: number;
  /**
   * Filing type selected for the document when the values were collected.
   * @format guid
   */
  filingTypeId?: string | null;
  /** Additional data values that apply to the document. */
  values?: FilingDraftAdditionalDataValue[];
}

export interface FilingDraftAttorney {
  /**
   * GUID User ID for this attorney
   * @format guid
   */
  attorneyId?: string;
  /**
   * The attorney's name (read only)
   * @example "object --[patch-disabled]"
   */
  readonly name?: PersonName;
  /**
   * GUID Organization ID for this attorney
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly organizationId?: string;
  /**
   * The attorney's organization name (read only)
   * @example "string --[patch-disabled]"
   */
  readonly organizationName?: string;
  /**
   * Int Service Method ID for this attorney
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly serviceMethodId?: number | null;
  /**
   * The attorney's service method name (read only)
   * @example "string --[patch-disabled]"
   */
  readonly serviceMethodName?: string | null;
}

export interface FilingDraftAttorneyToPartyMapping {
  /**
   * An AttorneyId from the Attorneys list in the filing. Null indicates that we have "no answer on file" for this attorney, but this record is needed to establish the PartyType
   * @format guid
   */
  attorneyId?: string | null;
  /**
   * The PartyId from the parties list in the filing. This joins with the PartyId in any FilingDraftParty object
   * @format int32
   */
  partyId?: number;
  /**
   * The ParticipantRoleID, 1 = FilingParty, 2 = ServiceParty, 0 (None) or null will get mapped based on the list the PartyId is in
   * @format int32
   */
  participantRoleId?: number | null;
  /**
   * The existing case Id for this attorney to party mapping. Nullable to support OPFs. All SubFs and MultiCase Filings need each mapping to have an associated CaseId.
   * @format guid
   */
  existingCaseId?: string | null;
  /**
   * The attorney's Type ID
   * @format guid
   */
  attorneyTypeId?: string | null;
  /**
   * The name of the attorney's type (read only)
   * @example "string --[patch-disabled]"
   */
  readonly attorneyTypeName?: string | null;
  /**
   * The attorney's Counsel Type, if applicable
   * @format guid
   */
  counselTypeId?: string | null;
  /**
   * The name of the attorney's counsel type (read only)
   * @example "string --[patch-disabled]"
   */
  readonly counselTypeName?: string | null;
  /**
   * The party type for this party (Plaintiff, Defendant, etc)
   * @format guid
   */
  partyTypeId?: string | null;
  /**
   * The name of the party type for this party (read only)
   * @example "string --[patch-disabled]"
   */
  readonly partyTypeName?: string | null;
  /**
   * Party sub-type for this party (Agent, Beneficiary, etc)
   * @format guid
   */
  partySubTypeId?: string | null;
  /**
   * The name of the party sub-type (read only)
   * @example "string --[patch-disabled]"
   */
  readonly partySubTypeName?: string | null;
  /** @example "string --[patch-disabled]" */
  readonly partyStatus?: string | null;
}

export interface FilingDraftCourtesyCopy {
  /**
   * User Id of the User receiving the Courtesy Copy.
   * @format guid
   */
  userId?: string;
  /** The Receiver's name */
  name?: PersonName | null;
  /** The address to send the Courtesy Copy to */
  address?: Address;
  /** Note the sender can include for the Receiver of the Courtesy Copy. */
  note?: string | null;
  /** List of Documents to send to the Receiver. */
  courtesyCopyDocument?: FilingDraftCourtesyCopyDocument[];
}

export interface FilingDraftCourtesyCopyDocument {
  /**
   * The DocumentId of the document in the FilingDraft.
   * @format int32
   */
  documentId?: number;
  /**
   * Number of copies to send to the Receiver of the Courtesy Copy.
   * @format int32
   */
  numberOfCopies?: number;
}

/**
 * Payment state persisted in the FilingDraft blob. Tracks which payment method the user
 * currently has selected and the full pre-authorization history grouped by payment method.
 */
export interface FilingDraftPayment {
  /**
   * The stored payment method the user has selected for this filing.
   * Patchable — updated by the client when the user picks a payment method.
   * @format guid
   */
  selectedPaymentMethodId?: string | null;
  /**
   * One entry per stored payment method attempted, each with its own attempt history.
   * Managed exclusively by the backend.
   */
  methods?: FilingDraftPaymentMethod[];
}

/**
 * Groups all pre-authorization attempts for a single stored payment method.
 * Identified by the filing (implicit) and the payment method ID.
 */
export interface FilingDraftPaymentMethod {
  /**
   * Internal identifier for the stored payment method.
   * @format guid
   */
  paymentMethodId?: string;
  /**
   * The external token string issued by the payment provider for this stored method.
   * Stored as ExternalAccountId in billing records.
   */
  providerToken?: string;
  /** All pre-auth attempts for this payment method, in chronological order. */
  attempts?: FilingDraftPreAuthAttempt[];
}

/** A single payment-gateway attempt — either authorized or failed. */
export interface FilingDraftPreAuthAttempt {
  status?: PreAuthStatus;
  /** @format decimal */
  amount?: number;
  /** @format date-time */
  attemptedAt?: string;
  /**
   * The gateway action this attempt represents (e.g. "authonly" or "sale" — see
   * PaymentAttemptAction), set at the point of the gateway call. Carried through to
   * billing persistence so the persist step doesn't need to re-derive which kind of attempt
   * this was. Null only for attempts recorded before this field existed.
   */
  action?: string | null;
  transactionId?: string | null;
  /** @format date-time */
  authorizedAt?: string | null;
  authCode?: string | null;
  gatewayCode?: string | null;
  gatewayMessage?: string | null;
}

/** A request to create a new FilingDraft */
export interface FilingDraftRequest {
  /** FileToCourt option (File, Serve, FileAndServe) */
  fileToCourt?: FileToCourt;
  /** FilingMode option (OPF, SubF) */
  filingMode?: FilingMode;
  /**
   * UserId for the filer
   * @format guid
   */
  filerId?: string;
  /**
   * UserId for the Authorizer
   * @format guid
   */
  authorizerId?: string;
  /**
   * CourtId to file into (this is the Court's Organization's ID)
   * @format guid
   */
  courtId?: string;
  /**
   * The DivisionId to file into, if applicable
   * @format guid
   */
  divisionId?: string | null;
  /**
   * CaseClassId to file into
   * @format guid
   */
  caseClassId?: string;
  cases: FilingDraftRequestCase[];
}

export interface FilingDraftRequestCase {
  /**
   * CaseTypeId to file into; if ExistingCaseID is set, value will be ignored
   * @format guid
   */
  caseTypeId?: string | null;
  /**
   * For OPF filings, null. For SubF filings, the existing CaseId to file into
   * @format guid
   */
  existingCaseId?: string | null;
  /** The Case Name for the filing; if ExistingCaseID is set, value will be ignored */
  caseName?: string | null;
}

/** @example [{"op":"replace","path":"/root/property","value":"new value"}] */
export type JsonPatchDocumentOfFilingDraft = {
  /** The operation to be performed */
  op: "add" | "remove" | "replace" | "move" | "copy" | "test";
  /** JSON pointer to the property to modify */
  path: string;
  /** The value to set (for add, replace operations) */
  value?: any | null;
  /** JSON pointer to copy/move from (for copy, move operations) */
  from?: string | null;
}[];

export type OperationOfFilingDraft = Operation & object;

/**
 * API response returned by POST /draft-filing/{filingId}/fee-quote.
 * Conveys the outcome of a Connex pre-filing fee quote. Fees are filing-level only.
 */
export interface FeeQuoteResult {
  /** Overall outcome of the fee-quote round-trip. */
  status?: FeeQuoteStatus;
  /**
   * Total court fee (populated when Status = Priced).
   * @format decimal
   */
  total?: number | null;
  /**
   * Itemised fee breakdown returned by the court (populated when
   * Status = Priced).
   */
  fees?: FeeQuoteLineItem[];
  /**
   * Validation messages returned by the court adapter (populated when
   * Status = Invalid).
   */
  validationErrors?: string[];
  /**
   * Human-readable error detail (populated when Status
   * is Error or Timeout, or when the adapter included an Error message).
   */
  errorMessage?: string | null;
}

/**
 * One fee line in Fees. Mirrors
 * ConnexV3.SharedObjects.FeeQuoteLineItem.
 */
export interface FeeQuoteLineItem {
  feeType?: string | null;
  description?: string | null;
  /** @format decimal */
  amount?: number;
}

/**
 * Result of the pre-submit authorizer bar-number check. Valid is false only when the
 * authorizing attorney HAS a Delaware bar number that the court CMS confirms does not belong to an
 * active attorney; true for every other case (not applicable, no bar number, valid, or CMS unreachable).
 */
export interface AuthorizerBarCheckResponse {
  valid?: boolean;
}

export interface FilingDraftSubmitResponse {
  /** @format int32 */
  filingId?: number;
  submittedBy?: string;
  submittedByOrganization?: string;
  authorizedBy?: string;
  authorizedByOrganization?: string;
  /** @format date-time */
  authorizedDate?: string;
}

export interface FilingDraftStateCourts {
  /** State details */
  state?: State;
  /** List of Courts in the State */
  courts?: FilingDraftCourt[];
}

export interface FilingDraftCourt {
  /**
   * Court's Organization GUID ID
   * @format guid
   */
  organizationId?: string;
  /** Court's Organization Name */
  organizationName?: string;
  /** The name of the Court Level */
  courtLevel?: string;
  /**
   * How the client drives case search for this court: Partial = type-ahead autocomplete,
   * Full = textbox + Search button (exact). Sourced from EfmCourtConfig; defaults to Partial
   * for courts without an EFM config row.
   */
  caseSearchMatch?: CaseSearchMatchMode;
  /** Which field(s) the client searches for this court. Defaults to Both. */
  caseSearchField?: CaseSearchFieldMode;
  /** List of Case Classes of the Court */
  caseClasses?: FilingDraftCaseClass[];
  /**
   * True when the Court allows the Filer to select a Division/Courtroom (Court.AllowSelectDivision).
   * When false, the client hides the Division field and it is not required, and
   * Divisions is returned empty.
   */
  allowSelectDivision?: boolean;
  /** List of Divisions of the Court (if any). Empty when AllowSelectDivision is false. */
  divisions?: FilingDraftDivision[];
}

export interface FilingDraftCaseClass {
  /**
   * The GUID ID of the Case Class
   * @format guid
   */
  caseClassId?: string;
  /** The name of the Case Class */
  caseClassName?: string;
}

export interface FilingDraftDivision {
  /**
   * The GUID ID of the Division
   * @format guid
   */
  divisionId?: string;
  /** The name of the Division */
  divisionName?: string;
}

export interface FilingDraftCaseSearchResult {
  /**
   * The GUID ID of the Case
   * @format guid
   */
  caseId?: string;
  /**
   * The GUID ID of the Case Class
   * @format guid
   */
  caseClassId?: string;
  /** The name of the Case Class */
  caseClassName?: string;
  /**
   * The GUID ID of the Case Type
   * @format guid
   */
  caseTypeId?: string;
  /** The name of the Case Type */
  caseTypeName?: string;
  /**
   * The GUID ID of the Division (if any)
   * @format guid
   */
  divisionId?: string | null;
  /** The name of the Division */
  divisionName?: string | null;
  /** The Case Name */
  caseName?: string;
  /** The Case Number */
  caseNumber?: string;
}

export interface FilingDraftConfiguration {
  /** Court Filing Configurations */
  filingCourtConfiguration?: FilingCourtConfiguration;
  /** CaseClass Filing Configurations (Replaces the FilingCourtCaseClassConfiguration from FilingConfiguration class) */
  filingCourtCaseClassConfiguration?: FilingDraftCourtCaseClassConfiguration;
  /** List of Case Types available for the Filing and their Configurations (Replaces the FilingCourtCaseTypeConfiguration from FilingConfiguration class) */
  filingCourtCaseTypeConfigurations?: FilingDraftCourtCaseTypeConfiguration[];
  /** List of Filing Types available for the Filing and their Configurations */
  filingCourtFilingTypeConfigurations?: FilingCourtFilingTypeConfiguration[];
  /** List of Filing Categories available for the Filing */
  filingCourtFilingCategories?: FilingCourtFilingCategory[];
  /** List of Party Types available for the Filing */
  filingCourtPartyTypeConfigurations?: FilingCourtPartyTypeConfiguration[];
  /** List of Alias Types available for the Filing */
  filingCourtAliasTypeConfigurations?: FilingCourtAliasTypeConfiguration[];
  /** List of Attorney Types available for the Filing */
  filingCourtAttorneyTypeConfigurations?: FilingCourtAttorneyTypeConfiguration[];
  /** List of Address Types available for the Filing */
  filingCourtAddressTypeConfigurations?: FilingCourtAddressTypeConfiguration[];
  /** List of Counsel Types available for the Filing */
  filingCourtCounselTypeConfigurations?: FilingCourtCounselTypeConfiguration[];
  /** List of Fee Waiver Reasons available for the filing */
  filingCourtFeeWaiverReasonConfigurations?: FilingCourtFeeWaiverReasonConfiguration[];
  /** List of Entity Types available for the Filing */
  filingCourtEntityTypeConfigurations?: EntityType[];
  /** Organization Filing Configurations (Replaces the FilingOrganizationConfiguration from FilingConfiguration class) */
  filingOrganizationConfiguration?: FilingDraftOrganizationConfiguration;
  /** List of Access Types available for the Filing */
  filingAccessTypeConfigurations?: FilingAccessTypeConfiguration[];
  /** List of Additional Recipients available for the Filing */
  filingUserAdditionalRecipients?: FilingUserAdditionalRecipient[];
  /**
   * Case-level additional-data values captured for the selected existing case (SubF only),
   * read from the JCMS CaseAdditionalData table. The client seeds the case additional-data
   * form with these so schema conditions (e.g. the Small Claims COVID-19 attestation's
   * ShowWhen on case.covid1179_02) evaluate against the real case before the draft exists.
   * Empty for OPF filings or when no captured data exists.
   */
  capturedCaseAdditionalDataValues?: FilingDraftAdditionalDataValue[];
  /** List of Artificial Entities related to the Form 50 Agent (User) filing the case. */
  filingDraftForm50ArtificialEntities?: FilingDraftForm50ArtificialEntities[];
  /**
   * Named pick lists captured onto the selected existing case at case sync,
   * keyed by list name (e.g. "judgments" for JTI's court-event judgments).
   * Backs additional-data schema collection references of the form
   * case.lists.<name>. Empty for OPF filings or when the case has no
   * captured lists.
   */
  capturedCaseLists?: Record<string, FilingDraftCapturedListItem[]>;
  /** Information of the Form50 Party available during Certificate Entry filing */
  filingDraftForm50CertificateEntryParty?: FilingDraftForm50CertificateEntryParty | null;
}

export interface FilingCourtConfiguration {
  courtName?: string;
  /** @format int32 */
  courtId?: number;
  /** @format guid */
  courtUniqueId?: string;
  courtTimeZone?: string;
  /** @format int32 */
  maxDocumentSizeBytes?: number;
  /** @format int32 */
  maxTotalDocumentSizeBytes?: number;
  isOnline?: boolean;
  /** @format byte */
  filingCompleteMessageFlag?: number;
  filingCompleteMessage?: string | null;
  feeWaiverReasons?: CourtFeeWaiverReason[];
  allowNoteToClerk?: boolean;
  allowCourtesyCopies?: boolean;
  allowFilerCourtesyCopies?: boolean;
  allowMultipleAddressTypesPerParty?: boolean;
  courtesyCopyJudges?: CourtesyCopyJudges[];
  /**
   * When true, a transaction may contain more than one main (lead) document. Maps to
   * Court.MultiLeadDoc. When false the transaction may only have a single main
   * document -- every other document must be supporting -- matching legacy behavior
   * (Basic/classic filing UI auto-attached later uploads to the existing lead, and the
   * bulk-filing XML path rejected payloads carrying more than one lead).
   */
  allowMultipleLeadDocuments?: boolean;
  /**
   * When true, Modern's review-and-submit step must obtain an authoritative
   * fee quote from Connex (via POST /draft-filing/{filingId}/fee-quote)
   * before Finalise. Internal fee calculation (CcFilingTypeFee /
   * FilingCourtFilingTypeConfiguration.TotalFee) is bypassed for these courts.
   */
  useExternalFeeQuote?: boolean;
  /**
   * When true, the court permits filers to declare a deferred payment arrangement at
   * review-and-submit. Maps to Court.AllowPaymentDeferred. Gates the
   * "I have a deferred payment arrangement with the Court" checkbox on the client.
   */
  allowPaymentDeferred?: boolean;
}

export interface CourtFeeWaiverReason {
  /** @format int32 */
  reasonId?: number;
  reason?: string;
}

export interface CourtesyCopyJudges {
  /** @format guid */
  userId?: string;
  name?: PersonName | null;
}

export interface FilingDraftCourtCaseClassConfiguration {
  caseClass?: string;
  /** @format int32 */
  caseClassId?: number;
  /** @format guid */
  caseClassUniqueId?: string;
  allowCourtFeeWaiver?: AllowCourtFeeWaiver;
  isPartySubTypeEnabled?: boolean;
  isCounselTypeEnabled?: boolean;
  allowSelfRepresented?: boolean;
  allowConfidentialParties?: boolean;
  allowFirstRespondentFiling?: boolean;
  hasAgreement?: boolean;
  agreement?: string | null;
  hasPartyVerification?: boolean;
  isDivisionRequired?: boolean;
  opfPartySearch?: boolean;
  formatRestrictions?: FilingDraftCourtCaseClassFormatRestrictions[];
  allowSubsequentFilings?: boolean;
  allowFileToCourtFilings?: boolean;
  allowServiceFilings?: boolean;
  allowFileAndServeFilings?: boolean;
  multiCaseAllowed?: boolean;
  /** @format int32 */
  serviceTabDefaultDisplay?: number;
  opfPartyExtraFields?: boolean;
  isAddressVisible?: boolean;
  isAddressRequired?: boolean;
  isPhoneVisible?: boolean;
  isPhoneRequired?: boolean;
  isEmailVisible?: boolean;
  isEmailRequired?: boolean;
  isSSNVisible?: boolean;
  isSSNRequired?: boolean;
  isDOBVisible?: boolean;
  isDOBRequired?: boolean;
  autofillSriData?: boolean;
  form50CertificateEntry?: boolean;
  defaultSriAttorneyType?: FilingCourtAttorneyTypeConfiguration;
  /** Whether filer can add a new party during a SubF */
  subFCanAddParty?: boolean;
  /** User can add a new party with representation from their own firm */
  subFCanAddPartyWithRepFromYourFirm?: boolean;
  /** User can add a new party with representation from their another firm */
  subFCanAddPartyWithRepFromAnotherFirm?: boolean;
  /** User can add a new party with no representation */
  subFCanAddPartyWithoutRep?: boolean;
  /** User can add representation from your firm to a party already represented by User's firm */
  canAddRepFromYourFirmToPartyWithRepFromYourFirm?: boolean;
  /** User can add representation from another firm to an existing party on the case who is unrepresented */
  canAddRepFromOtherFirmToPartyWithNoRep?: boolean;
  /** User can add representation from another firm to a party with existing representation */
  canAddRepFromOtherFirmToPartyWithRep?: boolean;
  requiresPayment?: boolean;
}

export interface FilingDraftCourtCaseClassFormatRestrictions {
  /** @format guid */
  filingTypeId?: string;
  /** @format int32 */
  documentFormatId?: number;
  documentExtension?: string;
  accept?: boolean;
  deny?: boolean;
}

export interface FilingDraftCourtCaseTypeConfiguration {
  /**
   *     The GUID ID of the Case Type
   *
   * @format guid
   */
  caseTypeId?: string;
  /**
   * The numeric JCms ID of the Case Type.
   * @format int32
   */
  caseTypeNumericId?: number;
  /** The name of the Case Type */
  caseTypeName?: string;
  /** Addition Info configured for the Case Type */
  additionalInfo?: string | null;
  /** Case Number Validation Expression configured for the Case Type */
  caseNumberValidationExpression?: string | null;
  /** Case Number Format Tip configured for the Case Type */
  caseNumberFormatTip?: string | null;
  /** Rule Check configured for the Case Type */
  ruleCheck?: string;
  /** Is Opf Initiating Party Only configuration for the Case Type */
  isOpfInitiatingPartyOnly?: boolean;
  /** Is Attestation Flow configuration for the Case Type */
  isAttestationFlow?: boolean;
  /** Allow Confidential Parties configuration for the Case Type */
  allowConfidentialParties?: boolean;
}

export interface FilingCourtFilingCategory {
  /** @format int32 */
  filingCategoryId?: number;
  /** @format guid */
  filingCategoryUniqueId?: string;
  filingCategory?: string;
}

export interface FilingCourtAddressTypeConfiguration {
  addressType?: string;
  /** @format int32 */
  addressTypeId?: number;
}

export interface FilingCourtFeeWaiverReasonConfiguration {
  /** @format int32 */
  reasonId?: number;
  reason?: string;
}

export interface EntityType {
  /** @format int32 */
  id?: number;
  name?: string;
}

export interface FilingDraftOrganizationConfiguration {
  /**
   * Firm Organization GUID ID
   *
   * @format guid
   */
  organizationId?: string;
  /** Firm Organization Name */
  organizationName?: string;
  /** List of Authorizers of the Filer Organization */
  authorizers?: FilingDraftAuthorizer[];
  /**
   * Required Billing Reference configuration for the Firm, for filing and service
   * transactions (MandatoryBillingReferenceType.SubmitFilingServiceTransaction).
   * Does not apply to document uploads — see RequiredBillingReferenceDocumentUpload.
   */
  requiredBillingReference?: boolean;
  /**
   * Required Billing Reference configuration for the Firm, for document uploads
   * (MandatoryBillingReferenceType.DocumentUpload). The firm selects this
   * activity independently of filings, so a draft with
   * FileToCourt.DocumentUpload is governed by this flag and not by
   * RequiredBillingReference.
   */
  requiredBillingReferenceDocumentUpload?: boolean;
  /** When doing an OPF, user can add an attorney from any firm to a new party */
  opfAllowAddingAttorneyFromAnyFirm?: boolean;
  /**
   * True when this filer organization has a deferred payment arrangement on record with the
   * court being filed into (a matching OrganizationDeferred row). Drives the default
   * checked state of the deferred-payment checkbox; the filer may still uncheck it.
   * Court-specific, so this cannot live on the cached court configuration.
   */
  hasPaymentDeferredArrangement?: boolean;
}

export interface FilingDraftAuthorizer {
  /**
   * User GUID ID of the Authorizer
   * @format guid
   */
  authorizerId?: string;
  /** User's Name in the following format: "LastName, FirstName" */
  displayName?: string | null;
  /** Bar Number of the Authorizer (if any) */
  barNumber?: string | null;
}

export interface FilingUserAdditionalRecipient {
  /** @format int32 */
  filingId?: number;
  /** @format guid */
  userUniqueId?: string;
  name?: PersonName | null;
  organizationName?: string;
  email?: string;
  isExisting?: boolean;
}

export interface FilingDraftForm50ArtificialEntities {
  /** @format guid */
  existingPartyId?: string | null;
  efmId?: string;
  displayName?: string;
}

/** A generic value/label pair from connector-captured case pick lists. */
export interface FilingDraftCapturedListItem {
  value: string;
  label: string;
  /**
   * Which group this item belongs to, when the list partitions another collection rather than
   * being picked from. Read by the client via an option source's GroupListRef.
   */
  group?: string | null;
}

export interface FilingDraftForm50CertificateEntryParty {
  /** @format guid */
  existingPartyId?: string | null;
  /** @format int32 */
  entityTypeId?: number;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string;
  suffix?: string | null;
  phoneNumber?: string | null;
  phoneExtension?: string | null;
  email?: string | null;
  /** @format int32 */
  addressTypeId?: number;
  streetLine1?: string | null;
  streetLine2?: string | null;
  city?: string | null;
  stateCode?: string | null;
  zipCode?: string | null;
}

export interface FilingDraftRecentlyUsed {
  /** The Code ID of the State  */
  stateCode?: string;
  /**
   * Court's Organization GUID ID
   * @format guid
   */
  organizationId?: string;
  /** Court's Organization Name */
  organizationName?: string;
  /**
   * The Date of the last time the filing data was used
   * @format date-time
   */
  lastUsed?: string | null;
  /**
   * The GUID ID of the Case when searching for SUBF.
   * Empty when searching for OPF.
   * @format guid
   */
  caseId?: string | null;
  /**
   * The Case Number when searching for SUBF.
   * Empty when searching for OPF.
   */
  caseNumber?: string | null;
  /**
   * The Case Name when searching for SUBF.
   * Empty when searching for OPF.
   */
  caseName?: string | null;
  /**
   * The GUID ID of the Case Class
   * @format guid
   */
  caseClassId?: string;
  /** The name of the Case Class */
  caseClassName?: string;
  /** @format guid */
  caseTypeId?: string;
  /** The name of the Case Type */
  caseTypeName?: string;
}

export interface Attorney {
  /** @format guid */
  id?: string;
  name?: string | null;
  /** @format guid */
  orgId?: string;
  organizationName?: string | null;
  barNumber?: string | null;
}

export interface FilingDraftCaseParticipants {
  /** The list of existing parties associated with the existing case */
  parties?: FilingDraftParty[];
  /** The list of attorneys associated with the existing case */
  attorneys?: FilingDraftAttorney[];
  /** A mapping from attorneys to the parties they represent */
  attorneyToPartyMappings?: FilingDraftAttorneyToPartyMapping[];
}

export interface FilingLinkedDocument {
  /** @format int32 */
  documentId?: number;
  /** @format int32 */
  filingId?: number;
  documentTitle?: string;
  filingType?: string;
  /** @format int32 */
  filingTypeId?: number;
  /** @format date-time */
  authorizedDate?: string;
  party?: FilingLinkedDocumentParty[];
}

export interface FilingLinkedDocumentParty {
  partyName?: string;
  partyType?: string;
}

export interface FilingDraftPartySearchResult {
  party: FilingDraftPartySearchPartyInfo;
  cases: FilingDraftPartySearchCaseInfo[];
}

export interface FilingDraftPartySearchPartyInfo {
  /** @format int32 */
  partyId?: number;
  /** @format int32 */
  entityTypeId?: number;
  firstName?: string | null;
  middleName?: string | null;
  lastName: string;
  suffix?: string | null;
  ssn?: string | null;
  dateOfBirth?: string | null;
  phone?: Phone | null;
  email?: string | null;
  addresses?: FilingDraftPartySearchAddress[];
  isAlias?: boolean;
  /** @format int32 */
  aliasPartyId?: number | null;
  /** @format int32 */
  aliasTypeId?: number | null;
}

export interface Phone {
  /** @format int32 */
  typeId?: number;
  type?: string;
  countryCode?: string;
  areaCode?: string;
  phoneNumber?: string;
  extension?: string | null;
}

export type FilingDraftPartySearchAddress = Address & {
  /** @format int32 */
  typeId?: number | null;
};

export interface FilingDraftPartySearchCaseInfo {
  caseNumber: string;
  caseName: string;
  partyType: string;
  /** @format int32 */
  partyTypeId?: number;
  isConfidentialParty?: boolean;
}

/**
 * A single Multi-Case Filing search result. One row per matching case, with optional
 * columns populated depending on the "Search By" filter used.
 */
export interface MultiCaseSearchResult {
  /**
   * The GUID ID of the Case
   * @format guid
   */
  caseId?: string;
  /**
   * The GUID ID of the Case Type
   * @format guid
   */
  caseTypeId?: string;
  /** The name of the Case Type */
  caseTypeName?: string;
  /** The Case Number */
  caseNumber?: string;
  /** The Case Name */
  caseName?: string;
  /** The matched party/attorney Last Name (Individual Party and Attorney Name modes) */
  lastName?: string | null;
  /** The matched party/attorney First Name (Individual Party and Attorney Name modes) */
  firstName?: string | null;
  /** The matched party/attorney Middle Name (Individual Party and Attorney Name modes) */
  middleName?: string | null;
  /** The matched Organization (Business Party) name */
  organizationName?: string | null;
  /** The matched Firm (attorney's organization) name (Firm Name mode) */
  firmName?: string | null;
  /** The associated Judge name (Judge Name mode) */
  judgeName?: string | null;
}

/** Filters for a Multi-Case Filing search. Shared by the "Search by Case" and "Search by Case Group" endpoints */
export interface MultiCaseSearchRequest {
  /**
   * The GUID of the Case Class to search within (required)
   * @format guid
   */
  caseClassId?: string;
  /** The "Search By" filter option */
  searchBy?: MultiCaseSearchBy;
  /** The "Case Number or Title" text. Matches cases whose case number OR case name contains this value (substring). */
  caseNumberOrTitle?: string | null;
  /** Last Name filter (Individual Party and Attorney Name modes) */
  lastName?: string | null;
  /** First Name filter (Individual Party and Attorney Name modes). Matches first name only. */
  firstName?: string | null;
  /** Middle Name filter (Individual Party and Attorney Name modes). Matches middle name only. */
  middleName?: string | null;
  /** Business (organization) Name filter (Business Party mode) */
  businessName?: string | null;
  /** Firm (attorney's organization) Name filter (Firm Name mode) */
  firmName?: string | null;
  /**
   * The GUID of the Judge (User) selected in the "Judge Name" dropdown (Judge Name mode)
   * @format guid
   */
  judgeUserId?: string | null;
  /**
   * The GUID of the Case Type selected in the "Case Type" dropdown (Case Type mode)
   * @format guid
   */
  caseTypeId?: string | null;
}

export interface FilingDraftExternalFirmRequest {
  attorneyFirstName?: string | null;
  attorneyLastName?: string | null;
  firmName?: string | null;
}

/**
 * Details for a submitted filing (transaction), keyed by FilingUniqueId.
 * Used by the modern transaction view sidecar. Navigation uses
 * FilingUniqueId; TransactionId is the
 * user-facing transaction number (legacy numeric FilingID) for display only.
 */
export interface TransactionDetails {
  /** @format guid */
  filingUniqueId?: string;
  /** @format int32 */
  filingModeId?: number;
  /** @format int64 */
  transactionId?: number;
  filingStatus?: string | null;
  filingOption?: FilingOptionId;
  /**
   * When the filing was submitted, as an absolute instant (UTC offset).
   * Persisted as Eastern wall-clock; converted on the way out so the UI can
   * render it in the signed-in user's own time zone.
   * @format date-time
   */
  submittedDate?: string | null;
  /**
   * When the filing was authorized, as an absolute instant (UTC offset).
   * See SubmittedDate.
   * @format date-time
   */
  authorizedDate?: string | null;
  authorizer?: string | null;
  authorizerOrganization?: string | null;
  sender?: string | null;
  senderOrganization?: string | null;
  billingReference?: string | null;
  multicase?: boolean;
  case?: TransactionCase;
  /**
   * Every case on the filing, for the transaction view's paginated multicase
   * case table. Always populated; single-case transactions render the
   * Case header block instead of the table.
   */
  cases?: TransactionCaseSummary[];
  documents?: TransactionDocument[];
  sendingParties?: TransactionParty[];
  additionalParties?: AdditionalParty[];
  serviceRecipients?: TransactionServiceRecipient[];
  additionalRecipients?: TransactionAdditionalRecipient[];
  payment?: TransactionPayment | null;
}

export interface TransactionCase {
  caseNumber?: string | null;
  caseName?: string | null;
  courtName?: string | null;
  division?: string | null;
  caseClass?: string | null;
  caseType?: string | null;
}

/**
 * One case on a multicase transaction. Mirrors the clerk-review multicase
 * case table columns (case type / case number / case name).
 */
export interface TransactionCaseSummary {
  /**
   * The case's unique (GUID) identifier; row identity for the UI table.
   * @format guid
   */
  caseId?: string;
  caseType?: string | null;
  caseNumber?: string | null;
  caseName?: string | null;
}

export interface TransactionDocument {
  /** @format int64 */
  documentId?: number;
  leadDocument?: boolean;
  documentTitle?: string | null;
  documentType?: string | null;
  documentSecurity?: string | null;
  /** @format int32 */
  numberOfPages?: number | null;
  reviewStatus?: string | null;
  /**
   * The date the document was reviewed. Deliberately NOT converted to an
   * absolute instant like AuthorizedDate:
   * clerk-entered review dates come from a day-granular date picker, so
   * shifting them into the viewer's zone would move a midnight value to the
   * previous day west of Eastern. Null when the document is unreviewed.
   * @format date-time
   */
  reviewDate?: string | null;
  /** @format decimal */
  statutoryFee?: number;
  fees?: TransactionDocumentFee[];
  /**
   * Judicial Routing for the document: the judge(s) it is pending review with and the judges
   * it can be routed to. Null when the user lacks the Judicial Routing permission for the court
   * or the document is not pending judge review.
   */
  judgeRouting?: TransactionDocumentJudgeRouting | null;
}

export interface TransactionDocumentFee {
  feeType?: string | null;
  /** @format decimal */
  amount?: number;
}

/**
 * A document's Judicial Routing state for the transaction view.
 * See JudicialRoutingProvider.
 */
export interface TransactionDocumentJudgeRouting {
  /** The judges the document is currently pending review with. */
  currentJudges?: TransactionJudge[];
  /** The judges the document can be routed to. */
  availableJudges?: TransactionJudge[];
}

export interface TransactionJudge {
  /**
   * The judge's unique (GUID) user identifier.
   * @format guid
   */
  judgeId?: string;
  name?: string | null;
}

export interface TransactionParty {
  partyName?: string | null;
  partyType?: string | null;
  attorneyName?: string | null;
  /**
   * The attorney's representation type on the case (e.g. "Advocate"), from the
   * matching case participant. Null when the case has no participant record for it.
   */
  attorneyType?: string | null;
  attorneyEmail?: string | null;
  firmName?: string | null;
}

export type AdditionalParty = TransactionParty & object;

export interface TransactionServiceRecipient {
  name?: string | null;
  organization?: string | null;
  /**
   * The recipient's representation type on the case (e.g. "Advocate"), from the
   * matching case participant. Null when the case has no participant record for it.
   */
  attorneyType?: string | null;
  partyName?: string | null;
  partyType?: string | null;
  deliveryMethod?: string | null;
  /**
   * Where service was delivered: an email address, fax number or mailing address,
   * depending on DeliveryMethod.
   */
  deliveryAddress?: string | null;
  deliveryStatus?: string | null;
  /**
   * When service was sent, as an absolute instant (UTC offset).
   * @format date-time
   */
  sentDate?: string | null;
}

/**
 * A non-party recipient the filer added to the transaction's service
 * (UserFiling roles AdditionalRecipient / AdditionalRecipientNewAddress).
 */
export interface TransactionAdditionalRecipient {
  name?: string | null;
  deliveryMethod?: string | null;
  deliveryAddress?: string | null;
}

/** Routes a document that is pending judge review to a different judge (Judicial Routing). */
export interface JudgeRoutingRequest {
  /**
   * The unique (GUID) user identifier of the judge to route the document to.
   * @format guid
   */
  judgeId?: string;
  /**
   * When the document is released to the judge's review queue; today or later.
   * Mirrors the clerk review Send Date.
   * @format date-time
   */
  sendDate?: string | null;
}

export interface ListResponseOfSavedFilings {
  data?: SavedFilings[];
}

export interface SavedFilings {
  /** @format guid */
  filingUniqueID?: string;
  /** @format date-time */
  draftDate?: string;
  courtName?: string | null;
  caseNumber?: string | null;
  caseName?: string | null;
  filerName?: string | null;
  isOPF?: boolean;
  isMultiCase?: boolean;
  caseList?: SavedFilingsCaseList[] | null;
}

export interface SavedFilingsCaseList {
  caseNumber?: string;
  caseName?: string;
}

export interface NewFormResult {
  /** @format uri */
  formIframeUrl?: string;
  /** @format guid */
  templatedFormId?: string;
  /** @format guid */
  templatedDataId?: string;
}

export interface NewFormRequest {
  templatedFormId?: string;
  /** @format guid */
  organizationId?: string;
  /** @format guid */
  filingId?: string;
  /** @format guid */
  caseTypeId?: string;
}

export interface EditFormResult {
  /** @format uri */
  formIframeUrl?: string;
  /** @format guid */
  templatedDataId?: string;
}

export interface ListResponseOfString {
  data?: string[];
}

/**
 * The judge chambers the requesting user works in, for courts with Court.EnableJudgeChambers set.
 * Pending filings still come from the judge review queue; this carries the chamber data layered on top.
 */
export interface JudgeChambersSummary {
  /** Chambers where the user is the judge or an active member. */
  chambers?: JudgeChamberSummary[];
  /**
   * Unread notifications for the user across all of their chambers.
   * @format int32
   */
  unreadNotificationCount?: number;
}

/** A single judge's chambers within a court. */
export interface JudgeChamberSummary {
  /** @format guid */
  chamberId?: string;
  /**
   * The judge's CerberusUser.UniqueId; matches AvailableJudgeUser.JudgeUniqueId in the judge review queue.
   * @format guid
   */
  judgeUniqueId?: string;
  judgeName?: PersonName;
  /**
   * The court's Organization.UniqueId.
   * @format guid
   */
  courtUniqueId?: string;
  courtName?: string | null;
  /** Tags defined by the chamber, shared by all of its members. */
  tags?: JudgeChamberTag[];
  /** Chamber tags applied to documents that are pending this judge's review. */
  documentTags?: JudgeChamberDocumentTag[];
  /** Documents pending this judge's review, which members can tag with the chamber's tags. */
  pendingDocumentIds?: number[];
  /** Cases of the filings pending this judge's review, which members can add chamber notes to. */
  pendingCaseIds?: number[];
  /** The same cases with their CourtCase.UniqueId, which the case information sidecar is opened with. */
  pendingCases?: JudgeChamberPendingCase[];
  /** Chamber note counts for pending documents that have notes. */
  documentNoteCounts?: JudgeChamberNoteCount[];
  /** Chamber note counts for pending cases that have notes. */
  caseNoteCounts?: JudgeChamberNoteCount[];
  /** Active members (the judge first), who pending documents can be assigned to. */
  members?: JudgeChamberMember[];
  /** Assignments of pending documents to active members. */
  documentAssignments?: JudgeChamberDocumentAssignment[];
}

/** A user defined tag shared by the members of a chamber. */
export interface JudgeChamberTag {
  /** @format guid */
  tagId?: string;
  name?: string;
  /**
   * The number of documents the tag is applied to. A tag in use cannot be deleted.
   * @format int32
   */
  documentCount?: number;
}

/** A chamber tag applied to a document. */
export interface JudgeChamberDocumentTag {
  /** @format int32 */
  documentId?: number;
  /** @format guid */
  tagId?: string;
}

/** A case of a filing pending the chamber judge's review. */
export interface JudgeChamberPendingCase {
  /**
   * The case's CourtCase.CaseID.
   * @format int32
   */
  caseId?: number;
  /**
   * The case's CourtCase.UniqueId.
   * @format guid
   */
  caseUniqueId?: string;
}

/** The number of chamber notes on a document or a case. */
export interface JudgeChamberNoteCount {
  /**
   * The document id or case id.
   * @format int32
   */
  id?: number;
  /** @format int32 */
  count?: number;
}

/** A chamber member, or a court user who can be added to a chamber. */
export interface JudgeChamberMember {
  /**
   * The user's CerberusUser.UniqueId.
   * @format guid
   */
  userUniqueId?: string;
  name?: PersonName;
  email?: string | null;
  /** This member is the chamber's judge (cannot be removed). */
  isJudge?: boolean;
}

/** The chamber member a document is assigned to. */
export interface JudgeChamberDocumentAssignment {
  /** @format int32 */
  documentId?: number;
  /**
   * The assignee's CerberusUser.UniqueId, or null when the document is not assigned.
   * @format guid
   */
  assigneeUserUniqueId?: string | null;
}

/** Creates or renames a chamber tag. */
export interface JudgeChamberTagRequest {
  /** The tag name; trimmed, required, at most 50 characters, and unique within the chamber (ignoring case). */
  name?: string | null;
}

/**
 * A document of a filing pending the chamber judge's review, as the judge review page shows it: who it is assigned
 * to, who it can be assigned to, and whether the user may act on it.
 */
export interface JudgeChamberFilingDocumentAssignment {
  /**
   * The document's Document.DocumentID.
   * @format int32
   */
  documentId?: number;
  /**
   * The chamber the document is assigned within.
   * @format guid
   */
  chamberId?: string;
  /**
   * The assigned member's CerberusUser.UniqueId, or null when unassigned.
   * @format guid
   */
  assigneeUserUniqueId?: string | null;
  /**
   * The user may change the document's status / action and review and sign it: they are the chamber judge or
   * the assignee.
   */
  canAct?: boolean;
  /** Active members (the judge first) the document can be assigned to. */
  members?: JudgeChamberMember[];
}

/**
 * The chamber tags for one document of a filing, for a document pending review by the judge of a chamber
 * the requesting user works in.
 */
export interface JudgeChamberFilingDocumentTags {
  /** @format int32 */
  documentId?: number;
  /**
   * The chamber whose tags apply to this document.
   * @format guid
   */
  chamberId?: string;
  /** Tags applied to the document. */
  tags?: JudgeChamberTag[];
  /** All of the chamber's tags (the tags that can be applied). */
  availableTags?: JudgeChamberTag[];
}

/** A chamber note on a document or a case. */
export interface JudgeChamberNote {
  /** @format guid */
  noteId?: string;
  /**
   * The document the note is on, or null for a case note.
   * @format int32
   */
  documentId?: number | null;
  /**
   * The case the note is on, or null for a document note.
   * @format int32
   */
  caseId?: number | null;
  /**
   * The note this reply answers, or null for a top-level note.
   * @format guid
   */
  parentNoteId?: string | null;
  /** The note as sanitized rich text markup (see ChamberNoteMarkup), with mentions as mention spans. */
  note?: string;
  /** The note is also shown in clerk review. */
  availableInClerkReview?: boolean;
  /**
   * The author's CerberusUser.UniqueId.
   * @format guid
   */
  authorUserUniqueId?: string;
  authorName?: PersonName;
  /** The author is the chamber's judge (otherwise chambers staff). */
  authorIsJudge?: boolean;
  /** The author is not a member of the chamber: a clerk who wrote the note in clerk review. */
  authorIsClerk?: boolean;
  /** @format date-time */
  createDate?: string;
  /** @format date-time */
  updateDate?: string;
  /** The requesting user wrote the note, so they can edit and delete it. */
  canEdit?: boolean;
  /** Replies to a top-level note, oldest first (always empty on a reply). */
  replies?: JudgeChamberNote[];
}

/** Adds or edits a chamber note. */
export interface JudgeChamberNoteRequest {
  /**
   * The note as rich text markup from the note editor. Sanitized to the editor's formatting and mentions; its
   * text is required and at most 4000 characters. People mentioned in it (mention spans) are notified once: a
   * chamber member, or a clerk who reviews the court's filings when the note is shown in clerk review.
   */
  note?: string | null;
  /**
   * Also show the note in clerk review. Ignored for case notes, which are chambers-only, and for replies,
   * which follow the note they answer.
   */
  availableInClerkReview?: boolean;
}

/** The chamber notes on one document or one case of a filing, for the chamber whose judge the filing was sent to. */
export interface JudgeChamberTargetNotes {
  /**
   * The chamber the notes belong to.
   * @format guid
   */
  chamberId?: string;
  /**
   * The document, or null for a case.
   * @format int32
   */
  documentId?: number | null;
  /**
   * The case, or null for a document.
   * @format int32
   */
  caseId?: number | null;
  /**
   * The case's CourtCase.UniqueId (the id the judge review page has), or null for a document.
   * @format guid
   */
  caseUniqueId?: string | null;
  /** The top-level notes, newest first, each with its replies. */
  notes?: JudgeChamberNote[];
}

/** The chamber notes shown in clerk review on one document, in a court that enables judge chambers. */
export interface JudgeChamberClerkReviewDocumentNotes {
  /** @format int32 */
  documentId?: number;
  /**
   * The document has a judge (the judge it was sent to for review, or its case's primary judge), so the clerk
   * can add a note to it.
   */
  canAddNote?: boolean;
  /** The top-level notes shown in clerk review, newest first, each with its replies. */
  notes?: JudgeChamberNote[];
}

/** The documents of the clerk review list whose chamber notes to read. */
export interface JudgeChamberClerkReviewNotesQuery {
  documentIds?: number[];
}

/**
 * Someone who can be mentioned ("@First Last") in a chamber note: a member of the chamber, or a clerk who reviews the
 * court's filings. Clerks can only be mentioned in document notes shown in clerk review.
 */
export interface JudgeChamberMentionCandidate {
  /**
   * The user's CerberusUser.UniqueId.
   * @format guid
   */
  userUniqueId?: string;
  name?: PersonName;
  /** The text inserted after "@" in a note ("First Last"). */
  mentionName?: string;
  /** The user is the chamber's judge. */
  isJudge?: boolean;
  /**
   * The user is not a member of the chamber but reviews the court's filings, so they can only be mentioned in
   * notes shown in clerk review.
   */
  isClerk?: boolean;
}

/** Assigns a document to a chamber member, or unassigns it. */
export interface JudgeChamberAssignmentRequest {
  /**
   * The active chamber member's CerberusUser.UniqueId, or null to unassign.
   * @format guid
   */
  userUniqueId?: string | null;
}

/** The user's chamber notifications, newest first, and how many are unread. */
export interface JudgeChamberNotificationList {
  /**
   * All of the user's unread notifications (not only those in Notifications).
   * @format int32
   */
  unreadCount?: number;
  notifications?: JudgeChamberNotification[];
}

/** A chamber notification for the user (e.g. a document was assigned to them). */
export interface JudgeChamberNotification {
  /** @format guid */
  notificationId?: string;
  /**
   * The chamber the notification is from.
   * @format guid
   */
  chamberId?: string;
  message?: string;
  isRead?: boolean;
  /**
   * When the notification was created (UTC).
   * @format date-time
   */
  createDate?: string;
  /**
   * The document the notification is about, if any.
   * @format int32
   */
  documentId?: number | null;
  /**
   * The document's transaction (Filing.FilingID), shown as "Transaction 302705".
   * @format int32
   */
  filingId?: number | null;
  /**
   * The document's transaction (Filing.FilingUniqueId), which opens its judge review page.
   * @format guid
   */
  filingUniqueId?: string | null;
}

/** Marks a chamber notification read or unread. */
export interface JudgeChamberNotificationReadRequest {
  isRead?: boolean;
}

/** One of the user's saved Judge Review list filters ("My saved filters"). Private to the user. */
export interface JudgeReviewSavedFilter {
  /** @format guid */
  savedFilterId?: string;
  name?: string;
  /** The Judge Review list filter criteria a saved filter restores. Every field is optional; empty means "any". */
  filter?: JudgeReviewFilterCriteria;
}

/** The Judge Review list filter criteria a saved filter restores. Every field is optional; empty means "any". */
export interface JudgeReviewFilterCriteria {
  /** Received on or after (yyyy-MM-dd). */
  dateFrom?: string | null;
  /** Received on or before (yyyy-MM-dd). */
  dateTo?: string | null;
  courtName?: string | null;
  caseClass?: string | null;
  documentType?: string | null;
  /** Clerk review status. */
  status?: string | null;
  /** A member's CerberusUser.UniqueId, or "not-assigned". */
  assignee?: string | null;
  /** Tag names, any of which a document must have. */
  tags?: string[];
}

/** Saves the current Judge Review list filter under a name. */
export interface JudgeReviewSavedFilterRequest {
  name?: string | null;
  filter?: JudgeReviewFilterCriteria | null;
}

/**
 * The "Judicial Review — My Pending Work" dashboard summary: the pending review
 * work broken down by document type, and a per-status breakdown (delayed /
 * recently reviewed). The judge-side counterpart of
 * ClerkReviewDashboardSummary.
 *
 * Kept as a distinct type (rather than reusing the clerk summary) so the judge
 * and clerk dashboards can diverge independently.
 */
export interface JudgeReviewDashboardSummary {
  /**
   * The count of pending-review documents grouped by document (filing) type,
   * e.g. "Proposed Orders" → 12.
   */
  documentTypes?: JudgeReviewDocumentTypeCount[];
  /**
   * A per-status breakdown of the judge's pending review work
   * (delayed for judge review, recently reviewed).
   */
  statuses?: JudgeReviewStatusCount[];
}

/**
 * A pending-review count for a single document (filing) type. Carries the
 * numeric FilingTypeId as the identity so the dashboard card can
 * deep-link into the judge review queue by a stable id (not the display label,
 * whose wording could drift between endpoints).
 */
export interface JudgeReviewDocumentTypeCount {
  /**
   * The filing type id (JCMS FilingType key) — the stable identity used to
   * deep-link/filter the judge review queue by document type.
   * @format int32
   */
  filingTypeId?: number;
  /** The display label for the document type (the filing type name). */
  label?: string;
  /**
   * The number of pending-review documents of this type.
   * @format int32
   */
  count?: number;
}

/** A single status bucket in the judge review dashboard summary. */
export interface JudgeReviewStatusCount {
  /** A stable semantic key identifying the bucket ("delayed" / "recentlyReviewed"). */
  key?: string;
  /** The display label for the bucket. */
  label?: string;
  /**
   * The number of items in the bucket.
   * @format int32
   */
  count?: number;
}

/**
 * Top-level judge review queue response. Contains the list of judges the requesting user
 * can act on behalf of (used for court/user filter UI), each carrying their pending review filings.
 */
export interface JudgeReviewSummary {
  /**
   * Judges the requesting user can act on behalf of, derived from UserJudicialAction
   * (UserId = requesting user, UserOnBehalfId = judge).
   * Each entry includes the judge's name, court (for the court filter dropdown), and their pending filings.
   */
  availableJudgeUsers?: AvailableJudgeUser[];
}

/**
 * A judge that the requesting user can act on behalf of, along with that judge's pending review filings.
 * Derived from UserJudicialAction where UserId is the requesting user
 * and UserOnBehalfId is this judge's UserId.
 */
export interface AvailableJudgeUser {
  /**
   * The unique ID (GUID) of the judge user.
   * @format guid
   */
  judgeUniqueId?: string;
  /** The display name of the judge. */
  name?: PersonName;
  /**
   * The court/organization the judge belongs to (CerberusUser.Organization.OrganizationName).
   * Used to populate the court filter in the judge review queue UI.
   */
  courtName?: string | null;
  /** The pending judge review filings assigned to this judge. */
  filings?: JudgeReviewFilingSummary[];
}

/**
 * Summary of a single filing in the judge review queue.
 * Returned as part of Filings inside JudgeReviewSummary.
 */
export interface JudgeReviewFilingSummary {
  /** @format int32 */
  filingId?: number;
  /** @format guid */
  filingUniqueId?: string;
  /** @format date-time */
  filingDate?: string | null;
  /** @format date-time */
  authorizedDate?: string | null;
  /** @format int32 */
  courtId?: number;
  /** @format guid */
  courtUniqueId?: string;
  courtName?: string;
  courtTimeZone?: string;
  /** @format int32 */
  authorizerId?: number | null;
  /** @format int32 */
  authorizerOrganizationId?: number | null;
  authorizerName?: PersonName;
  authorizerOrganizationName?: string;
  status?: string;
  /**
   * Lock status for this filing in the judge review queue.
   * Pending — no judge has this filing open.
   * InProgress — a judge currently holds the UserLock
   * (keyed to judge-review-filing-{FilingUniqueId}).
   */
  judgeReviewStatus?: JudgeReviewStatus;
  isLate?: boolean;
  hasFilerNote?: boolean;
  filerNote?: string | null;
  cases?: ReviewFilingCaseSummary[];
  documents?: ReviewFilingDocumentSummary[];
}

/**
 * A reviewed (attorney) filing as seen by the reviewing judge: a container of documents the judge disposes
 * of through one or more JudgeReviewActions, submitted one at a time.
 */
export interface JudgeReviewFiling {
  /**
   * The GUID of the attorney filing being reviewed. Used as the routing key for all
   * judge review endpoints and as the working-store blob name. Read only.
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly reviewedFilingUniqueId?: string;
  /**
   * The integer JCMS filing ID of the attorney filing being reviewed. Every filing spawned by a submitted
   * action carries this value as its ReviewedFilingId. Read only.
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly reviewedFilingId?: number;
  /**
   * Whether a judge review filing spawned from this reviewed filing is still being processed
   * downstream (read only).
   * @example "boolean --[patch-disabled]"
   */
  readonly inProcess?: boolean;
  /**
   * Whether this is an originating paper filing (read only)
   * @example "boolean --[patch-disabled]"
   */
  readonly isOpf?: boolean;
  /**
   * The GUID of the court this filing belongs to (read only)
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly courtId?: string;
  /**
   * The name of the court this filing belongs to (read only)
   * @example "string --[patch-disabled]"
   */
  readonly courtName?: string;
  /**
   * The display name of the judge performing the review (read only; derived from JudgeReviewerId)
   * @example "object --[patch-disabled]"
   */
  readonly judgeReviewerName?: PersonName | null;
  /**
   * The GUID of the judge performing this review. Patchable to support clerks acting on behalf of a judge.
   * @format guid
   */
  judgeReviewerId?: string;
  /** The cases associated with this filing. Multi-case filings will have multiple entries (read only) */
  readonly judgeReviewCases?: JudgeReviewCase[];
  /**
   * Every document of the reviewed filing assigned to this judge, with the defaults (filing type,
   * watermark, access type) a document takes when it joins an action and its
   * Status (pending / in current action / submitted). The judge's
   * per-document disposition lives on CurrentAction, not here (read only).
   */
  readonly judgeReviewDocuments?: JudgeReviewDocument[];
  /**
   * The single in-progress action, or null when none is in progress. Created and resized through
   * PUT judge-review/filing/{filingId}/current-action/documents, edited through JSON Patch
   * (/currentAction/distribution/..., /currentAction/statusUpdateOnly,
   * /currentAction/documents/{n}/...), finalized by submit and cleared by reset.
   * @example "object --[patch-disabled]"
   */
  readonly currentAction?: JudgeReviewAction | null;
  /**
   * Actions already submitted against this reviewed filing. Returned optimistically by submit and
   * reconciled from the database on every GET (spawned filings by ReviewedFilingId, record-only
   * actions from DocumentHistory), so it is never trusted from the working store alone (read only).
   */
  readonly submittedActions?: JudgeReviewAction[];
  /**
   * Validation errors associated with the current action. It cannot be submitted until all errors are
   * resolved (read only)
   */
  readonly validationErrors?: Error[];
}

export interface JudgeReviewCase {
  /**
   * The GUID of the case (read only)
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly caseId?: string;
  /**
   * The case number (read only)
   * @example "string --[patch-disabled]"
   */
  readonly caseNumber?: string;
  /**
   * The case style/name (read only)
   * @example "string --[patch-disabled]"
   */
  readonly caseName?: string;
  /**
   * The GUID of the case class (read only)
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly caseClassId?: string;
  /**
   * The display name of the case class (read only)
   * @example "string --[patch-disabled]"
   */
  readonly caseClass?: string | null;
  /**
   * The GUID of the case type (read only)
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly caseTypeId?: string;
  /**
   * The display name of the case type (read only)
   * @example "string --[patch-disabled]"
   */
  readonly caseType?: string | null;
  /**
   * The GUID of the court division, if applicable (read only)
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly divisionId?: string | null;
  /**
   * The display name of the court division, if applicable (read only)
   * @example "string --[patch-disabled]"
   */
  readonly division?: string | null;
  /**
   * The primary judge on the case. (read only)
   * @example "object --[patch-disabled]"
   */
  readonly primaryJudge?: JudgeReviewCaseJudge | null;
  /**
   * The alternate judge on the case, if assigned. (read only)
   * @example "object --[patch-disabled]"
   */
  readonly alternateJudge?: JudgeReviewCaseJudge | null;
  /**
   * All primary judges on the case. Populated for courts where AllowMultiplePrimaryJudges is true;
   * contains a single entry otherwise. Used by the clerk-on-behalf judge selector. (read only)
   */
  readonly additionalJudges?: JudgeReviewCaseJudge[];
}

/** A minimal judge reference used in judge assignment collections on JudgeReviewCase. */
export interface JudgeReviewCaseJudge {
  /**
   * The judge's unique identifier (CerberusUser.UniqueId).
   * @format guid
   */
  userId?: string;
  /** The judge's display name. */
  name?: PersonName;
  /** The judge users' Judicial Role (e.g., "Judge", "Magistrate", etc.) as defined in CerberusUser.UserJudicialRoleId. */
  judicialRole?: string | null;
}

export interface JudgeReviewDocument {
  /**
   * The integer ID of the original document. Used to correlate with JudgeReviewDocumentAction in the configuration response (read only)
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly existingDocumentId?: number;
  /**
   * The document's review state, derived from the database on every read: still pending, part of the
   * in-progress CurrentAction, or already submitted (read only).
   * Meaningful on JudgeReviewDocuments; on an action's documents it
   * mirrors the action's state.
   * @example "string --[patch-disabled]"
   */
  readonly status?: JudgeReviewDocumentStatus;
  /** The action the judge wishes to take on this document: KeepOriginal, Replace, or Attach */
  judgeDocumentOption?: JudgeDocumentOption;
  /**
   * The display name of the judge's selected filing type (read only; derived from JudgeReviewFilingTypeId)
   * @example "string --[patch-disabled]"
   */
  readonly judgeReviewFilingType?: string | null;
  /**
   * The GUID of the filing type for the new judge review document. Defaults to the value from UserJudgeReviewSettings. Required for Replace and Attach.
   * @format guid
   */
  judgeReviewFilingTypeId?: string | null;
  /**
   * The working-copy document id in the judge-review DocStore collection. Established by
   * copy-on-open (CreateJudgeReviewFiling) — the filer's document is copied into the
   * judge collection and this field is set to the resulting document id. Read-only; never
   * written by the client.
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly judgeReviewDocumentStoreId?: string | null;
  /**
   * Pre-signed SAS URI for direct upload to Azure Blob Storage.
   * Generated by the API during PATCH when JudgeDocumentOption changes to Replace or Attach.
   * Valid for 1 hour. PUT raw file bytes here with header x-ms-blob-type: BlockBlob and
   * no Authorization header (the SAS URI already encodes credentials).
   * After upload, call the commit endpoint with DocumentStoreId to trigger processing.
   * @format uri
   * @example "uri --[patch-disabled]"
   */
  readonly documentUploadUri?: string | null;
  /**
   * Original file name including extension (e.g. "order.pdf"). Required when
   * JudgeDocumentOption is Replace or Attach; used to create the DocStore slot and
   * determine the rendering pipeline. PATCH this alongside JudgeDocumentOption.
   */
  originalFileName?: string | null;
  /**
   * Display title for the uploaded document. Defaults to the filing type name during
   * DocStore slot creation if not set.
   */
  documentTitle?: string | null;
  /**
   * The display name of the document's access type (read only; derived from AccessTypeId)
   * @example "string --[patch-disabled]"
   */
  readonly accessType?: string | null;
  /**
   * The access type for the judge review document. Values 0 (public) and 4 (unknown) are coerced to 1 during validation.
   * @format int32
   */
  accessTypeId?: number | null;
  /** Scribble stamp options for this document, including assembled text, content flags, and signature type */
  scribble?: JudgeReviewScribble;
  /**
   * Judge-placed annotations on this document: signature stamps, initials stamps, drawn
   * signatures, and free-text overlays. Positions are page-percentage coordinates; drawn
   * signatures carry a self-contained PNG data URL. Persisted in the working-store blob
   * and returned on GET so the front end can re-hydrate them as editable objects on reconnect.
   */
  annotations?: JudgeReviewAnnotation[];
  /** The page(s) to apply the watermark overlay to. Defaults to the value from UserJudgeReviewSettings. */
  watermarkPosition?: WatermarkPosition;
  /**
   * The GUID (JudicialAction.UniqueId) of the judicial action the judge selected for this document.
   * Populated by the UI from the list returned by GetJudgeReviewDocumentActions. Required at submit time
   * to look up the integer JudicialActionId used in the FilingXml and to update
   * DocumentJudgeReview.JudicialActionId. When null the submission pipeline uses
   * the first matching UserJudgeReviewSettings row for this document's filing type as a fallback.
   * @format guid
   */
  selectedJudicialActionId?: string | null;
  /**
   * Whether the uploaded document has been processed and is ready for use. Read-only.
   * @example "boolean --[patch-disabled]"
   */
  readonly isReady?: boolean | null;
  /**
   * Size in bytes of the converted PDF rendering. Read-only.
   * @format int64
   * @example "int64 --[patch-disabled]"
   */
  readonly documentByteCount?: number | null;
  /**
   * Page count of the converted PDF rendering. Read-only.
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly documentPageCount?: number | null;
  /**
   * Visible error message from DocStore if processing failed. Read-only.
   * @example "string --[patch-disabled]"
   */
  readonly docStoreError?: string | null;
  /**
   * Whether the final converted-pdf (produced by the Continue finalize path)
   * is ready. Distinct from IsReady, which tracks the most recent
   * named-rendering completion (preview). Submit is gated on this field for
   * Replace/Attach documents.
   * @example "boolean --[patch-disabled]"
   */
  readonly isFinalReady?: boolean | null;
  /**
   * The number of blank pages the judge has appended to this document's active rendering
   * during the current review session. Incremented by each successful Add Blank Page call
   * and reset to zero by Reset. Used to gate judge-review-attach rendering and
   * submit finalization for KeepOriginal documents that carry only blank-page annotations
   * (no uploaded file).
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly blankPagesAdded?: number;
  /**
   * Whether the judge has completed their review of this document: a non-Pending judicial
   * action is selected and the studio Continue step completed without validation or
   * failure errors. Set by the mark-reviewed endpoint on the successful Continue path while
   * other documents remain outstanding, and cleared by Reset. The last outstanding document
   * is completed by submit (Issue Order) and is never persisted as reviewed before it.
   * @example "boolean --[patch-disabled]"
   */
  readonly isReviewed?: boolean;
}

export interface JudgeReviewScribble {
  /**
   * The assembled scribble stamp text to apply to the document. Assembled by the frontend from ScribbleOptions flags and resolved display values. Maximum 5,000 characters.
   * @maxLength 5000
   */
  scribbleText?: string | null;
  /** Flags indicating which metadata elements to include in the scribble stamp */
  scribbleOptions?: ScribbleOptions;
  /** The type of signature to include in the stamp. Only relevant when ScribbleOptions.IncludeJudgeSignature is true. */
  signatureType?: SignatureType | null;
}

export interface ScribbleOptions {
  /** Include the court name in the scribble stamp */
  includeCourt?: boolean;
  /** Include the judge's name in the scribble stamp */
  includeJudgeName?: boolean;
  /** Include the alternate judge's name in the scribble stamp */
  includeAlternateJudgeName?: boolean;
  /** Include the authorizer's name in the scribble stamp */
  includeAuthorizer?: boolean;
  /** Include the filing ID in the scribble stamp */
  includeFilingId?: boolean;
  /** Include the current date in the scribble stamp */
  includeCurrentDate?: boolean;
  /** Include the case number in the scribble stamp */
  includeCaseNumber?: boolean;
  /** Include the case name in the scribble stamp */
  includeCaseName?: boolean;
  /** Include the judge's signature in the scribble stamp. The signature type (slash or graphic) is set via JudgeReviewScribble.SignatureType. */
  includeJudgeSignature?: boolean;
}

/**
 * A single judge-placed annotation on a document page — signature stamp, initials stamp,
 * drawn signature, free text, or rich comment block. Positions are expressed as
 * page-percentage coordinates so they remain layout-independent across render sizes.
 */
export interface JudgeReviewAnnotation {
  /**
   * Client-assigned unique identifier for this annotation instance.
   * @maxLength 100
   */
  id?: string;
  /**
   * Annotation type. Allowed values: sig, init, draw, block,
   * date, fsx, seal, filed, text, comment, banner, case.
   * Validated against this set by the API — invalid values are rejected with JRD011.
   * @maxLength 10
   */
  type?: string;
  /**
   * 1-based page number the annotation is placed on. Must be >= 1.
   * @format int32
   */
  pageNumber?: number;
  /**
   * Horizontal position as a percentage of the page width (0–100 inclusive).
   * @format double
   */
  xPct?: number;
  /**
   * Vertical position as a percentage of the page height (0–100 inclusive).
   * @format double
   */
  yPct?: number;
  /**
   * Optional free-text content. Only relevant for type = "text" annotations.
   * Maximum 500 characters.
   * @maxLength 500
   */
  text?: string | null;
  /**
   * Optional PNG data URL carrying a drawn signature. Only relevant for type = "draw"
   * annotations. The drawn signature is self-contained so no external asset reference is
   * required. Maximum 2 MB (2,097,152 characters) enforced by the API backstop.
   */
  imageDataUrl?: string | null;
  /**
   * The scribble-option set for a comment annotation — controls which fields
   * (court, case number, judge name, etc.) are included in the rendered comment block.
   * Only relevant for type = "comment" annotations.
   */
  commentOptions?: ScribbleOptions | null;
  /**
   * The signature type (Graphic vs /s/) for a comment annotation.
   * Only relevant for type = "comment" when
   * IncludeJudgeSignature is true.
   */
  commentSignatureType?: SignatureType | null;
  /**
   * Freeform comment text for a comment annotation. Maximum 5,000 characters.
   * Only relevant for type = "comment" annotations.
   * @maxLength 5000
   */
  commentText?: string | null;
  /**
   * Optional judge-chosen box width as a percentage of the page width (greater than 0,
   * at most 100). Currently set only on type = "comment" annotations, whose text
   * wraps to this width. null means the client's default width.
   * @format double
   */
  widthPct?: number | null;
}

/**
 * A judge action on 1, many or all of a reviewed filing's documents. Submitting an action spawns at most
 * one judge-review filing (for its InFiling documents) and records the judicial action directly on its
 * RecordOnly documents. Documents not in the action stay pending.
 */
export interface JudgeReviewAction {
  /**
   * The DocStore collection holding this action's working renderings. Becomes the spawned filing's
   * FilingUniqueId on submit. Empty only for a record-only action rehydrated
   * from the database without an optimistic copy (no collection is known). Read only.
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly collectionId?: string;
  /**
   * The JCMS filing id of the filing this action spawned. Null while in progress and for an action whose
   * documents all resolved to RecordOnly. Read only.
   * @format int32
   * @example "int32 --[patch-disabled]"
   */
  readonly spawnedFilingId?: number | null;
  /**
   * Distribution of the spawned filing. Patchable on the current action
   * (e.g. /currentAction/distribution/filingMode).
   */
  distribution?: JudgeReviewActionDistribution;
  /**
   * Action-level opt-out of File & Serve: when true (and the court/case class allows
   * status-update-only judge review) every document of the action is record-only and no filing is
   * created. Documents of a record-only outcome must carry no judge edits (JRD021).
   */
  statusUpdateOnly?: boolean;
  /**
   * The documents this action operates on, with their dispositions. Membership is set through
   * PUT judge-review/filing/{filingId}/current-action/documents (which establishes the DocStore
   * working copies); individual disposition fields are patchable via
   * /currentAction/documents/{n}/.... Adding or removing entries by JSON Patch is disabled.
   */
  readonly documents?: JudgeReviewActionDocument[];
  /**
   * The UniqueId of the judge the action was taken by (the reviewing judge; clerks act on behalf of
   * the judge). Empty while in progress. Read only.
   * @format guid
   * @example "guid --[patch-disabled]"
   */
  readonly actedByUserId?: string;
  /**
   * When the action was submitted (Eastern time with offset). Null while in progress. Read only.
   * @format date-time
   * @example "date-time --[patch-disabled]"
   */
  readonly actedDate?: string | null;
}

/**
 * Distribution of the filing a JudgeReviewAction spawns. One per action, so every
 * InFiling document of an action shares it. Ignored (and not validated) when every document of the
 * action resolves to record-only, because no filing is created.
 */
export interface JudgeReviewActionDistribution {
  /** Controls how the spawned judge review filing is distributed after submission. */
  filingMode?: JudgeReviewFilingMode;
  /**
   * The CaseParticipant.UniqueId (JCMS combination id) values of the specific
   * party/attorney combinations to serve when FilingMode is
   * CustomServiceList.
   * Must be null or empty for all other filing modes (JRF005 CustomServiceListConflict) and must
   * contain at least one entry for CustomServiceList
   * (JRF006 CustomServiceListRequired). Identifiers correspond to
   * JudgeReviewFilingConfiguration.ServiceableParticipants.
   */
  customServiceListParticipantIds?: string[] | null;
  /**
   * Additional recipients entered by the judge (write-ins or user-search results). Resolved at submit
   * time: a recipient with a known UserUniqueId is emitted as that user; an unknown email
   * produces a write-in add-in. Only emitted for CustomServiceList
   * (and the legacy-era FileToCourt).
   */
  additionalRecipients?: JudgeReviewFilingAdditionalRecipient[] | null;
  /**
   * Judge-provided mailing addresses for unrepresented case participants on the service list, keyed by
   * CaseParticipant.UniqueId. Used at submit to populate the party address in the FilingXml for
   * US-Mail service and to upsert the party's ProSeService address in JCMS.
   */
  mailingAddresses?: JudgeReviewMailingAddress[] | null;
  /**
   * Whether the judge checked Court Ruling Transaction Charge for the spawned filing. Only relevant when
   * JudgeReviewFilingConfiguration.ShowCourtRulingTransactionCharge is true. Sets the spawned
   * filing's description and court-ruling fee organization.
   */
  courtRulingTransactionCharge?: boolean;
}

/**
 * An additional recipient entered by the judge — resolved at submit time via
 * AdditionalRecipientResolver. Mirrors FilingDraftAdditionalRecipient.
 */
export interface JudgeReviewFilingAdditionalRecipient {
  /**
   * If this recipient was retrieved from a user search, the User GUID.
   * Null for new (unknown) recipients; resolution falls back to Email.
   * @format guid
   */
  userUniqueId?: string | null;
  /** The recipient's name, used for write-in entries when no matching user is found. */
  name?: PersonName | null;
  /** The recipient's email address. */
  email?: string | null;
}

/**
 * A mailing address provided by the judge for a specific unrepresented (no-representation)
 * case participant. Keyed by the participant's CaseParticipant.UniqueId (the stable
 * party/attorney combination id returned in
 * JudgeReviewFilingConfiguration.ServiceableParticipants).
 */
export interface JudgeReviewMailingAddress {
  /**
   * The CaseParticipant.UniqueId (JCMS combination id) of the unrepresented case
   * participant this address applies to. Corresponds to
   * Models.Filing.CaseParticipant.CaseParticipantUniqueId in the serviceable-participants
   * roster.
   * @format guid
   */
  caseParticipantUniqueId?: string;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  /** State abbreviation (e.g. "CA"). */
  stateCode?: string | null;
  /**
   * @minLength 5
   * @maxLength 5
   */
  zipCode?: string | null;
  /**
   * @minLength 4
   * @maxLength 4
   */
  zipCodeExtension?: string | null;
}

/**
 * A reviewed document taking part in a JudgeReviewAction: the judge's per-document
 * disposition (every JudgeReviewDocument field: option, judicial action, annotations,
 * scribble, watermark, working copy) plus the outcome the server resolved at submit.
 */
export type JudgeReviewActionDocument = JudgeReviewDocument & {
  /**
   * The outcome resolved at submit: InFiling or
   * RecordOnly. Null while the action is still the
   * in-progress CurrentAction. Read only.
   */
  resolvedOutcome?: JudgeReviewActionDocumentOutcome | null;
};

/** @example [{"op":"replace","path":"/root/property","value":"new value"}] */
export type JsonPatchDocumentOfJudgeReviewFiling = {
  /** The operation to be performed */
  op: "add" | "remove" | "replace" | "move" | "copy" | "test";
  /** JSON pointer to the property to modify */
  path: string;
  /** The value to set (for add, replace operations) */
  value?: any | null;
  /** JSON pointer to copy/move from (for copy, move operations) */
  from?: string | null;
}[];

export type OperationOfJudgeReviewFiling = Operation & object;

/**
 * The response returned by POST /judge-review/filing/{filingId}/submit for the action just
 * submitted. Provides the receipt data for the Confirmation and Receipt screens plus the per-action
 * result (CollectionId, SpawnedFilingId, per-document
 * ResolvedOutcome, RemainingPendingCount)
 * and the submitted Action itself, so the front end can flip the acted documents
 * read-only immediately.
 */
export interface JudgeReviewSubmitResponse {
  /**
   * The new JCMS filing id for the judge-review filing — this is the "Transaction id"
   * shown on the receipt. Null when every document of the action was record-only (no new filing is
   * created). Same value as SpawnedFilingId.
   * @format int32
   */
  filingId?: number | null;
  /**
   * The submitted action's DocStore collection id; the spawned filing's FilingUniqueId when a
   * filing was created.
   * @format guid
   */
  collectionId?: string;
  /**
   * The JCMS filing id the action spawned, or null when every document was record-only.
   * @format int32
   */
  spawnedFilingId?: number | null;
  /**
   * Number of the judge's documents on the reviewed filing still pending after this action.
   * @format int32
   */
  remainingPendingCount?: number;
  /** The submitted action, as optimistically moved into SubmittedActions. */
  action?: JudgeReviewAction | null;
  /**
   * The original reviewed filing id (the attorney's transaction).
   * @format int32
   */
  reviewedFilingId?: number;
  /** Display name of the judge who submitted the review (filer = authorizer in JR). */
  submittedBy?: string;
  /** Organization of the submitting judge. */
  submittedByOrganization?: string;
  /** Display name of the authorizer (same as SubmittedBy in JR — judge is always the authorizer). */
  authorizedBy?: string;
  /** Organization of the authorizer. */
  authorizedByOrganization?: string;
  /**
   * Authoritative Filed & Served timestamp (UTC).
   * @format date-time
   */
  authorizedDate?: string;
  /**
   * True when the action recorded judicial actions directly on the existing documents
   * without creating a new filing (every document resolved to record-only).
   * Drives the receipt copy: "no document served" vs "signed / filed / served".
   */
  isStatusUpdateOnly?: boolean;
  /**
   * One entry per reviewed document — includes the disposition label and DocStore id
   * so the UI can display per-document outcomes and optionally re-fetch from DocStore.
   */
  documents?: JudgeReviewSubmitResponseDocument[];
}

/** Per-document outcome in a JudgeReviewSubmitResponse. */
export interface JudgeReviewSubmitResponseDocument {
  /**
   * The original JCMS document id (correlates to ExistingDocumentId).
   * @format int32
   */
  existingDocumentId?: number;
  /** The document title as set by the judge, or null if unchanged from the original. */
  documentTitle?: string | null;
  /** The filing type display name (e.g. "Proposed Order"). */
  filingType?: string | null;
  /**
   * The judicial action label the judge applied to this document (e.g. "Grant", "Deny").
   * Null if no action was resolved.
   */
  disposition?: string | null;
  /**
   * The GUID of the judicial action taken, as selected by the judge.
   * Matches SelectedJudicialActionId.
   * @format guid
   */
  judicialActionId?: string | null;
  /** The option the judge chose for this document. */
  judgeDocumentOption?: JudgeDocumentOption;
  /**
   * DocStore collection document id for the judge's uploaded / composed document.
   * Non-null for Replace and
   * Attach documents; null for
   * KeepOriginal.
   * The UI can use this to query DocStore for document preview on the receipt.
   * @format guid
   */
  documentStoreId?: string | null;
  /** Whether the document went into the spawned filing or was recorded directly on the reviewed document. */
  resolvedOutcome?: JudgeReviewActionDocumentOutcome;
}

/**
 * Request body of PUT judge-review/filing/{filingId}/current-action/documents: the complete set of
 * reviewed documents the in-progress CurrentAction operates on.
 */
export interface JudgeReviewCurrentActionDocuments {
  /**
   * The ExistingDocumentId of every document in the action (1, many or
   * all of the still-pending documents). Replaces the current membership: new documents are added with
   * their configured defaults and a fresh working copy, omitted documents are dropped from the action,
   * and documents already in the action keep their disposition.
   */
  existingDocumentIds?: number[];
}

export interface JudgeReviewFilingConfiguration {
  /**
   * The GUID of the filing this configuration applies to
   * @format guid
   */
  filingUniqueId?: string;
  /**
   * The integer ID of the filing this configuration applies to
   * @format int32
   */
  filingId?: number;
  /** The name of the attorney who submitted the original filing */
  filerName?: PersonName | null;
  /** The organization name of the attorney who submitted the original filing */
  filerOrganizationName?: string | null;
  /** The name of the user who authorized the original filing */
  filingAuthorizerName?: PersonName | null;
  /** The organization name of the authorizer for the original filing */
  filingAuthorizerOrganizationName?: string | null;
  /** Optional note from the filer to the clerk */
  filerNote?: string | null;
  /** The filer's client matter code (Filing.FilingDesc). */
  clientMatterCode?: string | null;
  /** The filer's comment on the filing. */
  filingComment?: string | null;
  /** Financial comment on the filing. */
  financialComment?: string | null;
  /**
   * Sum of the statutory fees across every non-rejected document on the filing — both the documents
   * assigned to this judge and the other documents in the transaction — matching Clerk Review and
   * Transaction Details. Displayed as the total statutory fee on the Transaction Detail preview page.
   * @format decimal
   */
  totalStatutoryFee?: number;
  /**
   * The date and time the original filing was authorized (filed and served).
   * Sourced from Filing.AuthorizedDate, converted to UTC.
   * Displayed as the "Filed & Served" timestamp on the Transaction Detail page.
   * @format date-time
   */
  filedAndServedDate?: string | null;
  /**
   * Maximum size in bytes for a single uploaded document (Replace/Attach).
   * Sourced from Court.MaxDocFileByteCount. The frontend should enforce this client-side
   * before sending the upload request.
   * @format int32
   */
  maxDocumentSizeBytes?: number;
  /**
   * Maximum combined size in bytes for all documents in the filing.
   * Sourced from Court.MaxTotalDocFileByteCount.
   * @format int32
   */
  maxTotalDocumentSizeBytes?: number;
  /**
   * File extensions accepted for Replace/Attach uploads at this court and case class.
   * Sourced from CourtCaseFilingTypeDocumentFormats where Accept = true and Deny = false,
   * deduplicated across all filing types for this court + case class.
   * Extensions are uppercase without a leading dot (e.g. "PDF", "DOCX").
   * An empty list means no court-level format restrictions are configured.
   */
  allowedFileExtensions?: string[];
  /**
   * Per-document source data and user settings. Each entry corresponds to a document assigned to this judge for review
   * (i.e., present in DocumentJudgeReview for this judge). Displayed in the "Pending Your Review" section.
   */
  judgeReviewDocumentActions?: JudgeReviewDocumentAction[];
  /**
   * Other documents on the original attorney filing that are NOT assigned to this judge for review.
   * Displayed in the "Other Documents in this Transaction" section of the Transaction Detail page.
   * Each entry exposes a DocumentStoreId that the frontend can use to fetch any rendering
   * from DocStore (e.g. "converted-pdf" for PDF Format, "original" for Original Format).
   */
  transactionDocuments?: JudgeReviewTransactionDocument[];
  /** Parties who submitted the original filing. */
  sendingParticipants?: JudgeReviewSendingParticipant[];
  /** Service list recipients derived from the filing's service configuration. */
  serviceParticipants?: JudgeReviewServiceParticipant[];
  /** Add-in (additional) service recipients. */
  additionalRecipients?: JudgeReviewAdditionalRecipient[];
  /**
   * All active case participants the judge may include on the service list.
   * Returned in the CaseParticipant[] shape consumed by the FE
   * app-cp-list-table component (party + representations + service method).
   * Matches the universe BuildJrParticipantRequestsAsync resolves at submit so the
   * picker and submit path never drift.
   */
  serviceableParticipants?: CaseParticipant[];
  /** Courtesy copy recipients. Only populated when CourtProfile.AllowCourtesyCopies is true. */
  courtesyCopyRecipients?: JudgeReviewCourtesyCopyRecipient[];
  /** Whether this case class allows multiple primary judges to be assigned simultaneously */
  allowMultiplePrimaryJudges?: boolean;
  /** Whether to show the primary judge field on the case info display. */
  showPrimaryJudge?: boolean;
  /** Whether to show the alternate judge field on the case info display. */
  showAlternateJudge?: boolean;
  /** Whether this case class allows the judge to update document status without creating a new filing */
  allowStatusUpdateOnly?: boolean;
  /** Whether this case class allows the clerk to set a delay date controlling when a document appears in the judge's queue */
  allowDelayingJudgeReview?: boolean;
  /** Whether a graphic signature image file is available for the primary judge. When false, only slash signature (/s/) is available. */
  isGraphicSignatureAvailable?: boolean;
  /**
   * Whether a graphic signature image file is available for the alternate judge.
   * False when no alternate judge is assigned to the case or when no signature file exists for them.
   */
  isAlternateGraphicSignatureAvailable?: boolean;
  /**
   * Whether the court allows courtesy copies on this filing. Controls visibility of
   * CourtesyCopyRecipients on the filing.
   */
  allowCourtesyCopies?: boolean;
  /**
   * Whether the court has the Court Ruling Transaction Charge feature enabled
   * (CourtProfile.CourtRulingFee). When true, show the checkbox on the judge review page.
   */
  showCourtRulingTransactionCharge?: boolean;
  /**
   * Available access / security type options for the Security select in the studio Document Details panel.
   * Court + case-class filtered (same logic as clerk review). Judges can set Sealed, InCamera, Suppressed
   * where permitted by CourtCaseClass configuration.
   */
  accessTypes?: FilingAccessTypeConfiguration[];
  /**
   * Available filing types for the Document Type select in the studio Document Details panel.
   * Court + case-class filtered: active CourtCaseFilingType rows whose
   * GroupFilingAccess is Both (0) or ClerkOnly (1).
   * FirmOnly (2) and inactive types are excluded.
   * Sourced once at the filing level — not per-document — because the court's type list
   * is the same for every document in the filing.
   */
  courtFilingTypes?: DisplayFieldOfGuid[];
  /**
   * 1-hour read SAS URL for the judge's own banner — the overlay file uploaded per judge +
   * court + case class in legacy Judge Review setup (UserJudgeReviewSettings.WatermarkFile,
   * .pdf or .rtf). An RTF is converted to PDF first and this URL points at the
   * converted copy, so the value is always something the browser can render. Null when the
   * judge has no banner configured or the conversion failed.
   */
  judgeBannerUrl?: string | null;
  /**
   * The corner the judge's banner is anchored to, from
   * UserJudgeReviewSettings.OverlayAlignment. Legacy applies the banner as a
   * corner-anchored overlay rather than letting the judge position it, so the studio applies
   * it automatically at this corner. Defaults to TopRight when
   * the column is null, matching UserJudgeReviewSettingsGetAlignment.
   */
  judgeBannerAlignment?: OverlayAlignment;
  /** Court seal stamp image URL. Null — source to be determined by business. */
  courtSealUrl?: string | null;
  /** Filed stamp image URL. Null — source to be determined by business. */
  filedStampUrl?: string | null;
}

export interface JudgeReviewDocumentAction {
  /**
   * The integer ID of the document. Correlates with JudgeReviewDocument.ExistingDocumentId in the filing patch object.
   * @format int32
   */
  documentId?: number;
  /** The title of the original document as submitted by the attorney */
  documentTitle?: string | null;
  /**
   * Store reference GUID for loading and displaying the original document PDF
   * @format guid
   */
  documentStoreId?: string;
  /** The display name of the document's original filing type */
  filingType?: string | null;
  /**
   * The GUID of the document's original filing type
   * @format guid
   */
  filingTypeId?: string;
  /**
   * The ID of the redacted version of this document, if one exists
   * @format int32
   */
  redactedDocumentId?: number | null;
  /**
   * The date and time this document was assigned to the judge's review queue (from DocumentJudgeReview.SendDate)
   * @format date-time
   */
  judgeReviewDate?: string | null;
  /** The judge's applicable user settings for this document, one entry per judicial action the judge is configured for on this filing type */
  judgeReviewUserSettings?: JudgeReviewUserSetting[];
  /**
   * The statutory fee for this document, as set by the clerk during clerk review.
   * For FSX courts: sum of DocumentFee rows matching CcFilingTypeFee entries for this court + case class + filing type.
   * For FSIL (Cook County): sum of all DocumentFee rows.
   * Zero when no fees are recorded. Read-only for judges; only the clerk can change this value.
   * @format decimal
   */
  statutoryFee?: number;
  /**
   * True when Document.RelatedDocumentId is 0 or NULL (main document in the filing).
   * False when RelatedDocumentId is non-zero (supporting/attached document).
   */
  isMainDocument?: boolean;
  /**
   * True when this document has cross-filing links in the DocumentLinking table, i.e.
   * LinkedDocuments is not empty. Controls whether to show the "Linked Documents" action.
   */
  hasLinkedDocuments?: boolean;
  /**
   * The documents linked to this one through DocumentLinking, in either direction, oldest
   * filing first. Listed by the "Linked Documents" action. Empty when there are none.
   */
  linkedDocuments?: JudgeReviewLinkedDocument[];
}

export interface JudgeReviewUserSetting {
  /** The display name of the judicial action this setting applies to */
  judicialAction?: string | null;
  /**
   * The GUID of the judicial action this setting applies to
   * @format guid
   */
  judicialActionId?: string;
  /** When true, the judge creates a new filing on review. When false, the judicial action is recorded directly on the document without creating a filing. */
  createNewFiling?: boolean;
  /** Whether to show the scribble/comments stamp section for this document */
  scribblePage?: boolean;
  /** The default position for the scribble stamp: true = first page, false = last page */
  scribbleFirstPage?: boolean;
  /** The filename of the watermark overlay to apply to the document. Null or empty means no watermark section is shown for this document. */
  watermarkFile?: string | null;
  /** The default watermark position for this document */
  defaultWatermarkPosition?: WatermarkPosition;
  /**
   * The GUID of the default filing type to pre-populate when the judge creates a new judge review document
   * @format guid
   */
  judgeFilingTypeId?: string;
}

/**
 * A document in another filing that is linked to a document on the judge-review filing through
 * DocumentLinking. Listed by the "Linked Documents" action on the Transaction Detail page.
 */
export interface JudgeReviewLinkedDocument {
  /**
   * The integer ID of the linked document (JCMS Document.DocumentId). Use it with the
   * documents/documentid/{documentId}/rendering/{rendering}/download endpoint to open it.
   * @format int32
   */
  documentId?: number;
  /** The title of the linked document as submitted. */
  documentTitle?: string | null;
  /** The display name of the linked document's filing type (e.g. "Motion", "Exhibit(s)"). */
  filingType?: string | null;
  /**
   * Number of pages in the linked document.
   * @format int32
   */
  pageCount?: number | null;
  /**
   * The transaction (JCMS Filing.FilingId) the linked document was filed in.
   * @format int32
   */
  transactionId?: number;
  /**
   * When the linked document's filing was submitted, in UTC. Null for filings never submitted.
   * @format date-time
   */
  filingDate?: string | null;
  /** Case number of the linked document's filing (its first case on a multi-case filing). */
  caseNumber?: string | null;
  /** Case name (case style) of the linked document's filing. */
  caseName?: string | null;
  /** Whether the reviewed document links to this document or this document links to it. */
  direction?: JudgeReviewLinkDirection;
}

/**
 * A document on the original attorney filing that is NOT assigned to this judge for review
 * (i.e., not present in DocumentJudgeReview for this judge).
 * Displayed in the "Other Documents in this Transaction" section of the Transaction Detail page.
 */
export interface JudgeReviewTransactionDocument {
  /**
   * The integer ID of the document (JCMS Document.DocumentId).
   * @format int32
   */
  documentId?: number;
  /** The title of the document as submitted by the attorney. */
  documentTitle?: string | null;
  /**
   * The GUID of the document's filing type.
   * @format guid
   */
  filingTypeId?: string;
  /** The display name of the document's filing type (e.g. "Motion", "Exhibit(s)"). */
  filingType?: string | null;
  /**
   * True when Document.RelatedDocumentId is 0 or NULL (main document in the filing).
   * False when RelatedDocumentId != 0 (supporting/attached document).
   */
  isMainDocument?: boolean;
  /**
   * Number of pages in the document.
   * @format int32
   */
  pageCount?: number | null;
  /**
   * DocStore document identifier. Use this with the appropriate RenderingName to fetch
   * any stored version of the document from DocStore:
   * "original"The raw bytes originally uploaded by the attorney.
   * "converted-pdf"The document converted to PDF (use for "PDF Format" link).
   * "clerk-stamped-pdf"The clerk-stamped copy, if clerk review has been completed.
   * All renderings are accessed via the same DocumentStoreId — only the rendering name differs.
   * @format guid
   */
  documentStoreId?: string;
  /**
   * True when this document has cross-filing links in the DocumentLinking table —
   * i.e., it is either the source of a link (documentID side, LinkTo > 0)
   * or the target of a link (relatedDocID side, LinkFrom > 0).
   * Controls whether to show the "Linked Documents" action for this document.
   * True exactly when LinkedDocuments is not empty.
   */
  hasLinkedDocuments?: boolean;
  /**
   * The documents linked to this one through DocumentLinking, in either direction, oldest
   * filing first. Listed by the "Linked Documents" action. Empty when there are none.
   */
  linkedDocuments?: JudgeReviewLinkedDocument[];
}

export interface JudgeReviewSendingParticipant {
  /**
   * The CerberusUser.UniqueId of the attorney or SR party for this participant.
   * Always populated — SR users are full CerberusUser accounts and always have a UniqueId.
   * @format guid
   */
  userUniqueId?: string;
  party?: PersonName | null;
  /** @format guid */
  partyTypeId?: string | null;
  partyType?: string | null;
  attorney?: PersonName | null;
  /** @format guid */
  attorneyTypeId?: string | null;
  attorneyType?: string | null;
  organizationName?: string | null;
  /**
   * Whether this participant is marked confidential on the case.
   * Null for multi-case filings (confidential parties not yet supported for multi-case).
   */
  confidential?: boolean | null;
}

export interface JudgeReviewServiceParticipant {
  /** Formatted attorney or delivery person name (UserFiling.DeliveryName). */
  attorneyName?: string | null;
  /** Organization name (UserFiling.DeliveryOrganizationName). */
  organizationName?: string | null;
  /**
   * Formatted party name. Sourced from UserFilingParty.DeliveryPartyName when
   * available, falling back to UserFiling.DeliveryName — matching legacy SP:
   * ISNULL(ufp.DeliveryPartyName, uf.DeliveryName).
   */
  partyName?: string | null;
  /** Party type description (PartyType.PartyType1 via UserFilingParty.PartyTypeId). */
  partyType?: string | null;
  /**
   * Delivery method label (Email, US Mail, Fax, etc.), derived from
   * UserFiling.DeliveryMethodId using the DeliveryMethod enum.
   */
  deliveryMethod?: string | null;
  /**
   * Derived from UserFiling.DeliveryError and UserFiling.ConfirmationDate.
   * Mirrors the legacy SP CASE expression:
   *   DeliveryError = 'Cancelled' → Cancelled
   *   DeliveryError IS NOT NULL   → Undeliverable
   *   ConfirmationDate IS NOT NULL → Delivered
   *   else                         → Sent
   */
  receiptStatus?: string;
  /** Delivery address (UserFiling.DeliveryAddress). */
  deliveryAddress?: string | null;
}

export interface JudgeReviewAdditionalRecipient {
  /**
   * Recipient name. Sourced from AddInService.AddInName or UserFiling.DeliveryName
   * (aliased as AddInName in the legacy SP UNION).
   */
  name?: string | null;
  /**
   * Delivery method label (Email, US Mail, Fax, etc.), derived from
   * DeliveryMethodId using the DeliveryMethod enum.
   */
  deliveryMethod?: string | null;
  /** Delivery address. */
  deliveryAddress?: string | null;
  /**
   * Derived from DeliveryError and ConfirmationDate.
   * Mirrors the legacy SP CASE expression:
   *   DeliveryError = 'Cancelled' → Cancelled
   *   DeliveryError IS NOT NULL   → Undeliverable
   *   ConfirmationDate IS NOT NULL → Delivered
   *   else                         → Sent
   */
  receiptStatus?: string;
}

export interface CaseParticipant {
  /** @format guid */
  caseParticipantUniqueId?: string | null;
  party?: Party;
  attorneys?: Representation[];
}

export interface Party {
  /** @format guid */
  tempPartyId?: string | null;
  /** @format int32 */
  partyId?: number | null;
  /** @format int32 */
  role?: number;
  /** @format int32 */
  partyTypeId?: number;
  partyType?: string | null;
  /** @format int32 */
  entityTypeId?: number;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string;
  suffix?: string | null;
  isConfidentialParty?: boolean;
  ssn?: string | null;
  dateOfBirth?: string | null;
  phone?: PartyPhone | null;
  email?: string | null;
  addresses?: Address[];
  aliases?: PartyAlias[];
  lexicalOrderName?: string;
}

export interface PartyPhone {
  phoneNumber?: string;
  extension?: string | null;
}

export interface PartyAlias {
  /** @format int32 */
  aliasTypeId?: number;
  /** @format int32 */
  entityTypeId?: number;
  firstName?: string | null;
  middleName?: string | null;
  lastName: string;
  suffix?: string | null;
  addresses?: Address[];
  phone?: PartyPhone | null;
  email?: string | null;
}

export interface Representation {
  /** @format guid */
  attorneyId?: string | null;
  proSe?: boolean;
  /** @format int32 */
  attorneyTypeId?: number | null;
  attorneyType?: string | null;
  /** @format int32 */
  counselTypeId?: number | null;
  attorneyName?: string | null;
  attorneyOrganizationName?: string | null;
  /** @format guid */
  organizationId?: string | null;
  /** @format int32 */
  serviceMethodId?: number | null;
  serviceMethod?: string | null;
}

export interface JudgeReviewCourtesyCopyRecipient {
  /**
   * The judge receiving the courtesy copy.
   * Sourced from CourtBranchLocationJudge — name fields constructed into PersonName
   * (no Prefix/Suffix on this entity).
   */
  judgeName?: PersonName | null;
  /** Mailing address — CourtBranchLocationJudge.StreetLine1. */
  streetLine1?: string | null;
  /** Mailing address — CourtBranchLocationJudge.StreetLine2. */
  streetLine2?: string | null;
  /** Mailing address — CourtBranchLocationJudge.City. */
  city?: string | null;
  /** Mailing address — CourtBranchLocationJudge.State. */
  state?: string | null;
  /** Mailing address — CourtBranchLocationJudge.ZipCode. */
  zipCode?: string | null;
  /** Mailing address — CourtBranchLocationJudge.ZipCodeExtension. */
  zipCodeExtension?: string | null;
  /** Delivery option label (e.g. "First Class Mail") — DeliveryOption.Description. */
  deliveryDescription?: string | null;
}

/** The unread-item count for a mailbox list (used by the nav badge). */
export interface UnreadCountResult {
  /** @format int32 */
  count?: number;
}

/** Response wrapper for the Sent Items query. */
export type SentQueryResponse = QueryResponseOfSentItem & object;

export interface QueryResponseOfSentItem {
  data?: SentItem[];
  /** @format int32 */
  count?: number | null;
  /** @format int32 */
  skip?: number;
  /** @format int32 */
  take?: number;
  sortBy?: string;
  sortOrder?: string;
}

/** A Sent Items filing (authored by the current user or organization). */
export type SentItem = MailboxItem & {
  /** The filing's status text. */
  filingStatus?: string | null;
  /**
   * Whether the current user may hard-remove this filing (only pending
   * filings — legacy RemovePendingFiling, gated on CompleteDocumentsPending).
   */
  canRemove?: boolean;
};

/**
 * Query request for the Sent Items list (filings authored by the user or the
 * user's organization). Ported from the legacy DisplayFilingList.aspx (go=outbox)
 * filters; adds the My-vs-Firm scope toggle.
 */
export type SentQueryRequest = InboxQueryRequest & {
  /**
   * Whose sent items to return: the current user's, or the whole organization's.
   * @default "Mine"
   */
  scope?: SentScope;
};

export interface GetMessageBoardResult {
  /** @format int32 */
  forumID?: number;
  unread?: boolean;
  name?: string;
  courtName?: string;
  caseNumber?: string | null;
  /** @format date-time */
  lastPostDate?: string | null;
  lastPostBy?: string;
}

export interface GetForumSubjectsByForumIDResult {
  unread?: boolean;
  /** @format int32 */
  postID?: number;
  subject?: string | null;
  postAuthor?: string | null;
  /** @format int32 */
  totalReplies?: number;
  /** @format date-time */
  lastPostDate?: string;
}

export interface GetForumsPostResult {
  /** @format int32 */
  postId?: number;
  /** @format int32 */
  forumId?: number;
  postAuthor?: string | null;
  /** @format date-time */
  postDate?: string;
  subject?: string | null;
  body?: string | null;
  formattedBody?: string | null;
  readOnly?: boolean;
  /** @format int32 */
  prevPostId?: number;
  /** @format int32 */
  nextPostId?: number;
  trackingThread?: boolean;
  organizationName?: string | null;
}

export interface CourtBase {
  /** @format guid */
  orgId?: string;
  name?: string;
  state?: string;
}

export interface ActivateMessageBoardDTO {
  /** @format int32 */
  courtID?: number;
  /** @format int32 */
  caseID?: number;
  messageBoardName?: string;
  billingReference?: string;
}

export interface GetCaseActivationResult {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  caseId?: number;
  caseNumber?: string | null;
  caseName?: string | null;
  caseStatus?: string | null;
  messageBoardName?: string | null;
  /** @format int32 */
  forumId?: number | null;
  /** @format int32 */
  lnForumId?: number | null;
}

export interface GetCasesDTO {
  /** @format guid */
  courtId?: string;
  caseName?: string | null;
  caseNumber?: string | null;
}

export interface ForumPostMessage {
  /** @format int32 */
  id?: number | null;
  /** @format int32 */
  forumID?: number;
  subject?: string;
  /** @format int32 */
  postType?: number;
  /** @format int32 */
  userId?: number;
  body?: string;
  /** @format int32 */
  parentId?: number | null;
}

export interface NewRegistration {
  captchaToken?: string;
  orgInformation?: OSOrganization;
  primaryContact?: OSUser;
  billingContact?: OSUser | null;
  contactType?: OSContactType;
  footer?: OSAuthorizer;
  terms?: boolean;
  firmAdministrator?: OSUser;
  additionalUsers?: OSUser[];
  agentId?: string | null;
  efmId?: string | null;
}

export interface OSOrganization {
  orgType?: OrganizationType;
  name?: string;
  address?: string;
  country?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export interface OSUser {
  userType?: UserType;
  contact?: OSContact;
  isBillingContact?: boolean;
  barNumbers?: OSBarInformation[];
}

export interface OSContact {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  suffixName?: string;
  email?: string;
  phone?: string;
  phoneExtension?: string;
}

export interface OSBarInformation {
  barNumber?: string;
  state?: string;
}

export interface OSAuthorizer {
  authorizedRepresentative?: string;
  authorizersTitle?: string;
}

export interface NewSRIRegistration {
  captchaToken?: string;
  contactType?: OSContactType;
  sriPrimaryContact?: SRIContact;
  footer?: OSAuthorizer;
}

export interface SRIContact {
  contact?: OSContact;
  address?: OSOrganization;
}

export interface Form50Agent {
  agentId?: string;
  efmId?: string;
  firstName?: string;
  middleName?: string | null;
  lastName?: string;
  suffixName?: string | null;
  email?: string;
  phone?: string;
}

export interface Form50AgentRequest {
  agentId?: string;
  lastName?: string;
}

export interface ListResponseOfUserTypeItem {
  data?: UserTypeItem[];
}

export interface UserTypeItem {
  id?: string;
  name?: string;
  /** @format int32 */
  groupId?: number | null;
  member?: boolean;
}

export interface MandatoryBillingReferenceTransactionType {
  /** @format int32 */
  mandatoryBillingReferenceId?: number;
  mandatoryBillingReferenceName?: string;
}

export interface OrganizationInformation {
  /** @format guid */
  uniqueId?: string;
  name?: string;
  type?: string;
  country?: string;
  courtLevel?: string | null;
  streetAddress?: string;
  streetAddress2?: string | null;
  city?: string;
  stateCode?: string;
  state?: string;
  zipCode?: string;
  phone?: string;
  email?: string;
  /** @format guid */
  primaryContactUniqueId?: string | null;
  primaryContactName?: string | null;
  customDocumentListNotesEnabled?: boolean;
  caseNotesEnabled?: boolean;
  documentNotesEnabled?: boolean;
  /** @format guid */
  billingContactUniqueId?: string | null;
  billingContactName?: string | null;
  electronicInvoiceOnly?: boolean | null;
  electronicInvoiceEmail?: string | null;
  mandatoryBillingReferenceTransactions?: MandatoryBillingReferenceTransaction[];
}

export interface MandatoryBillingReferenceTransaction {
  /** @format int32 */
  mandatoryBillingReferenceId?: number;
  mandatoryBillingReferenceName?: string;
  isMandatory?: boolean;
}

export interface OrganizationInformationRequest {
  /**
   * @minLength 1
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9\s'.\-]*$
   */
  streetAddress: string;
  /**
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9\s'.\-]*$
   */
  streetAddress2?: string | null;
  /**
   * @minLength 1
   * @pattern ^[a-zA-Z\s'-]*$
   */
  city: string;
  /** @minLength 1 */
  stateCode: string;
  /**
   * @minLength 1
   * @pattern ^\d{5}(-\d{4})?$
   */
  zipCode: string;
  /** @pattern ^([0-9]( |-)?)?(\(?[0-9]{3}\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4}|[a-zA-Z0-9]{7})$ */
  phone?: string | null;
  /**
   * @format email
   * @pattern ^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$
   */
  email?: string | null;
  /** @format guid */
  primaryContactUniqueId?: string;
  customDocumentListNotesEnabled?: boolean;
  caseNotesEnabled?: boolean;
  documentNotesEnabled?: boolean;
  /** @format guid */
  billingContactUniqueId?: string | null;
  electronicInvoiceOnly?: boolean | null;
  /**
   * @format email
   * @maxLength 150
   * @pattern ^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$
   */
  electronicInvoiceEmail?: string | null;
  mandatoryBillingReferenceTransactions?:
    | MandatoryBillingReferenceTransactionRequest[]
    | null;
}

export interface MandatoryBillingReferenceTransactionRequest {
  /** @format int32 */
  mandatoryBillingReferenceId?: number;
  isMandatory?: boolean;
}

export interface ListResponseOfUserDetails {
  data?: UserDetails[];
}

export interface UserDetails {
  /** @format int32 */
  id?: number;
  /** @format guid */
  uniqueId?: string;
  name?: string;
  loginName?: string;
  userTypeId?: string;
  userType?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  suffix?: string;
  phone?: string;
  email?: string;
}

export interface NewUserResponse {
  /** @format guid */
  userId?: string;
  loginName?: string;
  email?: string;
}

export interface QueuedChange {
  /** @format int32 */
  entryId?: number;
  /** @format int32 */
  statusId?: number;
}

export interface NewUserRequest {
  /**
   * @minLength 1
   * @maxLength 2
   */
  userType: string;
  /**
   * @minLength 1
   * @maxLength 30
   */
  firstName: string;
  /** @maxLength 20 */
  middleName?: string | null;
  /**
   * @minLength 1
   * @maxLength 50
   */
  lastName: string;
  /** @maxLength 20 */
  suffix?: string | null;
  /** @pattern ^([0-9]( |-)?)?(\(?[0-9]{3}\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4}|[a-zA-Z0-9]{7})$ */
  phone?: string | null;
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  barNumbers?: BarNumber[];
  primaryContact?: boolean;
  billingContact?: boolean;
}

export interface BarNumber {
  /**
   * @minLength 1
   * @maxLength 2
   */
  stateCode: string;
  /**
   * @minLength 1
   * @maxLength 15
   * @pattern ^[a-zA-Z0-9]*$
   */
  number: string;
}

export interface QueuedChangesBatch {
  queuedChanges?: QueuedChange[];
}

export interface UserRequest {
  userIds?: string[];
}

export interface UsersTransferRequest {
  userIds?: string[];
  /** @format guid */
  newOrgId?: string;
}

export interface ListResponseOfOrganizationItem {
  data?: OrganizationItem[];
}

export interface OrganizationItem {
  /** @format guid */
  uniqueId?: string;
  name?: string;
  type?: string;
}

export interface UserInfo {
  /** @format guid */
  id?: string;
  /** @format guid */
  orgId?: string;
  /**
   * @minLength 1
   * @maxLength 30
   * @pattern ^[a-zA-Z\s'-]*$
   */
  firstName: string;
  /**
   * @maxLength 20
   * @pattern ^[a-zA-Z\s'-]*$
   */
  middleName?: string | null;
  /**
   * @minLength 1
   * @maxLength 50
   * @pattern ^[a-zA-Z\s'-]*$
   */
  lastName: string;
  /**
   * @maxLength 20
   * @pattern ^(Sr\.|Jr\.|[a-zA-Z.]+)$
   */
  suffix?: string | null;
  /** @maxLength 2 */
  userType?: string;
  /**
   * @format email
   * @minLength 1
   * @pattern ^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$
   */
  email: string;
  /** @pattern ^([0-9]( |-)?)?(\(?[0-9]{3}\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4}|[a-zA-Z0-9]{7})$ */
  phone?: string | null;
  barNumbers?: BarNumber[];
  loginName?: string | null;
  agentId?: string | null;
}

export interface UserPermissions {
  /** @format guid */
  uniqueId?: string;
  name?: string;
  loginName?: string;
  email?: string;
  adminPermissions?: UserAdminPermissions | null;
  courtPermissions?: UserCourtPermission[] | null;
  judgePermissions?: UserJudgeQueuePermission[] | null;
}

export interface UserAdminPermissions {
  orgAdministrator?: boolean;
  resetPassword?: boolean;
  modifyOrg?: boolean;
  addModifyUser?: boolean;
  removeUser?: boolean;
  addNationalFirmAdmin?: boolean;
}

export interface UserCourtPermission {
  /** @format guid */
  courtUniqueId?: string;
  courtName?: string;
  search?: boolean;
  fileAndServe?: boolean;
  clerkReview?: boolean;
  judicialRouting?: boolean;
  authorizeTransaction?: boolean;
  uploadScannedDocument?: boolean;
}

export interface UserJudgeQueuePermission {
  /** @format int32 */
  judgeId?: number;
  /** @format guid */
  uniqueId?: string;
  judgeName?: string;
}

export interface ListResponseOfUserAccesToSaveFilings {
  data?: UserAccesToSaveFilings[];
}

export interface UserAccesToSaveFilings {
  /** @format int32 */
  id?: number;
  name?: string;
  isOrgAdmin?: boolean;
  /** @format guid */
  uniqueId?: string;
}

export interface ListRequestOfUserAccesToSaveFilings {
  data?: UserAccesToSaveFilings[];
}

export interface NotificationOptions {
  /**
   * @format int32
   * @min 0
   * @max 3
   */
  emailNotificationTypeId?: number;
  forwardingTo?: UserFordwardAccess[];
  forwardingFrom?: UserFordwardAccess[];
  receivingFrom?: UserFordwardAccess[];
  receivingTo?: UserFordwardAccess[];
}

export interface UserFordwardAccess {
  /** @format int32 */
  id?: number;
  name?: string;
  blocked?: boolean;
}

export interface CaseParticipantInfo {
  /** @format guid */
  orgId?: string;
  /** @format int32 */
  caseId?: number;
  caseName?: string | null;
  caseNumber?: string | null;
  /** @format int32 */
  partyId?: number;
  partyName?: string | null;
  /** @format int32 */
  partyTypeId?: number;
  partyType?: string | null;
  /** @format int32 */
  statusId?: number | null;
  status?: string | null;
  representation?: ParticipantRepresentation[];
}

export interface CaseParticipantRepresentation {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  caseId?: number;
  caseName?: string | null;
  caseNumber?: string | null;
  /** @format int32 */
  partyId?: number;
  partyName?: string | null;
  /** @format int32 */
  partyTypeId?: number;
  partyType?: string | null;
  /** @format int32 */
  statusId?: number | null;
  status?: string | null;
  /** @format int32 */
  attorneyId?: number;
  attorneyName?: string | null;
  /** @format int32 */
  attorneyTypeId?: number;
  attorneyType?: string | null;
  /** @format int32 */
  attorneyOrgId?: number;
  attorneyOrg?: string | null;
  /** @format int32 */
  representationStatusId?: number;
}

export interface CaseParticipant2 {
  /** @format int32 */
  courtId?: number;
  /** @format int32 */
  caseId?: number;
  /** @format int32 */
  partyId?: number;
  partyName?: string | null;
  /** @format int32 */
  entityTypeId?: number;
  entityType?: string;
  /** @format int32 */
  partyTypeId?: number;
  partyType?: string | null;
  /** @format int32 */
  statusId?: number | null;
  status?: string | null;
  email?: string | null;
  representation?: RepresentationAttorney[];
  addresses?: Address[];
  phones?: Phone[];
  aliases?: CaseParticipantAlias[];
}

export interface CaseParticipantAlias {
  /** @format int32 */
  id?: number;
  name?: string;
  /** @format int32 */
  typeId?: number;
  type?: string;
  email?: string | null;
  address?: Address | null;
  phone?: Phone | null;
}

export type CaseParticipantUpdateRequest = ParticipantUpdate & {
  /** @format int32 */
  filingId?: number | null;
  documentTitle?: string | null;
  documentRef?: TempDocumentRef | null;
};

export interface ParticipantUpdate {
  /** @format int32 */
  partyTypeId?: number | null;
  /** @format int32 */
  statusId?: number | null;
  representation?: RepresentationAttorney[];
}

export interface CaseParticipantBatchUpdateRequest {
  keys?: CaseParticipantKey[];
  update?: CaseParticipantUpdateRequest | null;
}

export type NewCaseParticipantRequest = NewCaseParticipant & {
  /** @format int32 */
  filingId?: number | null;
  documentTitle?: string | null;
  documentRef?: TempDocumentRef | null;
};

export interface NewCaseParticipant {
  /** @format int32 */
  partyId?: number | null;
  newPartyInfo?: Party2 | null;
  /** @format int32 */
  partyTypeId?: number;
  representation?: RepresentationAttorney[];
}

export interface Party2 {
  /** @format int32 */
  entityTypeId?: number;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string;
  suffix?: string | null;
  address?: Address | null;
  phone?: Phone | null;
}

export interface CaseParticipantBatchAddRequest {
  caseIds?: number[];
  newParticipant?: NewCaseParticipantRequest | null;
}

export interface QueueParticipantInfo {
  /** @format int32 */
  entryId?: number;
  /** @format int32 */
  requestUserId?: number;
  requestUser?: string;
  requestOrganization?: string;
  /** @format date-time */
  dateEntered?: string;
  /** @format int32 */
  status?: number;
  /** @format int32 */
  queueTypeId?: number;
  /** @format int32 */
  caseId?: number | null;
  caseName?: string | null;
  caseNumber?: string | null;
  caseClass?: string | null;
  /** @format guid */
  orgId?: string;
  courtName?: string;
  /** @format int32 */
  partyId?: number;
  partyName?: string;
  /** @format int32 */
  partyEntityTypeId?: number | null;
  partyEntityType?: string | null;
  /** @format int32 */
  originalPartyTypeId?: number | null;
  originalPartyType?: string | null;
  /** @format int32 */
  newPartyTypeId?: number | null;
  /** @format int32 */
  userId?: number;
  userName?: string;
  userOrganization?: string | null;
  /** @format int32 */
  originalParticipantStatusId?: number | null;
  originalParticipantStatus?: string | null;
  /** @format int32 */
  originalParticipantTypeId?: number | null;
  originalParticipantType?: string | null;
  /** @format int32 */
  newParticipantTypeId?: number | null;
  /** @format int32 */
  newParticipantStatusId?: number | null;
  newPartyInfo?: Party2 | null;
}

export interface QueuedParticipant {
  queue?: QueueInfo | null;
  case?: CaseBasicInfo | null;
  petition?: QueuePetition | null;
  participant?: QueuedParticipantParticipantInfo | null;
  update?: QueuedParticipantUpdate | null;
  queuedParty?: Party2 | null;
}

export interface CaseBasicInfo {
  /** @format int32 */
  caseId?: number;
  caseName?: string | null;
  caseNumber?: string | null;
  /** @format guid */
  orgId?: string;
  court?: string | null;
}

export interface QueuedParticipantParticipantInfo {
  /** @format int32 */
  partyId?: number | null;
  partyName?: string | null;
  isPartyAnAlias?: boolean;
  partyAliasType?: string | null;
  /** @format int32 */
  typeId?: number | null;
  type?: string | null;
  /** @format int32 */
  entityTypeId?: number | null;
  entityType?: string | null;
  /** @format int32 */
  statusId?: number | null;
  status?: string | null;
  representation?: RepresentationAttorney[];
}

export type QueuedParticipantUpdate = ParticipantUpdate & {
  representation?: RepresentationAttorneyUpdate[];
};

export type RepresentationAttorneyUpdate = RepresentationAttorney & {
  /** @format int32 */
  oldStatusId?: number | null;
  /** @format int32 */
  oldTypeId?: number | null;
  oldType?: string | null;
};

export interface AddedOrModifiedParticipant {
  entryIds?: number[];
  modifiedParticipant?: ModifiedParticipant | null;
  newCaseParticipant?: NewCaseParticipantRequest | null;
}

export interface ModifiedParticipant {
  /** @format int32 */
  caseId?: number;
  /** @format int32 */
  partyId?: number;
  /** @format int32 */
  partyTypeId?: number;
  key?: CaseParticipantKey;
  update?: CaseParticipantUpdateRequest | null;
}

export interface PartySearchItem {
  /** @format int32 */
  id?: number;
  name?: string | null;
  /** @format int32 */
  entityTypeId?: number;
  entityType?: string | null;
  isAlias?: boolean;
  aliasType?: string | null;
}

export interface PartyDetails {
  /** @format int32 */
  partyId?: number;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  suffix?: string;
  email?: string;
  /** @format int32 */
  status?: number | null;
  /** @format date-time */
  dateOfBirth?: string | null;
  ssn?: string;
  /** @format int32 */
  entityTypeId?: number | null;
  /** @format guid */
  uniqueId?: string;
  addresses?: PartyAddressDto[] | null;
  phoneNumbers?: PartyPhoneNumberDto[] | null;
}

export interface PartyAddressDto {
  /** @format int64 */
  partyAddressId?: number;
  addressType?: string;
  streetLine1?: string;
  streetLine2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  zipCodeExtension?: string;
  isPrivate?: boolean;
}

export interface PartyPhoneNumberDto {
  areaCode?: string;
  countryCode?: string;
  extension?: string;
  phoneNumber?: string;
  phoneType?: string;
}

export interface PaymentMethodResponse {
  /** @format guid */
  paymentMethodId?: string;
  last4?: string;
  cardBrand?: string;
  expiration?: string;
  /** The filer's label for this card, or null when left blank — the picker then shows the expiration (#172646). */
  title?: string | null;
  /**
   * True once past the end of the expiry month. Reported, not filtered out: a submitted filing's
   * summary still has to name the card it was paid with. Only the picker hides them (#172646).
   */
  isExpired?: boolean;
  isDefault?: boolean;
  /** True when shared across the organization (no specific owning user); false when scoped to one user. */
  isFirmLevel?: boolean;
  /** True when the current user created this payment method — only the creator can set-default, change scope, or deactivate. */
  canManage?: boolean;
}

export interface FormTokenResult {
  token?: string;
  iframeUrl?: string;
  /** @format int32 */
  paymentProviderId?: number;
}

export interface ConfirmPaymentMethodRequest {
  providerToken?: string;
}

export interface SetPaymentMethodScopeRequest {
  /**
   * True to make the payment method firm-level (shared across the organization); false to scope
   * it to the current user. The client only ever toggles its own scope — it never has (and
   * doesn't need) another user's internal id — so the controller resolves the actual target
   * user id from the authenticated user.
   */
  isFirmLevel?: boolean;
}

export interface GetTrialBindersResult {
  /** @format guid */
  id?: string;
  system?: string | null;
  caseName?: string | null;
  caseNumber?: string | null;
  courtName?: string | null;
  isBookmarked?: boolean;
}

export interface TrialBinderFolderModel {
  folderType?: TrialBinderFolderType;
  folderName?: string;
  children?: TrialBinderFolderModel[];
  /** @format guid */
  folderId?: string | null;
  /** @format int32 */
  documentCount?: number;
  isSystemFolder?: boolean;
  /** @format int64 */
  totalSize?: number;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  lastModified?: string;
  createdBy?: string | null;
  isArchive?: boolean;
  /** @format int32 */
  folderOrder?: number;
}

export interface TrialBinderCaseDocumentsResponse {
  documents?: TrialBinderCaseDocument[];
  filingTypes?: string[];
}

export interface TrialBinderCaseDocument {
  /** @format int32 */
  documentID?: number;
  documentTitle?: string;
  filingType?: string;
  /** @format int32 */
  filingID?: number;
  partyType?: string;
  partyName?: string;
  attorneyFirm?: string;
  isMyFirm?: boolean;
  isMe?: boolean;
  /** @format date-time */
  authorizedDate?: string;
}

export interface TrialBinderDocumentDto {
  /** @format guid */
  id?: string;
  /** @format guid */
  folderId?: string;
  title?: string;
  transactionId?: string | null;
  fileName?: string;
  partyType?: string | null;
  partyName?: string | null;
  accessType?: string | null;
  documentType?: string | null;
  documentLocation?: string | null;
  /** @format int32 */
  documentSize?: number;
  /** @format date-time */
  dateCreated?: string;
  systemDocumentId?: string | null;
  createdBy?: string | null;
  archivedBy?: string | null;
  /** @format date-time */
  archivedDate?: string | null;
  originalPath?: string | null;
}

export interface TrialBinderAddDocumentResponse {
  feeCharged?: boolean;
  /** @format double */
  feeAmount?: number;
  otherOrganization?: boolean;
  /** @format double */
  otherOrganizationAmount?: number;
}

export interface TrialBinderAddDocumentRequest {
  items?: TrialBinderAddDocumentRequestItem[];
  billingReference?: string | null;
  overrideFeeCheck?: boolean;
}

export interface TrialBinderAddDocumentRequestItem {
  /** @format int32 */
  documentId?: number;
  partyType?: string;
  partyName?: string;
}

export interface MoveDocumentModel {
  /** @format guid */
  fromFolderId?: string;
  /** @format guid */
  toFolderId?: string | null;
  documentIds?: string[];
}

export interface NewFolderModel {
  /** @format guid */
  parentId?: string | null;
  folderName?: string;
}

export interface FilingDetails {
  /** @format int64 */
  filingId?: number;
  caseNumber?: string | null;
  caseName?: string | null;
  courtName?: string | null;
  division?: string | null;
  /** @format date-time */
  authorizedDate?: string | null;
  authorizor?: string | null;
  authorizerOrganization?: string | null;
  sender?: string | null;
  senderOrganization?: string | null;
  caseClass?: string | null;
  caseType?: string | null;
  filingOption?: string | null;
  billingReference?: string | null;
  documents?: FilingDetailDocument[];
  sendingParties?: FilingDetailParty[];
  serviceRecipients?: ServiceRecipient[];
  additionalRecipients?: AdditionalRecipient[];
}

export interface FilingDetailDocument {
  leadDocument?: boolean;
  /** @format int32 */
  numberOfPages?: number | null;
  /** @format int64 */
  documentId?: number;
  documentType?: string | null;
  documentSecurity?: string | null;
  /** @format decimal */
  statutoryFee?: number;
  documentTitle?: string | null;
  clerkReviewStatus?: string | null;
  /** @format date-time */
  reviewDate?: string | null;
}

export interface FilingDetailParty {
  partyName?: string | null;
  partyType?: string | null;
  attorneyName?: string | null;
  attorneyType?: string | null;
  firmName?: string | null;
}

export interface ServiceRecipient {
  party?: FilingDetailParty;
  deliveryStatus?: string | null;
  deliveryMethod?: string | null;
  deliveryType?: string | null;
}

export interface AdditionalRecipient {
  deliveryName?: string | null;
  deliveryAddress?: string | null;
}

export interface SearchDocumentResult {
  parentFolder?: string;
  /** @format guid */
  documentId?: string;
  /** @format guid */
  folderId?: string;
  documentTitle?: string;
  documentType?: string;
  fileName?: string;
  systemDocumentId?: string;
  transactionId?: string;
}

export interface UserPermissionList {
  canAccessClerkReview?: boolean;
  canAccessJudgeReview?: boolean;
  canModifyOrganization?: boolean;
  /**
   * The user's court has Court.EnableJudgeChambers set, so judge review opens the
   * judge chambers queue and non-judge users need active chamber membership.
   */
  isJudgeChambersEnabled?: boolean;
  /** Court users need Search on a court in their courthouse that has an active message board; other users always have it. */
  canAccessMessageBoard?: boolean;
}

export interface ListResponseOfVendorIntegrationConfigDetail {
  data?: VendorIntegrationConfigDetail[];
}

export interface VendorIntegrationConfigDetail {
  /** @format guid */
  vendorIntegrationId?: string;
  vendorName?: string;
  enabled?: boolean;
  domainRequired?: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  adaptorId?: number;
  firmConfig?: VendorIntegrationFirmConfigDetail;
  firmCourts?: VendorIntegrationFirmCourtDetail[];
}

export interface VendorIntegrationFirmConfigDetail {
  /** @format int32 */
  organizationId?: number;
  enabled?: boolean;
  domain?: string | null;
}

export interface VendorIntegrationFirmCourtDetail {
  /** @format int32 */
  organizationId?: number;
  /** @format guid */
  courtId?: string;
  courtName?: string | null;
  enabled?: boolean;
}

export interface UpdateVendorIntegrationFirm {
  enabled?: boolean;
  domain?: string;
}

export type Case2 = CosmosModelBase & {
  courtId?: string;
  /** @format int64 */
  jcmsCourtId?: number;
  bigCase?: boolean;
  cmsCaseId?: string | null;
  /** @format int64 */
  efspCaseId?: number | null;
  initiatingTransactionId?: string;
  /** @format date-time */
  updatedAtUtc?: string | null;
  title?: string;
  number?: string;
  currentStatus?: CaseSecurity | null;
  class?: string;
  /** @format int32 */
  jcmsCaseClassId?: number | null;
  classCmsCode?: string;
  caseTypeCmsCode?: string | null;
  judge?: string | null;
  /** @format date-time */
  fileDate?: string | null;
  statuses?: StatusRecord[] | null;
  officials?: Official[] | null;
  participants?: Party3[] | null;
  additionalData?: CaseAdditionalDataRecord | null;
};

export interface StatusRecord {
  statusType?: string;
  /** @format date-time */
  date?: string | null;
  comment?: string;
  isCurrent?: boolean;
  makesCaseActive?: boolean;
}

export type Official = PartyAndAttorneyBase & {
  userType?: ConnexPersonType;
  counselTypeCmsCode?: string | null;
  representativeOf?: RepresentedRecord[] | null;
};

export interface RepresentedRecord {
  /** @format int32 */
  fsxId?: number | null;
  name?: NameRecord | null;
  contact?: ContactRecord | null;
  cmsId?: string | null;
  repTypeCmsCode?: string | null;
  status?: RepresentationStatus;
}

export interface NameRecord {
  prefix?: string | null;
  given?: string | null;
  middle?: string | null;
  sur?: string | null;
  suffix?: string | null;
  business?: string | null;
}

export interface ContactRecord {
  mailingAddress?: AddressRecord[] | null;
  telephone?: TelephoneRecord[] | null;
  email?: string[] | null;
}

export interface AddressRecord {
  streetFull?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  fsxAddressType?: AddressType2;
  primary?: boolean | null;
  streetLines?: string[] | null;
}

export type AddressType2 = EnumStringOfAddressType & object;

export type EnumStringOfAddressType = EnumString & object;

export interface EnumString {
  string?: string;
}

export interface TelephoneRecord {
  type?: string;
  number?: string;
}

export interface PartyAndAttorneyBase {
  isOrganization?: boolean;
  userType?: ConnexPersonType;
  cmsId?: string | null;
  globalCmsId?: string | null;
  /** @format int32 */
  fsxId?: number | null;
  typeCmsCode?: string | null;
  name?: NameRecord | null;
  alias?: AliasRecord[] | null;
  active?: boolean;
  syncedWithCms?: boolean;
  /** @format int32 */
  sentIdx?: number | null;
  contact?: ContactRecord | null;
  barInformation?: BarInformationRecord | null;
  otherCmsIdentifiers?: Record<string, string[]> | null;
}

export interface AliasRecord {
  name?: NameRecord;
  cmsCode?: string;
  cmsTypeCode?: string;
}

export interface BarInformationRecord {
  barNumber?: string;
  state?: string;
}

export type Party3 = PartyAndAttorneyBase & {
  userType?: ConnexPersonType;
  proSe?: boolean | null;
  dateOfBirth?: string | null;
  ssn?: string | null;
  charges?: ChargeRecord[] | null;
};

export interface ChargeRecord {
  chargeId?: string;
  /** @format date-time */
  offenseDate?: string | null;
}

export interface CaseAdditionalDataRecord {
  CaseValues?: AdditionalFieldValue[];
  SpecialStatusCodes?: string[];
  CaseLists?: Record<string, CapturedListItem[]>;
}

export interface AdditionalFieldValue {
  Key: string;
  Value?: string | null;
  Label?: string | null;
  DisplayValue?: string | null;
}

export interface CapturedListItem {
  Value: string;
  Label?: string | null;
}

export interface CosmosModelBase {
  wrapper?: string | null;
  pk?: string;
  id?: string;
}

export type ConnexFiling = ConnexFilingBase & {
  multiCase?: boolean;
  isOpf?: boolean;
  preStampOpf?: boolean;
  createdExternally?: boolean;
  docketable?: boolean;
  paymentDeferred?: boolean;
  courtFeeWaiverReason?: string | null;
  /** @format int64 */
  judgementEventId?: number | null;
  submitters?: Person[];
  invoice?: Invoice;
  offense?: OffenseRecord | null;
  filerNote?: string | null;
};

export interface Person {
  fsxId?: string;
  cmsCode?: string | null;
  name?: NameRecord;
  contact?: ContactRecord | null;
}

export type Invoice = InvoiceItem[];

export interface InvoiceItem {
  name?: string;
  categoryCmsCode?: string;
  typeCmsCode?: string;
  amount?: Amount;
  /** @format int32 */
  units?: number;
  /** @format decimal */
  adjustedAmount?: number;
}

export interface Amount {
  /** @format decimal */
  value?: number;
  currency?: string;
}

export interface OffenseRecord {
  charge?: string | null;
  degree?: string | null;
}

export type ConnexFilingBase = CosmosModelBase & {
  /** @format int32 */
  step?: number;
  state?: ConnexFilingState;
  courtId?: string;
  transactionId?: string;
  connexCaseId?: string | null;
  caseNumber?: string | null;
  /** @format date-time */
  reviewTimestamp?: string | null;
  efspData?: ClientDataRecord | null;
  cmsFilingIds?: string[];
  case?: ConnexFilingCase;
  attachments?: Attachment[];
  authorizers?: Person[];
  senders?: Person[];
};

export type ConnexFilingState = EnumStringOfConnexFilingState & object;

export type EnumStringOfConnexFilingState = EnumString & object;

export interface ClientDataRecord {
  /** @format int32 */
  caseId?: number;
  /** @format int32 */
  filingId?: number;
  /** @format int32 */
  courtId?: number | null;
  /** @format int32 */
  version?: number | null;
}

export interface ConnexFilingCase {
  title?: string;
  category?: CaseCategory;
  cmsCode?: string;
  classCmsCode?: string | null;
  additionalFieldValues?: AdditionalFieldValue[] | null;
  officials?: Official[] | null;
  participants?: Party3[] | null;
  security?: CaseSecurity | null;
}

export interface Attachment {
  cmsCode?: string;
  title?: string;
  /** @format date-time */
  reviewDate?: string | null;
  judgementTypeEvent?: string | null;
  comments?: string | null;
  eventStatus?: string | null;
  accessType?: AccessType | null;
  reviewStatus?: string | null;
  efspId?: string | null;
  media?: MediaRecord | null;
  cmsData?: CmsDataRecord | null;
  additionalFieldValues?: AdditionalFieldValue[] | null;
  attachments?: Attachment[] | null;
  /** @format date-time */
  serviceDate?: string | null;
  fsxTypeDescription?: string | null;
  accepted?: boolean;
}

export interface MediaRecord {
  docStoreInfo?: DocStoreRecord;
  contentType?: string;
  /** @format int32 */
  pageCount?: number;
  /** @format int64 */
  sizeInBytes?: number;
  temporaryUri?: string | null;
}

export interface DocStoreRecord {
  /** @format guid */
  collectionId?: string;
  /** @format guid */
  documentId?: string;
}

export interface CmsDataRecord {
  cmsId?: string;
  cmsFilingId?: string;
  versionId?: string | null;
}

export type Artifact = CosmosModelBase & {
  courtId?: string;
  connexCaseId?: string;
  artifactId?: string;
  /** @format date-time */
  updatedAtUTC?: string;
  cmsDocumentId?: string;
  securityType?: string | null;
  versionNumber?: string;
  documentType?: string | null;
  eventType?: string | null;
  name?: string;
  clientDocumentId?: string | null;
};
